import _possibleConstructorReturn from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _toConsumableArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _get from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _createForOfIteratorHelper from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var ch2 = {};

var wk = function wk(c, id, msg, transfer, cb) {
  var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'], {
    type: 'text/javascript'
  }))));

  w.onmessage = function (e) {
    var d = e.data,
        ed = d.$e$;

    if (ed) {
      var err = new Error(ed[0]);
      err['code'] = ed[1];
      err.stack = ed[2];
      cb(err, null);
    } else cb(null, d);
  };

  w.postMessage(msg, transfer);
  return w;
}; // aliases for shorter compressed code (most minifers don't do this)


var u8 = Uint8Array,
    u16 = Uint16Array,
    i32 = Int32Array; // fixed length extra bits

var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0,
/* unused */
0, 0,
/* impossible */
0]); // fixed distance extra bits

var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13,
/* unused */
0, 0]); // code length index map

var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]); // get base, reverse index map from extra bits

var freb = function freb(eb, start) {
  var b = new u16(31);

  for (var i = 0; i < 31; ++i) {
    b[i] = start += 1 << eb[i - 1];
  } // numbers here are at max 18 bits


  var r = new i32(b[30]);

  for (var i = 1; i < 30; ++i) {
    for (var j = b[i]; j < b[i + 1]; ++j) {
      r[j] = j - b[i] << 5 | i;
    }
  }

  return {
    b: b,
    r: r
  };
};

var _a = freb(fleb, 2),
    fl = _a.b,
    revfl = _a.r; // we can ignore the fact that the other numbers are wrong; they never happen anyway


fl[28] = 258, revfl[258] = 28;

var _b = freb(fdeb, 0),
    revfd = _b.r; // map of value to reverse (assuming 16 bits)


var rev = new u16(32768);

for (var i = 0; i < 32768; ++i) {
  // reverse table algorithm from SO
  var x$1 = (i & 0xAAAA) >> 1 | (i & 0x5555) << 1;
  x$1 = (x$1 & 0xCCCC) >> 2 | (x$1 & 0x3333) << 2;
  x$1 = (x$1 & 0xF0F0) >> 4 | (x$1 & 0x0F0F) << 4;
  rev[i] = ((x$1 & 0xFF00) >> 8 | (x$1 & 0x00FF) << 8) >> 1;
} // create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?


var hMap = function hMap(cd, mb, r) {
  var s = cd.length; // index

  var i = 0; // u16 "map": index -> # of codes with bit length = index

  var l = new u16(mb); // length of cd must be 288 (total # of codes)

  for (; i < s; ++i) {
    if (cd[i]) ++l[cd[i] - 1];
  } // u16 "map": index -> minimum code for bit length = index


  var le = new u16(mb);

  for (i = 1; i < mb; ++i) {
    le[i] = le[i - 1] + l[i - 1] << 1;
  }

  var co;

  if (r) {
    // u16 "map": index -> number of actual bits, symbol for code
    co = new u16(1 << mb); // bits to remove for reverser

    var rvb = 15 - mb;

    for (i = 0; i < s; ++i) {
      // ignore 0 lengths
      if (cd[i]) {
        // num encoding both symbol and bits read
        var sv = i << 4 | cd[i]; // free bits

        var r_1 = mb - cd[i]; // start value

        var v = le[cd[i] - 1]++ << r_1; // m is end value

        for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
          // every 16 bit value starting with the code yields the same result
          co[rev[v] >> rvb] = sv;
        }
      }
    }
  } else {
    co = new u16(s);

    for (i = 0; i < s; ++i) {
      if (cd[i]) {
        co[i] = rev[le[cd[i] - 1]++] >> 15 - cd[i];
      }
    }
  }

  return co;
}; // fixed length tree


var flt = new u8(288);

for (var i = 0; i < 144; ++i) flt[i] = 8;

for (var i = 144; i < 256; ++i) flt[i] = 9;

for (var i = 256; i < 280; ++i) flt[i] = 7;

for (var i = 280; i < 288; ++i) flt[i] = 8; // fixed distance tree


var fdt = new u8(32);

for (var i = 0; i < 32; ++i) fdt[i] = 5; // fixed length map


var flm = /*#__PURE__*/hMap(flt, 9, 0); // fixed distance map

var fdm = /*#__PURE__*/hMap(fdt, 5, 0); // get end of byte

var shft = function shft(p) {
  return (p + 7) / 8 | 0;
}; // typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice


var slc = function slc(v, s, e) {
  if (s == null || s < 0) s = 0;
  if (e == null || e > v.length) e = v.length; // can't use .constructor in case user-supplied

  return new u8(v.subarray(s, e));
}; // error codes


var ec = ['unexpected EOF', 'invalid block type', 'invalid length/literal', 'invalid distance', 'stream finished', 'no stream handler',, 'no callback', 'invalid UTF-8 data', 'extra field too long', 'date not in range 1980-2099', 'filename too long', 'stream finishing', 'invalid zip data' // determined by unknown compression method
];

var err = function err(ind, msg, nt) {
  var e = new Error(msg || ec[ind]);
  e.code = ind;
  if (Error.captureStackTrace) Error.captureStackTrace(e, err);
  if (!nt) throw e;
  return e;
}; // starting at p, write the minimum number of bits that can hold v to d


var wbits = function wbits(d, p, v) {
  v <<= p & 7;
  var o = p / 8 | 0;
  d[o] |= v;
  d[o + 1] |= v >> 8;
}; // starting at p, write the minimum number of bits (>8) that can hold v to d


var wbits16 = function wbits16(d, p, v) {
  v <<= p & 7;
  var o = p / 8 | 0;
  d[o] |= v;
  d[o + 1] |= v >> 8;
  d[o + 2] |= v >> 16;
}; // creates code lengths from a frequency table


var hTree = function hTree(d, mb) {
  // Need extra info to make a tree
  var t = [];

  for (var i = 0; i < d.length; ++i) {
    if (d[i]) t.push({
      s: i,
      f: d[i]
    });
  }

  var s = t.length;
  var t2 = t.slice();
  if (!s) return {
    t: et,
    l: 0
  };

  if (s == 1) {
    var v = new u8(t[0].s + 1);
    v[t[0].s] = 1;
    return {
      t: v,
      l: 1
    };
  }

  t.sort(function (a, b) {
    return a.f - b.f;
  }); // after i2 reaches last ind, will be stopped
  // freq must be greater than largest possible number of symbols

  t.push({
    s: -1,
    f: 25001
  });
  var l = t[0],
      r = t[1],
      i0 = 0,
      i1 = 1,
      i2 = 2;
  t[0] = {
    s: -1,
    f: l.f + r.f,
    l: l,
    r: r
  }; // efficient algorithm from UZIP.js
  // i0 is lookbehind, i2 is lookahead - after processing two low-freq
  // symbols that combined have high freq, will start processing i2 (high-freq,
  // non-composite) symbols instead
  // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/

  while (i1 != s - 1) {
    l = t[t[i0].f < t[i2].f ? i0++ : i2++];
    r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
    t[i1++] = {
      s: -1,
      f: l.f + r.f,
      l: l,
      r: r
    };
  }

  var maxSym = t2[0].s;

  for (var i = 1; i < s; ++i) {
    if (t2[i].s > maxSym) maxSym = t2[i].s;
  } // code lengths


  var tr = new u16(maxSym + 1); // max bits in tree

  var mbt = ln(t[i1 - 1], tr, 0);

  if (mbt > mb) {
    // more algorithms from UZIP.js
    // TODO: find out how this code works (debt)
    //  ind    debt
    var i = 0,
        dt = 0; //    left            cost

    var lft = mbt - mb,
        cst = 1 << lft;
    t2.sort(function (a, b) {
      return tr[b.s] - tr[a.s] || a.f - b.f;
    });

    for (; i < s; ++i) {
      var i2_1 = t2[i].s;

      if (tr[i2_1] > mb) {
        dt += cst - (1 << mbt - tr[i2_1]);
        tr[i2_1] = mb;
      } else break;
    }

    dt >>= lft;

    while (dt > 0) {
      var i2_2 = t2[i].s;
      if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;else ++i;
    }

    for (; i >= 0 && dt; --i) {
      var i2_3 = t2[i].s;

      if (tr[i2_3] == mb) {
        --tr[i2_3];
        ++dt;
      }
    }

    mbt = mb;
  }

  return {
    t: new u8(tr),
    l: mbt
  };
}; // get the max length and assign length codes


var ln = function ln(n, l, d) {
  return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
}; // length codes generation


var lc = function lc(c) {
  var s = c.length; // Note that the semicolon was intentional

  while (s && !c[--s]);

  var cl = new u16(++s); //  ind      num         streak

  var cli = 0,
      cln = c[0],
      cls = 1;

  var w = function w(v) {
    cl[cli++] = v;
  };

  for (var i = 1; i <= s; ++i) {
    if (c[i] == cln && i != s) ++cls;else {
      if (!cln && cls > 2) {
        for (; cls > 138; cls -= 138) w(32754);

        if (cls > 2) {
          w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
          cls = 0;
        }
      } else if (cls > 3) {
        w(cln), --cls;

        for (; cls > 6; cls -= 6) w(8304);

        if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
      }

      while (cls--) w(cln);

      cls = 1;
      cln = c[i];
    }
  }

  return {
    c: cl.subarray(0, cli),
    n: s
  };
}; // calculate the length of output from tree, code lengths


var clen = function clen(cf, cl) {
  var l = 0;

  for (var i = 0; i < cl.length; ++i) l += cf[i] * cl[i];

  return l;
}; // writes a fixed block
// returns the new bit pos


var wfblk = function wfblk(out, pos, dat) {
  // no need to write 00 as type: TypedArray defaults to 0
  var s = dat.length;
  var o = shft(pos + 2);
  out[o] = s & 255;
  out[o + 1] = s >> 8;
  out[o + 2] = out[o] ^ 255;
  out[o + 3] = out[o + 1] ^ 255;

  for (var i = 0; i < s; ++i) out[o + i + 4] = dat[i];

  return (o + 4 + s) * 8;
}; // writes a block


var wblk = function wblk(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
  wbits(out, p++, final);
  ++lf[256];

  var _a = hTree(lf, 15),
      dlt = _a.t,
      mlb = _a.l;

  var _b = hTree(df, 15),
      ddt = _b.t,
      mdb = _b.l;

  var _c = lc(dlt),
      lclt = _c.c,
      nlc = _c.n;

  var _d = lc(ddt),
      lcdt = _d.c,
      ndc = _d.n;

  var lcfreq = new u16(19);

  for (var i = 0; i < lclt.length; ++i) ++lcfreq[lclt[i] & 31];

  for (var i = 0; i < lcdt.length; ++i) ++lcfreq[lcdt[i] & 31];

  var _e = hTree(lcfreq, 7),
      lct = _e.t,
      mlcb = _e.l;

  var nlcc = 19;

  for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc);

  var flen = bl + 5 << 3;
  var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
  var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
  if (bs >= 0 && flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
  var lm, ll, dm, dl;
  wbits(out, p, 1 + (dtlen < ftlen)), p += 2;

  if (dtlen < ftlen) {
    lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
    var llm = hMap(lct, mlcb, 0);
    wbits(out, p, nlc - 257);
    wbits(out, p + 5, ndc - 1);
    wbits(out, p + 10, nlcc - 4);
    p += 14;

    for (var i = 0; i < nlcc; ++i) wbits(out, p + 3 * i, lct[clim[i]]);

    p += 3 * nlcc;
    var lcts = [lclt, lcdt];

    for (var it = 0; it < 2; ++it) {
      var clct = lcts[it];

      for (var i = 0; i < clct.length; ++i) {
        var len = clct[i] & 31;
        wbits(out, p, llm[len]), p += lct[len];
        if (len > 15) wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
      }
    }
  } else {
    lm = flm, ll = flt, dm = fdm, dl = fdt;
  }

  for (var i = 0; i < li; ++i) {
    var sym = syms[i];

    if (sym > 255) {
      var len = sym >> 18 & 31;
      wbits16(out, p, lm[len + 257]), p += ll[len + 257];
      if (len > 7) wbits(out, p, sym >> 23 & 31), p += fleb[len];
      var dst = sym & 31;
      wbits16(out, p, dm[dst]), p += dl[dst];
      if (dst > 3) wbits16(out, p, sym >> 5 & 8191), p += fdeb[dst];
    } else {
      wbits16(out, p, lm[sym]), p += ll[sym];
    }
  }

  wbits16(out, p, lm[256]);
  return p + ll[256];
}; // deflate options (nice << 13) | chain


var deo = /*#__PURE__*/new i32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]); // empty

var et = /*#__PURE__*/new u8(0); // compresses data into a raw DEFLATE buffer

var dflt = function dflt(dat, lvl, plvl, pre, post, st) {
  var s = st.z || dat.length;
  var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post); // writing to this writes to the output buffer

  var w = o.subarray(pre, o.length - post);
  var lst = st.l;
  var pos = (st.r || 0) & 7;

  if (lvl) {
    if (pos) w[0] = st.r >> 3;
    var opt = deo[lvl - 1];
    var n = opt >> 13,
        c = opt & 8191;
    var msk_1 = (1 << plvl) - 1; //    prev 2-byte val map    curr 2-byte val map

    var prev = st.p || new u16(32768),
        head = st.h || new u16(msk_1 + 1);
    var bs1_1 = Math.ceil(plvl / 3),
        bs2_1 = 2 * bs1_1;

    var hsh = function hsh(i) {
      return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
    }; // 24576 is an arbitrary number of maximum symbols per block
    // 424 buffer for last block


    var syms = new i32(25000); // length/literal freq   distance freq

    var lf = new u16(288),
        df = new u16(32); //  l/lcnt  exbits  index          l/lind  waitdx          blkpos

    var lc_1 = 0,
        eb = 0,
        i = st.i || 0,
        li = 0,
        wi = st.w || 0,
        bs = 0;

    for (; i + 2 < s; ++i) {
      // hash value
      var hv = hsh(i); // index mod 32768    previous index mod

      var imod = i & 32767,
          pimod = head[hv];
      prev[imod] = pimod;
      head[hv] = imod; // We always should modify head and prev, but only add symbols if
      // this data is not yet processed ("wait" for wait index)

      if (wi <= i) {
        // bytes remaining
        var rem = s - i;

        if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
          pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
          li = lc_1 = eb = 0, bs = i;

          for (var j = 0; j < 286; ++j) lf[j] = 0;

          for (var j = 0; j < 30; ++j) df[j] = 0;
        } //  len    dist   chain


        var l = 2,
            d = 0,
            ch_1 = c,
            dif = imod - pimod & 32767;

        if (rem > 2 && hv == hsh(i - dif)) {
          var maxn = Math.min(n, rem) - 1;
          var maxd = Math.min(32767, i); // max possible length
          // not capped at dif because decompressors implement "rolling" index population

          var ml = Math.min(258, rem);

          while (dif <= maxd && --ch_1 && imod != pimod) {
            if (dat[i + l] == dat[i + l - dif]) {
              var nl = 0;

              for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);

              if (nl > l) {
                l = nl, d = dif; // break out early when we reach "nice" (we are satisfied enough)

                if (nl > maxn) break; // now, find the rarest 2-byte sequence within this
                // length of literals and search for that instead.
                // Much faster than just using the start

                var mmd = Math.min(dif, nl - 2);
                var md = 0;

                for (var j = 0; j < mmd; ++j) {
                  var ti = i - dif + j & 32767;
                  var pti = prev[ti];
                  var cd = ti - pti & 32767;
                  if (cd > md) md = cd, pimod = ti;
                }
              }
            } // check the previous match


            imod = pimod, pimod = prev[imod];
            dif += imod - pimod & 32767;
          }
        } // d will be nonzero only when a match was found


        if (d) {
          // store both dist and len data in one int32
          // Make sure this is recognized as a len/dist with 28th bit (2^28)
          syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
          var lin = revfl[l] & 31,
              din = revfd[d] & 31;
          eb += fleb[lin] + fdeb[din];
          ++lf[257 + lin];
          ++df[din];
          wi = i + l;
          ++lc_1;
        } else {
          syms[li++] = dat[i];
          ++lf[dat[i]];
        }
      }
    }

    for (i = Math.max(i, wi); i < s; ++i) {
      syms[li++] = dat[i];
      ++lf[dat[i]];
    }

    pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);

    if (!lst) {
      st.r = pos & 7 | w[pos / 8 | 0] << 3; // shft(pos) now 1 less if pos & 7 != 0

      pos -= 7;
      st.h = head, st.p = prev, st.i = i, st.w = wi;
    }
  } else {
    for (var i = st.w || 0; i < s + lst; i += 65535) {
      // end
      var e = i + 65535;

      if (e >= s) {
        // write final block
        w[pos / 8 | 0] = lst;
        e = s;
      }

      pos = wfblk(w, pos + 1, dat.subarray(i, e));
    }

    st.i = s;
  }

  return slc(o, 0, pre + shft(pos) + post);
}; // CRC32 table


var crct = /*#__PURE__*/function () {
  var t = new Int32Array(256);

  for (var i = 0; i < 256; ++i) {
    var c = i,
        k = 9;

    while (--k) c = (c & 1 && -306674912) ^ c >>> 1;

    t[i] = c;
  }

  return t;
}(); // CRC32


var crc = function crc() {
  var c = -1;
  return {
    p: function p(d) {
      // closures have awful performance
      var cr = c;

      for (var i = 0; i < d.length; ++i) cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;

      c = cr;
    },
    d: function d() {
      return ~c;
    }
  };
}; // deflate with opts


var dopt = function dopt(dat, opt, pre, post, st) {
  if (!st) {
    st = {
      l: 1
    };

    if (opt.dictionary) {
      var dict = opt.dictionary.subarray(-32768);
      var newDat = new u8(dict.length + dat.length);
      newDat.set(dict);
      newDat.set(dat, dict.length);
      dat = newDat;
      st.w = dict.length;
    }
  }

  return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
}; // Walmart object spread


var mrg = function mrg(a, b) {
  var o = {};

  for (var k in a) o[k] = a[k];

  for (var k in b) o[k] = b[k];

  return o;
}; // worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.


var wcln = function wcln(fn, fnStr, td) {
  var dt = fn();
  var st = fn.toString();
  var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');

  for (var i = 0; i < dt.length; ++i) {
    var v = dt[i],
        k = ks[i];

    if (typeof v == 'function') {
      fnStr += ';' + k + '=';
      var st_1 = v.toString();

      if (v.prototype) {
        // for global objects
        if (st_1.indexOf('[native code]') != -1) {
          var spInd = st_1.indexOf(' ', 8) + 1;
          fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
        } else {
          fnStr += st_1;

          for (var t in v.prototype) fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
        }
      } else fnStr += st_1;
    } else td[k] = v;
  }

  return fnStr;
};

var ch = []; // clone bufs

var cbfs = function cbfs(v) {
  var tl = [];

  for (var k in v) {
    if (v[k].buffer) {
      tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    }
  }

  return tl;
}; // use a worker to execute code


var wrkr = function wrkr(fns, init, id, cb) {
  if (!ch[id]) {
    var fnStr = '',
        td_1 = {},
        m = fns.length - 1;

    for (var i = 0; i < m; ++i) fnStr = wcln(fns[i], fnStr, td_1);

    ch[id] = {
      c: wcln(fns[m], fnStr, td_1),
      e: td_1
    };
  }

  var td = mrg({}, ch[id].e);
  return wk(ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};

var bDflt = function bDflt() {
  return [u8, u16, i32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf];
}; // gzip extra


var gze = function gze() {
  return [gzh, gzhl, wbytes, crc, crct];
}; // post buf


var pbf = function pbf(msg) {
  return postMessage(msg, [msg.buffer]);
}; // async helper


var cbify = function cbify(dat, opts, fns, init, id, cb) {
  var w = wrkr(fns, init, id, function (err, dat) {
    w.terminate();
    cb(err, dat);
  });
  w.postMessage([dat, opts], opts.consume ? [dat.buffer] : []);
  return function () {
    w.terminate();
  };
}; // write bytes


var wbytes = function wbytes(d, b, v) {
  for (; v; ++b) d[b] = v, v >>>= 8;
}; // gzip header


var gzh = function gzh(c, o) {
  var fn = o.filename;
  c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix

  if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));

  if (fn) {
    c[3] = 8;

    for (var i = 0; i <= fn.length; ++i) c[i + 10] = fn.charCodeAt(i);
  }
}; // gzip header length


var gzhl = function gzhl(o) {
  return 10 + (o.filename ? o.filename.length + 1 : 0);
};
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */


function deflateSync(data, opts) {
  return dopt(data, opts || {}, 0, 0);
}

function gzip(data, opts, cb) {
  if (!cb) cb = opts, opts = {};
  if (typeof cb != 'function') err(7);
  return cbify(data, opts, [bDflt, gze, function () {
    return [gzipSync];
  }], function (ev) {
    return pbf(gzipSync(ev.data[0], ev.data[1]));
  }, 2, cb);
}
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */


function gzipSync(data, opts) {
  if (!opts) opts = {};
  var c = crc(),
      l = data.length;
  c.p(data);
  var d = dopt(data, opts, gzhl(opts), 8),
      s = d.length;
  return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
} // text decoder


var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/new TextDecoder(); // text decoder stream

var tds = 0;

try {
  td.decode(et, {
    stream: true
  });
  tds = 1;
} catch (e) {}

var StringDictionary = /*#__PURE__*/_createClass(function StringDictionary(getPageNo) {
  var _this = this;

  _classCallCheck(this, StringDictionary);

  this.getPageNo = getPageNo;
  this.idx = 1;
  /** backwards dictionary of
   * [repeated str:key]
   * */

  this.backDict = {};

  this.getKey = function (str) {
    var isNew = false;

    if (!_this.backDict[str]) {
      var _this$getPageNo;

      isNew = true;
      _this.backDict[str] = "".concat((_this$getPageNo = _this.getPageNo()) !== null && _this$getPageNo !== void 0 ? _this$getPageNo : 0, "_").concat(_this.idx);
      _this.idx += 1;
    }

    return [_this.backDict[str], isNew];
  };
});

var AttributeSender = /*#__PURE__*/function () {
  function AttributeSender(options) {
    var _this2 = this;

    _classCallCheck(this, AttributeSender);

    this.sendSetAttribute = function (id, name, value) {
      if (_this2.isDictDisabled) {
        var msg = [12
        /* Type.SetNodeAttribute */
        , id, name, value];
        return _this2.app.send(msg);
      } else {
        var message = [52
        /* Type.SetNodeAttributeDict */
        , id, _this2.applyDict(name), _this2.applyDict(value)];
        return _this2.app.send(message);
      }
    };

    this.app = options.app;
    this.isDictDisabled = options.isDictDisabled;
    this.dict = new StringDictionary(this.app.session.getPageNumber);
  }

  _createClass(AttributeSender, [{
    key: "applyDict",
    value: function applyDict(str) {
      var _this$dict$getKey = this.dict.getKey(str),
          _this$dict$getKey2 = _slicedToArray(_this$dict$getKey, 2),
          key = _this$dict$getKey2[0],
          isNew = _this$dict$getKey2[1];

      if (isNew) {
        this.app.send([43
        /* Type.StringDict */
        , key, str]);
      }

      return key;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.dict = new StringDictionary(this.app.session.getPageNumber);
    }
  }]);

  return AttributeSender;
}();

var ConditionsManager = /*#__PURE__*/function () {
  function ConditionsManager(app, startParams) {
    _classCallCheck(this, ConditionsManager);

    this.app = app;
    this.startParams = startParams;
    this.conditions = [];
    this.hasStarted = false;

    this.createConditionFromFilter = function (filter) {
      if (filter.value.length) {
        var resultCondition = mapCondition(filter);

        if (resultCondition.type) {
          return resultCondition;
        }
      }

      return undefined;
    };

    this.durationInt = null;
  }

  _createClass(ConditionsManager, [{
    key: "setConditions",
    value: function setConditions(conditions) {
      this.conditions = conditions;
    }
  }, {
    key: "fetchConditions",
    value: function () {
      var _fetchConditions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, token) {
        var _this3 = this;

        var r, _yield$r$json2, conditions, mappedConditions;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("".concat(this.app.options.ingestPoint, "/v1/web/conditions/").concat(projectId), {
                method: 'GET',
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              });

            case 3:
              r = _context.sent;
              _context.next = 6;
              return r.json();

            case 6:
              _yield$r$json2 = _context.sent;
              conditions = _yield$r$json2.conditions;
              mappedConditions = [];
              conditions.forEach(function (c) {
                var filters = c.filters;
                filters.forEach(function (filter) {
                  var cond;

                  if (filter.type === 'fetch') {
                    cond = {
                      type: 'network_request',
                      subConditions: [],
                      name: c.name
                    };
                    filter.filters.forEach(function (f) {
                      var subCond = _this3.createConditionFromFilter(f);

                      if (subCond) {
                        ;
                        cond.subConditions.push(subCond);
                      }
                    });
                  } else {
                    cond = _this3.createConditionFromFilter(filter);
                  }

                  if (cond) {
                    if (cond.type === 'session_duration') {
                      _this3.processDuration(cond.value[0], c.name);
                    }

                    mappedConditions.push(_objectSpread(_objectSpread({}, cond), {}, {
                      name: c.name
                    }));
                  }
                });
              });
              this.conditions = mappedConditions;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              this.app.debug.error('Critical: cannot fetch start conditions');

            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 13]]);
      }));

      function fetchConditions(_x, _x2) {
        return _fetchConditions.apply(this, arguments);
      }

      return fetchConditions;
    }()
  }, {
    key: "trigger",
    value: function trigger(conditionName) {
      if (this.hasStarted) return;

      try {
        this.hasStarted = true;
        void this.app.start(this.startParams, undefined, conditionName);
      } catch (e) {
        this.app.debug.error(e);
      }
    }
  }, {
    key: "processMessage",
    value: function processMessage(message) {
      if (this.hasStarted) return;

      switch (message[0]) {
        case 78
        /* Type.JSException */
        :
          this.jsExceptionEvent(message);
          break;

        case 27
        /* Type.CustomEvent */
        :
          this.customEvent(message);
          break;

        case 68
        /* Type.MouseClick */
        :
          this.clickEvent(message);
          break;

        case 122
        /* Type.SetPageLocation */
        :
          this.pageLocationEvent(message);
          break;

        case 83
        /* Type.NetworkRequest */
        :
          this.networkRequest(message);
          break;
      }
    }
  }, {
    key: "processFlags",
    value: function processFlags(flag) {
      var _this4 = this;

      var flagConds = this.conditions.filter(function (c) {
        return c.type === 'feature_flag';
      });

      if (flagConds.length) {
        flagConds.forEach(function (flagCond) {
          var operator = operators[flagCond.operator];

          if (operator && flag.find(function (f) {
            return operator(f.key, flagCond.value);
          })) {
            _this4.trigger(flagCond.name);
          }
        });
      }
    }
  }, {
    key: "processDuration",
    value: function processDuration(durationMs, condName) {
      var _this5 = this;

      this.durationInt = setInterval(function () {
        var sessionLength = performance.now();

        if (sessionLength > durationMs) {
          _this5.trigger(condName);
        }
      }, 1000);
      this.app.attachStopCallback(function () {
        if (_this5.durationInt) {
          clearInterval(_this5.durationInt);
        }
      });
    }
  }, {
    key: "networkRequest",
    value: function networkRequest(message) {
      var _this6 = this;

      // method - 2, url - 3, status - 6, duration - 8
      var reqConds = this.conditions.filter(function (c) {
        return c.type === 'network_request';
      });
      if (!reqConds.length) return;
      reqConds.forEach(function (reqCond) {
        var validSubConditions = reqCond.subConditions.filter(function (c) {
          return c.operator !== 'isAny';
        });

        if (validSubConditions.length) {
          var allPass = validSubConditions.every(function (subCond) {
            var value;

            switch (subCond.key) {
              case 'url':
                value = message[3];
                break;

              case 'status':
                value = message[6];
                break;

              case 'method':
                value = message[2];
                break;

              case 'duration':
                value = message[8];
                break;
            }

            var operator = operators[subCond.operator]; // @ts-ignore

            if (operator && operator(value, subCond.value)) {
              return true;
            }
          });

          if (allPass) {
            _this6.trigger(reqCond.name);
          }
        } else if (validSubConditions.length === 0 && reqCond.subConditions.length) {
          _this6.trigger(reqCond.name);
        }
      });
    }
  }, {
    key: "customEvent",
    value: function customEvent(message) {
      var _this7 = this;

      // name - 1, payload - 2
      var evConds = this.conditions.filter(function (c) {
        return c.type === 'custom_event';
      });

      if (evConds.length) {
        evConds.forEach(function (evCond) {
          var operator = operators[evCond.operator];

          if (operator && (operator(message[1], evCond.value) || operator(message[2], evCond.value))) {
            _this7.trigger(evCond.name);
          }
        });
      }
    }
  }, {
    key: "clickEvent",
    value: function clickEvent(message) {
      var _this8 = this;

      // label - 3, selector - 4
      var clickCond = this.conditions.filter(function (c) {
        return c.type === 'click';
      });

      if (clickCond.length) {
        clickCond.forEach(function (click) {
          var operator = operators[click.operator];

          if (operator && (operator(message[3], click.value) || operator(message[4], click.value))) {
            _this8.trigger(click.name);
          }
        });
      }
    }
  }, {
    key: "pageLocationEvent",
    value: function pageLocationEvent(message) {
      var _this9 = this;

      // url - 1
      var urlConds = this.conditions.filter(function (c) {
        return c.type === 'visited_url';
      });

      if (urlConds) {
        urlConds.forEach(function (urlCond) {
          var operator = operators[urlCond.operator];

          if (operator && operator(message[1], urlCond.value)) {
            _this9.trigger(urlCond.name);
          }
        });
      }
    }
  }, {
    key: "jsExceptionEvent",
    value: function jsExceptionEvent(message) {
      var _this10 = this;

      // name - 1, message - 2, payload - 3
      var testedValues = [message[1], message[2], message[3]];
      var exceptionConds = this.conditions.filter(function (c) {
        return c.type === 'exception';
      });

      if (exceptionConds) {
        exceptionConds.forEach(function (exceptionCond) {
          var operator = operators[exceptionCond.operator];

          if (operator && testedValues.some(function (val) {
            return operator(val, exceptionCond.value);
          })) {
            _this10.trigger(exceptionCond.name);
          }
        });
      }
    }
  }]);

  return ConditionsManager;
}();

var operators = {
  is: function is(val, target) {
    return target.some(function (t) {
      return val.includes(t);
    });
  },
  isAny: function isAny() {
    return true;
  },
  isNot: function isNot(val, target) {
    return !target.some(function (t) {
      return val.includes(t);
    });
  },
  contains: function contains(val, target) {
    return target.some(function (t) {
      return val.includes(t);
    });
  },
  notContains: function notContains(val, target) {
    return !target.some(function (t) {
      return val.includes(t);
    });
  },
  startsWith: function startsWith(val, target) {
    return target.some(function (t) {
      return val.startsWith(t);
    });
  },
  endsWith: function endsWith(val, target) {
    return target.some(function (t) {
      return val.endsWith(t);
    });
  },
  greaterThan: function greaterThan(val, target) {
    return val > target;
  },
  greaterOrEqual: function greaterOrEqual(val, target) {
    return val >= target;
  },
  lessOrEqual: function lessOrEqual(val, target) {
    return val <= target;
  },
  lessThan: function lessThan(val, target) {
    return val < target;
  }
};

var mapCondition = function mapCondition(condition) {
  var opMap = {
    on: 'is',
    notOn: 'isNot',
    ">": 'greaterThan',
    "<": 'lessThan',
    "=": 'is',
    "<=": 'lessOrEqual',
    ">=": 'greaterOrEqual'
  };

  var mapOperator = function mapOperator(operator) {
    var keys = Object.keys(opMap); // @ts-ignore

    if (keys.includes(operator)) return opMap[operator];
  };

  var con = {
    type: '',
    operator: '',
    value: condition.value,
    key: ''
  };

  switch (condition.type) {
    case 'click':
      con = {
        type: 'click',
        operator: mapOperator(condition.operator),
        value: condition.value,
        key: ''
      };
      break;

    case 'location':
      con = {
        type: 'visited_url',
        // @ts-ignore
        operator: condition.operator,
        value: condition.value,
        key: ''
      };
      break;

    case 'custom':
      con = {
        type: 'custom_event',
        // @ts-ignore
        operator: condition.operator,
        value: condition.value,
        key: ''
      };
      break;

    case 'metadata':
      con = {
        // @ts-ignore
        type: condition.source === 'featureFlag' ? 'feature_flag' : condition.type,
        // @ts-ignore
        operator: condition.operator,
        value: condition.value,
        key: ''
      };
      break;

    case 'error':
      con = {
        type: 'exception',
        // @ts-ignore
        operator: condition.operator,
        value: condition.value,
        key: ''
      };
      break;

    case 'duration':
      con = {
        type: 'session_duration',
        // @ts-ignore
        value: condition.value[0],
        key: ''
      };
      break;

    case 'fetchUrl':
      con = {
        type: 'network_request',
        key: 'url',
        operator: condition.operator,
        value: condition.value
      };
      break;

    case 'fetchStatusCode':
      con = {
        type: 'network_request',
        key: 'status',
        operator: mapOperator(condition.operator),
        value: condition.value
      };
      break;

    case 'fetchMethod':
      con = {
        type: 'network_request',
        key: 'method',
        operator: mapOperator(condition.operator),
        value: condition.value
      };
      break;

    case 'fetchDuration':
      con = {
        type: 'network_request',
        key: 'duration',
        operator: mapOperator(condition.operator),
        value: condition.value
      };
      break;
  } // @ts-ignore


  return con;
};

var FeatureFlags = /*#__PURE__*/function () {
  function FeatureFlags(app) {
    _classCallCheck(this, FeatureFlags);

    this.app = app;
    this.flags = [];
    this.storageKey = '__openreplay_flags';
    var persistFlags = this.app.sessionStorage.getItem(this.storageKey);

    if (persistFlags) {
      var persistFlagsStrArr = persistFlags.split(';').filter(Boolean);
      this.flags = persistFlagsStrArr.map(function (flag) {
        return JSON.parse(flag);
      });
    }
  }

  _createClass(FeatureFlags, [{
    key: "getFeatureFlag",
    value: function getFeatureFlag(flagName) {
      return this.flags.find(function (flag) {
        return flag.key === flagName;
      });
    }
  }, {
    key: "isFlagEnabled",
    value: function isFlagEnabled(flagName) {
      return this.flags.findIndex(function (flag) {
        return flag.key === flagName;
      }) !== -1;
    }
  }, {
    key: "onFlagsLoad",
    value: function onFlagsLoad(cb) {
      this.onFlagsCb = cb;
    }
  }, {
    key: "reloadFlags",
    value: function () {
      var _reloadFlags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(token) {
        var persistFlagsStr, persistFlags, persistArray, sessionInfo, userInfo, requestObject, authToken, resp, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              persistFlagsStr = this.app.sessionStorage.getItem(this.storageKey);
              persistFlags = {};

              if (persistFlagsStr) {
                persistArray = persistFlagsStr.split(';').filter(Boolean);
                persistArray.forEach(function (flag) {
                  var flagObj = JSON.parse(flag);
                  persistFlags[flagObj.key] = {
                    key: flagObj.key,
                    value: flagObj.value
                  };
                });
              }

              sessionInfo = this.app.session.getInfo();
              userInfo = this.app.session.userInfo;
              requestObject = {
                projectID: sessionInfo.projectID,
                userID: sessionInfo.userID,
                metadata: sessionInfo.metadata,
                referrer: document.referrer,
                os: userInfo.userOS,
                device: userInfo.userDevice,
                country: userInfo.userCountry,
                state: userInfo.userState,
                city: userInfo.userCity,
                browser: userInfo.userBrowser,
                persistFlags: persistFlags
              };
              authToken = token !== null && token !== void 0 ? token : this.app.session.getSessionToken();
              _context2.next = 9;
              return fetch(this.app.options.ingestPoint + '/v1/web/feature-flags', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(authToken)
                },
                body: JSON.stringify(requestObject)
              });

            case 9:
              resp = _context2.sent;

              if (!(resp.status === 200)) {
                _context2.next = 15;
                break;
              }

              _context2.next = 13;
              return resp.json();

            case 13:
              data = _context2.sent;
              return _context2.abrupt("return", this.handleFlags(data.flags));

            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));

      function reloadFlags(_x3) {
        return _reloadFlags.apply(this, arguments);
      }

      return reloadFlags;
    }()
  }, {
    key: "handleFlags",
    value: function handleFlags(flags) {
      var _this$onFlagsCb;

      var persistFlags = [];
      flags.forEach(function (flag) {
        if (flag.is_persist) persistFlags.push(flag);
      });
      var str = '';
      var uniquePersistFlags = this.diffPersist(persistFlags);
      uniquePersistFlags.forEach(function (flag) {
        str += "".concat(JSON.stringify(flag), ";");
      });
      this.app.sessionStorage.setItem(this.storageKey, str);
      this.flags = flags;
      return (_this$onFlagsCb = this.onFlagsCb) === null || _this$onFlagsCb === void 0 ? void 0 : _this$onFlagsCb.call(this, flags);
    }
  }, {
    key: "clearPersistFlags",
    value: function clearPersistFlags() {
      this.app.sessionStorage.removeItem(this.storageKey);
    }
  }, {
    key: "diffPersist",
    value: function diffPersist(flags) {
      var persistFlags = this.app.sessionStorage.getItem(this.storageKey);
      if (!persistFlags) return flags;
      var persistFlagsStrArr = persistFlags.split(';').filter(Boolean);
      var persistFlagsArr = persistFlagsStrArr.map(function (flag) {
        return JSON.parse(flag);
      });
      return flags.filter(function (flag) {
        return persistFlagsArr.findIndex(function (pf) {
          return pf.key === flag.key;
        }) === -1;
      });
    }
  }]);

  return FeatureFlags;
}();

var DEPRECATED_ATTRS = {
  htmlmasked: 'hidden',
  masked: 'obscured'
};
var IN_BROWSER = !(typeof window === 'undefined');
var IS_FIREFOX = IN_BROWSER && navigator.userAgent.match(/firefox|fxios/i);
var MAX_STR_LEN = 1e5; // Buggy to use `performance.timeOrigin || performance.timing.navigationStart`
// https://github.com/mdn/content/issues/4713
// Maybe move to timer/ticker

var timeOrigin = IN_BROWSER ? Date.now() - performance.now() : 0;

function adjustTimeOrigin() {
  timeOrigin = Date.now() - performance.now();
}

function getTimeOrigin() {
  return timeOrigin;
}

var now = IN_BROWSER && !!performance.now ? function () {
  return Math.round(performance.now() + timeOrigin);
} : function () {
  return Date.now();
};
var stars = 'repeat' in String.prototype ? function (str) {
  return '*'.repeat(str.length);
} : function (str) {
  return str.replace(/./g, '*');
};

function normSpaces(str) {
  return str.trim().replace(/\s+/g, ' ');
} // isAbsoluteUrl regexp:  /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)


function isURL(s) {
  return s.startsWith('https://') || s.startsWith('http://');
} // TODO: JOIN IT WITH LOGGER somehow (use logging decorators?); Don't forget about index.js loggin when there is no logger instance.


var DOCS_HOST = 'https://docs.openreplay.com';
var warnedFeatures = {};

function deprecationWarn(nameOfFeature, useInstead) {
  var docsPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';

  if (warnedFeatures[nameOfFeature]) {
    return;
  }

  console.warn("OpenReplay: ".concat(nameOfFeature, " is deprecated. ").concat(useInstead ? "Please, use ".concat(useInstead, " instead.") : '', " Visit ").concat(DOCS_HOST).concat(docsPath, " for more information."));
  warnedFeatures[nameOfFeature] = true;
}

function getLabelAttribute(e) {
  var value = e.getAttribute('data-openreplay-label');

  if (value !== null) {
    return value;
  }

  value = e.getAttribute('data-asayer-label');

  if (value !== null) {
    deprecationWarn('"data-asayer-label" attribute', '"data-openreplay-label" attribute', '/');
  }

  return value;
}

function hasOpenreplayAttribute(e, attr) {
  var newName = "data-openreplay-".concat(attr);

  if (e.hasAttribute(newName)) {
    // @ts-ignore
    if (DEPRECATED_ATTRS[attr]) {
      deprecationWarn("\"".concat(newName, "\" attribute"), // @ts-ignore
      "\"".concat(DEPRECATED_ATTRS[attr], "\" attribute"), '/installation/sanitize-data');
    }

    return true;
  }

  return false;
}
/**
 * checks if iframe is accessible
 **/


function canAccessIframe(iframe) {
  try {
    return Boolean(iframe.contentDocument);
  } catch (e) {
    return false;
  }
}

function canAccessTarget(target) {
  try {
    if (target instanceof HTMLIFrameElement) {
      void target.contentDocument;
    } else if (target instanceof Window) {
      void target.document;
    } else if (target instanceof Document) {
      void target.defaultView;
    } else if ('nodeType' in target) {
      void target.nodeType;
    } else if ('addEventListener' in target) {
      void target.addEventListener;
    }

    return true;
  } catch (e) {
    if (e instanceof DOMException && e.name === 'SecurityError') {
      return false;
    }
  }

  return true;
}

function dec2hex(dec) {
  return dec.toString(16).padStart(2, '0');
}

function generateRandomId(len) {
  var arr = new Uint8Array(len / 2); // msCrypto = IE11
  // @ts-ignore

  var safeCrypto = window.crypto || window.msCrypto;

  if (safeCrypto) {
    safeCrypto.getRandomValues(arr);
    return Array.from(arr, dec2hex).join('');
  } else {
    return Array.from({
      length: len
    }, function () {
      return dec2hex(Math.floor(Math.random() * 16));
    }).join('');
  }
}

function inIframe() {
  try {
    return window.self && window.top && window.self !== window.top;
  } catch (e) {
    return true;
  }
}
/**
 * Because angular devs decided that its a good idea to override a browser apis
 * we need to use this to achieve safe behavior
 * */


function ngSafeBrowserMethod(method) {
  // @ts-ignore
  return window.Zone && '__symbol__' in window.Zone ? // @ts-ignore
  window['Zone']['__symbol__'](method) : method;
}

function createMutationObserver(cb, forceNgOff) {
  if (!forceNgOff) {
    var mObserver = ngSafeBrowserMethod('MutationObserver');
    return new window[mObserver](cb);
  } else {
    return new MutationObserver(cb);
  }
}

function createEventListener(target, event, cb, capture, forceNgOff) {
  // we need to check if target is crossorigin frame or no and if we can access it
  if (!canAccessTarget(target)) {
    return;
  }

  var safeAddEventListener = 'addEventListener';

  if (!forceNgOff) {
    safeAddEventListener = ngSafeBrowserMethod('addEventListener');
  }

  try {
    // parent has angular, but child frame don't
    if (target[safeAddEventListener]) {
      target[safeAddEventListener](event, cb, capture);
    } else {
      // @ts-ignore
      target.addEventListener(event, cb, capture);
    }
  } catch (e) {
    var msg = e.message;
    console.error( // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    "Openreplay: ".concat(msg, "; if this error is caused by an IframeObserver, ignore it"), event, target);
  }
}

function deleteEventListener(target, event, cb, capture, forceNgOff) {
  if (!canAccessTarget(target)) {
    return;
  }

  var safeRemoveEventListener = 'removeEventListener';

  if (!forceNgOff) {
    safeRemoveEventListener = ngSafeBrowserMethod('removeEventListener');
  }

  try {
    if (target[safeRemoveEventListener]) {
      target[safeRemoveEventListener](event, cb, capture);
    } else {
      // @ts-ignore
      target.removeEventListener(event, cb, capture);
    }
  } catch (e) {
    var msg = e.message;
    console.error( // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    "Openreplay: ".concat(msg, "; if this error is caused by an IframeObserver, ignore it"), event, target);
  }
}

var FIFOTaskScheduler = /*#__PURE__*/function () {
  function FIFOTaskScheduler() {
    _classCallCheck(this, FIFOTaskScheduler);

    this.taskQueue = [];
    this.isRunning = false;
  } // Adds a task to the queue


  _createClass(FIFOTaskScheduler, [{
    key: "addTask",
    value: function addTask(task) {
      this.taskQueue.push(task);
      this.runTasks();
    } // Runs tasks from the queue

  }, {
    key: "runTasks",
    value: function runTasks() {
      var _this11 = this;

      if (this.isRunning || this.taskQueue.length === 0) {
        return;
      }

      this.isRunning = true;

      var executeNextTask = function executeNextTask() {
        if (_this11.taskQueue.length === 0) {
          _this11.isRunning = false;
          return;
        } // Get the next task and execute it


        var nextTask = _this11.taskQueue.shift();

        Promise.resolve(nextTask()).then(function () {
          requestAnimationFrame(function () {
            return executeNextTask();
          });
        });
      };

      executeNextTask();
    }
  }]);

  return FIFOTaskScheduler;
}();

var scheduler = new FIFOTaskScheduler();

function requestIdleCb(callback) {
  // performance improvement experiment;
  scheduler.addTask(callback);
  /**
   * This is a brief polyfill that suits our needs
   * I took inspiration from Microsoft Clarity polyfill on this one
   * then adapted it a little bit
   *
   * I'm very grateful for their bright idea
   * */
  // const taskTimeout = 3000
  // if (window.requestIdleCallback) {
  //   return window.requestIdleCallback(callback, { timeout: taskTimeout })
  // } else {
  //   const channel = new MessageChannel()
  //   const incoming = channel.port1
  //   const outgoing = channel.port2
  //
  //   incoming.onmessage = (): void => {
  //     callback()
  //   }
  //   requestAnimationFrame((): void => {
  //     outgoing.postMessage(1)
  //   })
  // }
}

function simpleMerge(defaultObj, givenObj) {
  var result = _objectSpread({}, defaultObj);

  for (var key in givenObj) {
    // eslint-disable-next-line no-prototype-builtins
    if (givenObj.hasOwnProperty(key)) {
      var userOptionValue = givenObj[key];
      var defaultOptionValue = defaultObj[key];

      if (typeof userOptionValue === 'object' && !Array.isArray(userOptionValue) && userOptionValue !== null) {
        result[key] = simpleMerge(defaultOptionValue || {}, userOptionValue);
      } else {
        result[key] = userOptionValue;
      }
    }
  }

  return result;
} // Auto-generated, do not edit

/* eslint-disable */


function Timestamp(timestamp) {
  return [0
  /* Messages.Type.Timestamp */
  , timestamp];
}

function SetPageLocationDeprecated(url, referrer, navigationStart) {
  return [4
  /* Messages.Type.SetPageLocationDeprecated */
  , url, referrer, navigationStart];
}

function SetViewportSize(width, height) {
  return [5
  /* Messages.Type.SetViewportSize */
  , width, height];
}

function SetViewportScroll(x, y) {
  return [6
  /* Messages.Type.SetViewportScroll */
  , x, y];
}

function CreateDocument() {
  return [7
  /* Messages.Type.CreateDocument */
  ];
}

function CreateElementNode(id, parentID, index, tag, svg) {
  return [8
  /* Messages.Type.CreateElementNode */
  , id, parentID, index, tag, svg];
}

function CreateTextNode(id, parentID, index) {
  return [9
  /* Messages.Type.CreateTextNode */
  , id, parentID, index];
}

function MoveNode(id, parentID, index) {
  return [10
  /* Messages.Type.MoveNode */
  , id, parentID, index];
}

function RemoveNode(id) {
  return [11
  /* Messages.Type.RemoveNode */
  , id];
}

function SetNodeAttribute(id, name, value) {
  return [12
  /* Messages.Type.SetNodeAttribute */
  , id, name, value];
}

function RemoveNodeAttribute(id, name) {
  return [13
  /* Messages.Type.RemoveNodeAttribute */
  , id, name];
}

function SetNodeData(id, data) {
  return [14
  /* Messages.Type.SetNodeData */
  , id, data];
}

function SetNodeScroll(id, x, y) {
  return [16
  /* Messages.Type.SetNodeScroll */
  , id, x, y];
}

function SetInputTarget(id, label) {
  return [17
  /* Messages.Type.SetInputTarget */
  , id, label];
}

function SetInputValue(id, value, mask) {
  return [18
  /* Messages.Type.SetInputValue */
  , id, value, mask];
}

function SetInputChecked(id, checked) {
  return [19
  /* Messages.Type.SetInputChecked */
  , id, checked];
}

function MouseMove(x, y) {
  return [20
  /* Messages.Type.MouseMove */
  , x, y];
}

function NetworkRequestDeprecated(type, method, url, request, response, status, timestamp, duration) {
  return [21
  /* Messages.Type.NetworkRequestDeprecated */
  , type, method, url, request, response, status, timestamp, duration];
}

function ConsoleLog(level, value) {
  return [22
  /* Messages.Type.ConsoleLog */
  , level, value];
}

function PageLoadTiming(requestStart, responseStart, responseEnd, domContentLoadedEventStart, domContentLoadedEventEnd, loadEventStart, loadEventEnd, firstPaint, firstContentfulPaint) {
  return [23
  /* Messages.Type.PageLoadTiming */
  , requestStart, responseStart, responseEnd, domContentLoadedEventStart, domContentLoadedEventEnd, loadEventStart, loadEventEnd, firstPaint, firstContentfulPaint];
}

function PageRenderTiming(speedIndex, visuallyComplete, timeToInteractive) {
  return [24
  /* Messages.Type.PageRenderTiming */
  , speedIndex, visuallyComplete, timeToInteractive];
}

function CustomEvent(name, payload) {
  return [27
  /* Messages.Type.CustomEvent */
  , name, payload];
}

function UserID(id) {
  return [28
  /* Messages.Type.UserID */
  , id];
}

function UserAnonymousID(id) {
  return [29
  /* Messages.Type.UserAnonymousID */
  , id];
}

function Metadata(key, value) {
  return [30
  /* Messages.Type.Metadata */
  , key, value];
}

function CSSInsertRule(id, rule, index) {
  return [37
  /* Messages.Type.CSSInsertRule */
  , id, rule, index];
}

function CSSDeleteRule(id, index) {
  return [38
  /* Messages.Type.CSSDeleteRule */
  , id, index];
}

function Fetch(method, url, request, response, status, timestamp, duration) {
  return [39
  /* Messages.Type.Fetch */
  , method, url, request, response, status, timestamp, duration];
}

function Profiler(name, duration, args, result) {
  return [40
  /* Messages.Type.Profiler */
  , name, duration, args, result];
}

function OTable(key, value) {
  return [41
  /* Messages.Type.OTable */
  , key, value];
}

function StateAction(type) {
  return [42
  /* Messages.Type.StateAction */
  , type];
}

function ReduxDeprecated(action, state, duration) {
  return [44
  /* Messages.Type.ReduxDeprecated */
  , action, state, duration];
}

function Vuex(mutation, state) {
  return [45
  /* Messages.Type.Vuex */
  , mutation, state];
}

function MobX(type, payload) {
  return [46
  /* Messages.Type.MobX */
  , type, payload];
}

function NgRx(action, state, duration) {
  return [47
  /* Messages.Type.NgRx */
  , action, state, duration];
}

function GraphQLDeprecated(operationKind, operationName, variables, response, duration) {
  return [48
  /* Messages.Type.GraphQLDeprecated */
  , operationKind, operationName, variables, response, duration];
}

function PerformanceTrack(frames, ticks, totalJSHeapSize, usedJSHeapSize) {
  return [49
  /* Messages.Type.PerformanceTrack */
  , frames, ticks, totalJSHeapSize, usedJSHeapSize];
}

function StringDictDeprecated(key, value) {
  return [50
  /* Messages.Type.StringDictDeprecated */
  , key, value];
}

function SetNodeAttributeDictDeprecated(id, nameKey, valueKey) {
  return [51
  /* Messages.Type.SetNodeAttributeDictDeprecated */
  , id, nameKey, valueKey];
}

function StringDict(key, value) {
  return [43
  /* Messages.Type.StringDict */
  , key, value];
}

function SetNodeAttributeDict(id, name, value) {
  return [52
  /* Messages.Type.SetNodeAttributeDict */
  , id, name, value];
}

function ResourceTimingDeprecated(timestamp, duration, ttfb, headerSize, encodedBodySize, decodedBodySize, url, initiator) {
  return [53
  /* Messages.Type.ResourceTimingDeprecated */
  , timestamp, duration, ttfb, headerSize, encodedBodySize, decodedBodySize, url, initiator];
}

function ConnectionInformation(downlink, type) {
  return [54
  /* Messages.Type.ConnectionInformation */
  , downlink, type];
}

function SetPageVisibility(hidden) {
  return [55
  /* Messages.Type.SetPageVisibility */
  , hidden];
}

function LoadFontFace(parentID, family, source, descriptors) {
  return [57
  /* Messages.Type.LoadFontFace */
  , parentID, family, source, descriptors];
}

function SetNodeFocus(id) {
  return [58
  /* Messages.Type.SetNodeFocus */
  , id];
}

function LongTask(timestamp, duration, context, containerType, containerSrc, containerId, containerName) {
  return [59
  /* Messages.Type.LongTask */
  , timestamp, duration, context, containerType, containerSrc, containerId, containerName];
}

function SetNodeAttributeURLBased(id, name, value, baseURL) {
  return [60
  /* Messages.Type.SetNodeAttributeURLBased */
  , id, name, value, baseURL];
}

function SetCSSDataURLBased(id, data, baseURL) {
  return [61
  /* Messages.Type.SetCSSDataURLBased */
  , id, data, baseURL];
}

function TechnicalInfo(type, value) {
  return [63
  /* Messages.Type.TechnicalInfo */
  , type, value];
}

function CustomIssue(name, payload) {
  return [64
  /* Messages.Type.CustomIssue */
  , name, payload];
}

function CSSInsertRuleURLBased(id, rule, index, baseURL) {
  return [67
  /* Messages.Type.CSSInsertRuleURLBased */
  , id, rule, index, baseURL];
}

function MouseClick(id, hesitationTime, label, selector, normalizedX, normalizedY) {
  return [68
  /* Messages.Type.MouseClick */
  , id, hesitationTime, label, selector, normalizedX, normalizedY];
}

function MouseClickDeprecated(id, hesitationTime, label, selector) {
  return [69
  /* Messages.Type.MouseClickDeprecated */
  , id, hesitationTime, label, selector];
}

function CreateIFrameDocument(frameID, id) {
  return [70
  /* Messages.Type.CreateIFrameDocument */
  , frameID, id];
}

function AdoptedSSReplaceURLBased(sheetID, text, baseURL) {
  return [71
  /* Messages.Type.AdoptedSSReplaceURLBased */
  , sheetID, text, baseURL];
}

function AdoptedSSInsertRuleURLBased(sheetID, rule, index, baseURL) {
  return [73
  /* Messages.Type.AdoptedSSInsertRuleURLBased */
  , sheetID, rule, index, baseURL];
}

function AdoptedSSDeleteRule(sheetID, index) {
  return [75
  /* Messages.Type.AdoptedSSDeleteRule */
  , sheetID, index];
}

function AdoptedSSAddOwner(sheetID, id) {
  return [76
  /* Messages.Type.AdoptedSSAddOwner */
  , sheetID, id];
}

function AdoptedSSRemoveOwner(sheetID, id) {
  return [77
  /* Messages.Type.AdoptedSSRemoveOwner */
  , sheetID, id];
}

function JSException(name, message, payload, metadata) {
  return [78
  /* Messages.Type.JSException */
  , name, message, payload, metadata];
}

function Zustand(mutation, state) {
  return [79
  /* Messages.Type.Zustand */
  , mutation, state];
}

function BatchMetadata(version, pageNo, firstIndex, timestamp, location) {
  return [81
  /* Messages.Type.BatchMetadata */
  , version, pageNo, firstIndex, timestamp, location];
}

function PartitionedMessage(partNo, partTotal) {
  return [82
  /* Messages.Type.PartitionedMessage */
  , partNo, partTotal];
}

function NetworkRequest(type, method, url, request, response, status, timestamp, duration, transferredBodySize) {
  return [83
  /* Messages.Type.NetworkRequest */
  , type, method, url, request, response, status, timestamp, duration, transferredBodySize];
}

function WSChannel(chType, channelName, data, timestamp, dir, messageType) {
  return [84
  /* Messages.Type.WSChannel */
  , chType, channelName, data, timestamp, dir, messageType];
}

function InputChange(id, value, valueMasked, label, hesitationTime, inputDuration) {
  return [112
  /* Messages.Type.InputChange */
  , id, value, valueMasked, label, hesitationTime, inputDuration];
}

function SelectionChange(selectionStart, selectionEnd, selection) {
  return [113
  /* Messages.Type.SelectionChange */
  , selectionStart, selectionEnd, selection];
}

function MouseThrashing(timestamp) {
  return [114
  /* Messages.Type.MouseThrashing */
  , timestamp];
}

function UnbindNodes(totalRemovedPercent) {
  return [115
  /* Messages.Type.UnbindNodes */
  , totalRemovedPercent];
}

function ResourceTiming(timestamp, duration, ttfb, headerSize, encodedBodySize, decodedBodySize, url, initiator, transferredSize, cached) {
  return [116
  /* Messages.Type.ResourceTiming */
  , timestamp, duration, ttfb, headerSize, encodedBodySize, decodedBodySize, url, initiator, transferredSize, cached];
}

function TabChange(tabId) {
  return [117
  /* Messages.Type.TabChange */
  , tabId];
}

function TabData(tabId) {
  return [118
  /* Messages.Type.TabData */
  , tabId];
}

function CanvasNode(nodeId, timestamp) {
  return [119
  /* Messages.Type.CanvasNode */
  , nodeId, timestamp];
}

function TagTrigger(tagId) {
  return [120
  /* Messages.Type.TagTrigger */
  , tagId];
}

function Redux(action, state, duration, actionTime) {
  return [121
  /* Messages.Type.Redux */
  , action, state, duration, actionTime];
}

function SetPageLocation(url, referrer, navigationStart, documentTitle) {
  return [122
  /* Messages.Type.SetPageLocation */
  , url, referrer, navigationStart, documentTitle];
}

function GraphQL(operationKind, operationName, variables, response, duration) {
  return [123
  /* Messages.Type.GraphQL */
  , operationKind, operationName, variables, response, duration];
}

function WebVitals(name, value) {
  return [124
  /* Messages.Type.WebVitals */
  , name, value];
}

var _Messages = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AdoptedSSAddOwner: AdoptedSSAddOwner,
  AdoptedSSDeleteRule: AdoptedSSDeleteRule,
  AdoptedSSInsertRuleURLBased: AdoptedSSInsertRuleURLBased,
  AdoptedSSRemoveOwner: AdoptedSSRemoveOwner,
  AdoptedSSReplaceURLBased: AdoptedSSReplaceURLBased,
  BatchMetadata: BatchMetadata,
  CSSDeleteRule: CSSDeleteRule,
  CSSInsertRule: CSSInsertRule,
  CSSInsertRuleURLBased: CSSInsertRuleURLBased,
  CanvasNode: CanvasNode,
  ConnectionInformation: ConnectionInformation,
  ConsoleLog: ConsoleLog,
  CreateDocument: CreateDocument,
  CreateElementNode: CreateElementNode,
  CreateIFrameDocument: CreateIFrameDocument,
  CreateTextNode: CreateTextNode,
  CustomEvent: CustomEvent,
  CustomIssue: CustomIssue,
  Fetch: Fetch,
  GraphQL: GraphQL,
  GraphQLDeprecated: GraphQLDeprecated,
  InputChange: InputChange,
  JSException: JSException,
  LoadFontFace: LoadFontFace,
  LongTask: LongTask,
  Metadata: Metadata,
  MobX: MobX,
  MouseClick: MouseClick,
  MouseClickDeprecated: MouseClickDeprecated,
  MouseMove: MouseMove,
  MouseThrashing: MouseThrashing,
  MoveNode: MoveNode,
  NetworkRequest: NetworkRequest,
  NetworkRequestDeprecated: NetworkRequestDeprecated,
  NgRx: NgRx,
  OTable: OTable,
  PageLoadTiming: PageLoadTiming,
  PageRenderTiming: PageRenderTiming,
  PartitionedMessage: PartitionedMessage,
  PerformanceTrack: PerformanceTrack,
  Profiler: Profiler,
  Redux: Redux,
  ReduxDeprecated: ReduxDeprecated,
  RemoveNode: RemoveNode,
  RemoveNodeAttribute: RemoveNodeAttribute,
  ResourceTiming: ResourceTiming,
  ResourceTimingDeprecated: ResourceTimingDeprecated,
  SelectionChange: SelectionChange,
  SetCSSDataURLBased: SetCSSDataURLBased,
  SetInputChecked: SetInputChecked,
  SetInputTarget: SetInputTarget,
  SetInputValue: SetInputValue,
  SetNodeAttribute: SetNodeAttribute,
  SetNodeAttributeDict: SetNodeAttributeDict,
  SetNodeAttributeDictDeprecated: SetNodeAttributeDictDeprecated,
  SetNodeAttributeURLBased: SetNodeAttributeURLBased,
  SetNodeData: SetNodeData,
  SetNodeFocus: SetNodeFocus,
  SetNodeScroll: SetNodeScroll,
  SetPageLocation: SetPageLocation,
  SetPageLocationDeprecated: SetPageLocationDeprecated,
  SetPageVisibility: SetPageVisibility,
  SetViewportScroll: SetViewportScroll,
  SetViewportSize: SetViewportSize,
  StateAction: StateAction,
  StringDict: StringDict,
  StringDictDeprecated: StringDictDeprecated,
  TabChange: TabChange,
  TabData: TabData,
  TagTrigger: TagTrigger,
  TechnicalInfo: TechnicalInfo,
  Timestamp: Timestamp,
  UnbindNodes: UnbindNodes,
  UserAnonymousID: UserAnonymousID,
  UserID: UserID,
  Vuex: Vuex,
  WSChannel: WSChannel,
  WebVitals: WebVitals,
  Zustand: Zustand
});

var perf = IN_BROWSER && 'performance' in window && 'memory' in performance // works in Chrome only
? performance : {
  memory: {}
};
var deviceMemory = IN_BROWSER ? (navigator.deviceMemory || 0) * 1024 : 0;
var jsHeapSizeLimit = perf.memory.jsHeapSizeLimit || 0;

function Performance(app, opts) {
  var options = Object.assign({
    capturePerformance: true
  }, opts);

  if (!options.capturePerformance) {
    return;
  }

  var frames;
  var ticks;

  var nextFrame = function nextFrame() {
    if (frames === undefined || frames === -1) {
      return;
    }

    frames++;
    requestAnimationFrame(nextFrame);
  };

  app.ticker.attach(function () {
    if (ticks === undefined || ticks === -1) {
      return;
    }

    ticks++;
  }, 0, false);

  var sendPerformanceTrack = function sendPerformanceTrack() {
    if (frames === undefined || ticks === undefined) {
      return;
    }

    app.send(PerformanceTrack(frames, ticks, perf.memory.totalJSHeapSize || 0, perf.memory.usedJSHeapSize || 0));
    ticks = frames = document.hidden ? -1 : 0;
  };

  app.attachStartCallback(function () {
    ticks = frames = -1;
    sendPerformanceTrack();
    nextFrame();
  });
  app.attachStopCallback(function () {
    ticks = frames = undefined;
  });
  app.ticker.attach(sendPerformanceTrack, 40, false);

  if (document.hidden !== undefined) {
    app.attachEventListener(document, 'visibilitychange', sendPerformanceTrack, false, false);
  }
}

var WATCHED_TAGS_KEY = '__or__watched_tags__';

var TagWatcher = /*#__PURE__*/function () {
  function TagWatcher(params) {
    var _params$sessionStorag,
        _this12 = this;

    _classCallCheck(this, TagWatcher);

    this.intervals = {};
    this.tags = [];
    this.sessionStorage = params.sessionStorage;
    this.errLog = params.errLog;
    this.onTag = params.onTag; // @ts-ignore

    var tags = JSON.parse((_params$sessionStorag = params.sessionStorage.getItem(WATCHED_TAGS_KEY)) !== null && _params$sessionStorag !== void 0 ? _params$sessionStorag : '[]');
    this.setTags(tags);
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target) {
            // @ts-ignore
            var tag = entry.target.__or_watcher_tagname;

            if (tag) {
              _this12.onTagRendered(tag);
            }

            _this12.observer.unobserve(entry.target);
          }
        }
      });
    });
  }

  _createClass(TagWatcher, [{
    key: "fetchTags",
    value: function () {
      var _fetchTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ingest, token) {
        var _this13 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", fetch("".concat(ingest, "/v1/web/tags"), {
                method: 'GET',
                headers: {
                  Authorization: "Bearer ".concat(token)
                }
              }).then(function (r) {
                return r.json();
              }).then(function (_ref) {
                var tags = _ref.tags;

                if (tags && tags.length) {
                  _this13.setTags(tags);

                  var tagString = JSON.stringify(tags);

                  _this13.sessionStorage.setItem(WATCHED_TAGS_KEY, tagString || '');
                }
              }).catch(function (e) {
                return _this13.errLog(e);
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));

      function fetchTags(_x4, _x5) {
        return _fetchTags.apply(this, arguments);
      }

      return fetchTags;
    }()
  }, {
    key: "setTags",
    value: function setTags(tags) {
      var _this14 = this;

      this.tags = tags;
      this.intervals = {};
      tags.forEach(function (tag) {
        _this14.intervals[tag.id] = setInterval(function () {
          var possibleEls = document.querySelectorAll(tag.selector);

          if (possibleEls.length > 0) {
            var el = possibleEls[0]; // @ts-ignore

            el.__or_watcher_tagname = tag.id;

            _this14.observer.observe(el);
          }
        }, 500);
      });
    }
  }, {
    key: "onTagRendered",
    value: function onTagRendered(tagId) {
      if (this.intervals[tagId]) {
        clearInterval(this.intervals[tagId]);
      }

      this.onTag(tagId);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this15 = this;

      this.tags.forEach(function (tag) {
        clearInterval(_this15.intervals[tag.id]);
      });
      this.tags = [];
      this.intervals = {};
      this.observer.disconnect();
    }
  }]);

  return TagWatcher;
}();

var bgStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(0, 0, 0, 0.40)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 999999,
  fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
};
var containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  alignItems: 'center',
  padding: '1.5rem',
  borderRadius: '2px',
  border: '1px solid #D9D9D9',
  background: '#FFF',
  width: '22rem'
};
var containerWidgetStyle = {
  display: 'flex',
  'flex-direction': 'column',
  gap: 'unset',
  'align-items': 'center',
  padding: 'unset',
  fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
  'border-radius': '2px',
  border: '1px solid #D9D9D9',
  background: 'rgba(255, 255, 255, 0.75)',
  width: '22rem'
};
var titleStyle = {
  fontFamily: 'Verdana, sans-serif',
  fontSize: '1.25rem',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '1.75rem',
  color: 'rgba(0, 0, 0, 0.85)'
};
var descriptionStyle = {
  borderTop: '1px solid rgba(0, 0, 0, 0.06)',
  borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
  padding: '1.25rem 0rem',
  color: 'rgba(0, 0, 0, 0.85)',
  fontFamily: 'Verdana, sans-serif',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'auto',
  whiteSpace: 'pre-wrap'
};
var buttonStyle = {
  display: 'flex',
  padding: '0.4rem 0.9375rem',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.625rem',
  borderRadius: '0.25rem',
  border: '1px solid #394EFF',
  background: '#394EFF',
  boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.04)',
  color: '#FFF',
  textAlign: 'center',
  fontFamily: 'Verdana, sans-serif',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '1.5rem',
  cursor: 'pointer'
};
var sectionTitleStyle = {
  fontFamily: 'Verdana, sans-serif',
  fontSize: '13px',
  fontWeight: '500',
  lineHeight: 'auto',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  cursor: 'pointer'
};
var contentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.625rem',
  fontSize: '13px',
  lineHeight: 'auto'
}; // New widget styles

var titleWidgetStyle = {
  padding: '0.5rem',
  gap: '0.5rem',
  fontFamily: 'Verdana, sans-serif',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: 'auto',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  borderRadius: '2px',
  background: 'rgba(0, 0, 0, 0.75)',
  boxSizing: 'border-box'
};
var descriptionWidgetStyle = {
  boxSizing: 'border-box',
  display: 'block',
  width: '100%',
  borderBottom: '1px solid #D9D9D9',
  background: '#FFF',
  padding: '0.65rem',
  alignSelf: 'stretch',
  color: '#000',
  fontFamily: 'Verdana, sans-serif',
  // fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: '400' // lineHeight: '1.375rem',

};

var endSectionStyle = _objectSpread(_objectSpread({}, descriptionWidgetStyle), {}, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.625rem'
});

var symbolIcon = {
  fontSize: '1.25rem',
  fontWeight: '500',
  cursor: 'pointer',
  color: '#394EFF'
};
var buttonWidgetStyle = {
  display: 'flex',
  padding: '0.4rem 0.9375rem',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.625rem',
  borderRadius: '0.25rem',
  border: '1px solid #394EFF',
  background: '#394EFF',
  boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.04)',
  color: '#FFF',
  textAlign: 'center',
  fontFamily: 'Verdana, sans-serif',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '1.5rem',
  width: '100%',
  boxSizing: 'border-box',
  cursor: 'pointer'
};
var stopWidgetStyle = {
  marginTop: '1rem',
  marginBottom: '1rem',
  cursor: 'pointer',
  display: 'block',
  fontWeight: '500',
  fontSize: '13px!important',
  lineHeight: 'auto'
};
var paginationStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '1rem',
  padding: '0.5rem',
  width: '100%',
  boxSizing: 'border-box'
};
var taskNumberActive = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '6.25em',
  outline: '1px solid #394EFF',
  fontSize: '13px',
  height: '24px',
  width: '24px'
};
var taskNumberDone = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '6.25em',
  outline: '1px solid #D2DFFF',
  boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.04)',
  background: '#D2DFFF',
  fontSize: '13px',
  height: '24px',
  width: '24px'
};
var taskDescriptionCard = {
  borderRadius: '0.375rem',
  border: '1px solid rgba(0, 0, 0, 0.06)',
  background: '#F5F7FF',
  boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.04)',
  display: 'flex',
  flexDirection: 'column',
  padding: '0.625rem 0.9375rem',
  gap: '0.5rem',
  alignSelf: 'stretch'
};
var taskTextStyle = {
  fontWeight: 'bold'
};
var taskDescriptionStyle = {
  fontSize: '13px',
  lineHeight: 'auto'
};
var taskButtonStyle = {
  marginRight: '0.5rem',
  cursor: 'pointer',
  color: '#394EFF',
  textAlign: 'center',
  fontFamily: 'Verdana, sans-serif',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: 'auto'
};

var taskButtonBorderedStyle = _objectSpread(_objectSpread({}, taskButtonStyle), {}, {
  display: 'flex',
  padding: '0.25rem 0.9375rem',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.5rem',
  borderRadius: '0.25rem',
  border: '1px solid #394EFF'
});

var taskButtonsRow = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  boxSizing: 'border-box'
};
var spinnerStyles = {
  border: '4px solid rgba(255, 255, 255, 0.4)',
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  borderLeftColor: '#fff',
  animation: 'spin 0.5s linear infinite'
};
var Quality = {
  Standard: {
    width: 1280,
    height: 720
  },
  High: {
    width: 1920,
    height: 1080
  }
};

var Recorder = /*#__PURE__*/function () {
  function Recorder(app) {
    _classCallCheck(this, Recorder);

    this.app = app;
    this.mediaRecorder = null;
    this.recordedChunks = [];
    this.stream = null;
    this.recStartTs = null;
  }

  _createClass(Recorder, [{
    key: "startRecording",
    value: function () {
      var _startRecording = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fps, quality, micReq, camReq) {
        var _this16 = this;

        var videoConstraints;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.recStartTs = this.app.timestamp();
              videoConstraints = quality;
              _context4.prev = 2;
              _context4.next = 5;
              return navigator.mediaDevices.getUserMedia({
                video: camReq ? _objectSpread(_objectSpread({}, videoConstraints), {}, {
                  frameRate: {
                    ideal: fps
                  }
                }) : false,
                audio: micReq
              });

            case 5:
              this.stream = _context4.sent;
              this.mediaRecorder = new MediaRecorder(this.stream, {
                mimeType: 'video/webm;codecs=vp9'
              });
              this.recordedChunks = [];

              this.mediaRecorder.ondataavailable = function (event) {
                if (event.data.size > 0) {
                  _this16.recordedChunks.push(event.data);
                }
              };

              this.mediaRecorder.start();
              _context4.next = 15;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](2);
              console.error(_context4.t0);

            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 12]]);
      }));

      function startRecording(_x6, _x7, _x8, _x9) {
        return _startRecording.apply(this, arguments);
      }

      return startRecording;
    }()
  }, {
    key: "stopRecording",
    value: function () {
      var _stopRecording = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this17 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", new Promise(function (resolve) {
                if (!_this17.mediaRecorder) return;

                _this17.mediaRecorder.onstop = function () {
                  var blob = new Blob(_this17.recordedChunks, {
                    type: 'video/webm'
                  });
                  resolve(blob);
                };

                _this17.mediaRecorder.stop();
              }));

            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));

      function stopRecording() {
        return _stopRecording.apply(this, arguments);
      }

      return stopRecording;
    }()
  }, {
    key: "sendToAPI",
    value: function () {
      var _sendToAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this18 = this;

        var blob;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.stopRecording();

            case 2:
              blob = _context6.sent;
              return _context6.abrupt("return", fetch("".concat(this.app.options.ingestPoint, "/v1/web/uxt/upload-url"), {
                headers: {
                  Authorization: "Bearer ".concat(this.app.session.getSessionToken())
                }
              }).then(function (r) {
                if (r.ok) {
                  return r.json();
                } else {
                  throw new Error('Failed to get upload url');
                }
              }).then(function (_ref2) {
                var url = _ref2.url;
                return fetch(url, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'video/webm'
                  },
                  body: blob
                });
              }).catch(console.error).finally(function () {
                _this18.discard();
              }));

            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));

      function sendToAPI() {
        return _sendToAPI.apply(this, arguments);
      }

      return sendToAPI;
    }()
  }, {
    key: "saveToFile",
    value: function () {
      var _saveToFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var fileName,
            blob,
            url,
            a,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              fileName = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 'recorded-video.webm';
              _context7.next = 3;
              return this.stopRecording();

            case 3:
              blob = _context7.sent;
              url = URL.createObjectURL(blob);
              a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a);

            case 13:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));

      function saveToFile() {
        return _saveToFile.apply(this, arguments);
      }

      return saveToFile;
    }()
  }, {
    key: "discard",
    value: function discard() {
      var _this$mediaRecorder, _this$stream;

      (_this$mediaRecorder = this.mediaRecorder) === null || _this$mediaRecorder === void 0 ? void 0 : _this$mediaRecorder.stop();
      (_this$stream = this.stream) === null || _this$stream === void 0 ? void 0 : _this$stream.getTracks().forEach(function (track) {
        return track.stop();
      });
    }
  }]);

  return Recorder;
}(); // @ts-nocheck


function attachDND(element, dragTarget) {
  dragTarget.onmousedown = function (event) {
    var clientRect = element.getBoundingClientRect();
    var shiftX = event.clientX - clientRect.left;
    var shiftY = event.clientY - clientRect.top;
    element.style.position = 'fixed';
    element.style.zIndex = 99999999999999;
    moveAt(event.pageX, event.pageY);

    function moveAt(pageX, pageY) {
      var leftC = pageX - shiftX;
      var topC = pageY - shiftY;
      if (leftC <= 5) leftC = 5;
      if (topC <= 5) topC = 5;
      if (leftC >= window.innerWidth - clientRect.width) leftC = window.innerWidth - clientRect.width;
      if (topC >= window.innerHeight - clientRect.height) topC = window.innerHeight - clientRect.height;
      element.style.left = "".concat(leftC, "px");
      element.style.top = "".concat(topC, "px");
    }

    function onMouseMove(event) {
      moveAt(event.pageX, event.pageY);
    }

    document.addEventListener('mousemove', onMouseMove);

    var clearAll = function clearAll() {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', clearAll);
    };

    document.addEventListener('mouseup', clearAll);
  };

  dragTarget.ondragstart = function () {
    return false;
  };
}

function generateGrid() {
  var grid = document.createElement('div');
  grid.className = 'grid';

  for (var _i2 = 0; _i2 < 16; _i2++) {
    var cell = document.createElement('div');
    Object.assign(cell.style, {
      width: '2px',
      height: '2px',
      borderRadius: '10px',
      background: 'white'
    });
    cell.className = 'cell';
    grid.appendChild(cell);
  }

  Object.assign(grid.style, {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    gap: '2px',
    cursor: 'grab'
  });
  return grid;
}

function generateChevron() {
  var triangle = document.createElement('div');
  Object.assign(triangle.style, {
    width: '0',
    height: '0',
    borderLeft: '7px solid transparent',
    borderRight: '7px solid transparent',
    borderBottom: '7px solid white'
  });
  var container = document.createElement('div');
  container.appendChild(triangle);
  Object.assign(container.style, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
    cursor: 'pointer',
    marginLeft: 'auto',
    transform: 'rotate(180deg)'
  });
  return container;
}

function addKeyframes() {
  var styleSheet = document.createElement('style');
  styleSheet.type = 'text/css';
  styleSheet.innerText = "@keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }";
  document.head.appendChild(styleSheet);
}

function createSpinner() {
  addKeyframes();
  var spinner = document.createElement('div');
  spinner.classList.add('spinner');
  Object.assign(spinner.style, spinnerStyles);
  return spinner;
}

function createElement(tag, className, styles, textContent, id) {
  var element = document.createElement(tag);
  element.className = className;
  Object.assign(element.style, styles);

  if (textContent) {
    element.textContent = textContent;
  }

  if (id) {
    element.id = id;
  }

  return element;
}

var TEST_START = 'or_uxt_test_start';
var TASK_IND = 'or_uxt_task_index';
var SESSION_ID = 'or_uxt_session_id';
var TEST_ID = 'or_uxt_test_id';

var SignalManager = /*#__PURE__*/_createClass(function SignalManager(ingestPoint, getTimestamp, token, testId, storageKey, setStorageKey, removeStorageKey, getStorageKey, getSessionId) {
  var _this19 = this;

  _classCallCheck(this, SignalManager);

  this.ingestPoint = ingestPoint;
  this.getTimestamp = getTimestamp;
  this.token = token;
  this.testId = testId;
  this.storageKey = storageKey;
  this.setStorageKey = setStorageKey;
  this.removeStorageKey = removeStorageKey;
  this.getStorageKey = getStorageKey;
  this.getSessionId = getSessionId;
  this.durations = {
    testStart: 0,
    tasks: []
  };

  this.getDurations = function () {
    return _this19.durations;
  };

  this.setDurations = function (durations) {
    _this19.durations.testStart = durations.testStart;
    _this19.durations.tasks = durations.tasks;
  };

  this.signalTask = function (taskId, status, taskAnswer) {
    if (!taskId) return console.error('User Testing: No Task ID Given');

    var taskStart = _this19.durations.tasks.find(function (t) {
      return t.taskId === taskId;
    });

    var timestamp = _this19.getTimestamp();

    var duration = taskStart ? timestamp - taskStart.started : 0;
    return fetch("".concat(_this19.ingestPoint, "/v1/web/uxt/signals/task"), {
      method: 'POST',
      headers: {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        Authorization: "Bearer ".concat(_this19.token)
      },
      body: JSON.stringify({
        testId: _this19.testId,
        taskId: taskId,
        status: status,
        duration: duration,
        timestamp: timestamp,
        taskAnswer: taskAnswer
      })
    });
  };

  this.signalTest = function (status) {
    var timestamp = _this19.getTimestamp();

    if (status === 'begin' && _this19.testId) {
      var sessionId = _this19.getSessionId();

      _this19.setStorageKey(SESSION_ID, sessionId);

      _this19.setStorageKey(_this19.storageKey, _this19.testId.toString());

      _this19.setStorageKey(TEST_START, timestamp.toString());
    } else {
      _this19.removeStorageKey(_this19.storageKey);

      _this19.removeStorageKey(TASK_IND);

      _this19.removeStorageKey(TEST_START);
    }

    var start = _this19.durations.testStart || timestamp;
    var duration = timestamp - start;
    return fetch("".concat(_this19.ingestPoint, "/v1/web/uxt/signals/test"), {
      method: 'POST',
      headers: {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        Authorization: "Bearer ".concat(_this19.token)
      },
      body: JSON.stringify({
        testId: _this19.testId,
        status: status,
        duration: duration,
        timestamp: timestamp
      })
    });
  };

  var possibleStart = this.getStorageKey(TEST_START);

  if (possibleStart) {
    this.durations.testStart = parseInt(possibleStart, 10);
  }
});

var UserTestManager = /*#__PURE__*/function () {
  function UserTestManager(app, storageKey) {
    var _this20 = this;

    _classCallCheck(this, UserTestManager);

    this.app = app;
    this.storageKey = storageKey;
    this.bg = createElement('div', 'bg', bgStyle, undefined, '__or_ut_bg');
    this.container = createElement('div', 'container', containerStyle, undefined, '__or_ut_ct');
    this.widgetGuidelinesVisible = true;
    this.widgetTasksVisible = false;
    this.widgetVisible = true;
    this.isActive = false;
    this.descriptionSection = null;
    this.taskSection = null;
    this.endSection = null;
    this.stopButton = null;
    this.stopButtonContainer = null;
    this.test = null;
    this.testId = null;
    this.signalManager = null;

    this.getTest = function (id, token, inProgress) {
      _this20.testId = id;
      var ingest = _this20.app.options.ingestPoint;
      return fetch("".concat(ingest, "/v1/web/uxt/test/").concat(id), {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }).then(function (res) {
        return res.json();
      }).then(function (_ref3) {
        var test = _ref3.test;
        _this20.isActive = true;
        _this20.test = test;
        _this20.signalManager = new SignalManager(_this20.app.options.ingestPoint, function () {
          return _this20.app.timestamp();
        }, token, id, _this20.storageKey, function (k, v) {
          return _this20.app.localStorage.setItem(k, v);
        }, function (k) {
          return _this20.app.localStorage.removeItem(k);
        }, function (k) {
          return _this20.app.localStorage.getItem(k);
        }, function () {
          return _this20.app.getSessionID();
        });

        _this20.createGreeting(test.title, test.reqMic, test.reqCamera);

        if (inProgress) {
          if (test.reqMic || test.reqCamera) {
            void _this20.userRecorder.startRecording(30, Quality.Standard, test.reqMic, test.reqCamera);
          }

          _this20.showWidget(test.description, test.tasks, true);

          _this20.showTaskSection();
        }
      }).then(function () {
        return id;
      }).catch(function (err) {
        console.log('OR: Error fetching test', err);
      });
    };

    this.hideTaskSection = function () {
      return false;
    };

    this.showTaskSection = function () {
      return true;
    };

    this.collapseWidget = function () {
      return false;
    };

    this.removeGreeting = function () {
      return false;
    }; // eslint-disable-next-line @typescript-eslint/no-empty-function


    this.toggleDescriptionVisibility = function () {};

    this.currentTaskIndex = 0;
    this.userRecorder = new Recorder(app);
    var sessionId = this.app.getSessionID();
    var savedSessionId = this.app.localStorage.getItem(SESSION_ID);

    if (sessionId !== savedSessionId) {
      this.app.localStorage.removeItem(this.storageKey);
      this.app.localStorage.removeItem(SESSION_ID);
      this.app.localStorage.removeItem(TEST_ID);
      this.app.localStorage.removeItem(TASK_IND);
      this.app.localStorage.removeItem(TEST_START);
    }

    var taskIndex = this.app.localStorage.getItem(TASK_IND);

    if (taskIndex) {
      this.currentTaskIndex = parseInt(taskIndex, 10);
    }
  }

  _createClass(UserTestManager, [{
    key: "getTestId",
    value: function getTestId() {
      return this.testId;
    }
  }, {
    key: "createGreeting",
    value: function createGreeting(title, micRequired, cameraRequired) {
      var _this21 = this;

      var titleElement = createElement('div', 'title', titleStyle, title);
      var descriptionElement = createElement('div', 'description', descriptionStyle, "Welcome, you're here to help us improve, not to be judged. Your insights matter!\n\n\uD83D\uDCF9 We're recording this browser tab to learn from your experience.\n\uD83C\uDFA4 Please enable mic and camera if asked, to give us a complete picture.");
      var buttonElement = createElement('div', 'button', buttonStyle, 'Read guidelines to begin');

      this.removeGreeting = function () {
        // this.container.innerHTML = ''
        if (micRequired || cameraRequired) {
          void _this21.userRecorder.startRecording(30, Quality.Standard, micRequired, cameraRequired);
        }

        _this21.container.removeChild(buttonElement);

        _this21.container.removeChild(descriptionElement);

        _this21.container.removeChild(titleElement);

        return false;
      };

      buttonElement.onclick = function () {
        var _this21$signalManager, _this21$signalManager2, _this21$test, _this21$test2;

        _this21.removeGreeting();

        var durations = (_this21$signalManager = _this21.signalManager) === null || _this21$signalManager === void 0 ? void 0 : _this21$signalManager.getDurations();

        if (durations && _this21.signalManager) {
          durations.testStart = _this21.app.timestamp();

          _this21.signalManager.setDurations(durations);
        }

        void ((_this21$signalManager2 = _this21.signalManager) === null || _this21$signalManager2 === void 0 ? void 0 : _this21$signalManager2.signalTest('begin'));
        _this21.container.style.fontFamily = "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
        Object.assign(_this21.container.style, containerWidgetStyle);

        _this21.showWidget(((_this21$test = _this21.test) === null || _this21$test === void 0 ? void 0 : _this21$test.guidelines) || '', ((_this21$test2 = _this21.test) === null || _this21$test2 === void 0 ? void 0 : _this21$test2.tasks) || []);
      };

      this.container.append(titleElement, descriptionElement, buttonElement);
      this.bg.appendChild(this.container);
      document.body.appendChild(this.bg);
    }
  }, {
    key: "showWidget",
    value: function showWidget(guidelines, tasks, inProgress) {
      var _this22 = this;

      this.container.innerHTML = '';
      Object.assign(this.bg.style, {
        position: 'fixed',
        zIndex: 99999999999999,
        right: '8px',
        left: 'unset',
        width: 'fit-content',
        top: '8px',
        height: 'fit-content',
        background: 'unset',
        display: 'unset',
        alignItems: 'unset',
        justifyContent: 'unset'
      }); // Create title section

      var titleSection = this.createTitleSection();
      this.container.style.fontFamily = "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
      Object.assign(this.container.style, containerWidgetStyle);
      var descriptionSection = this.createDescriptionSection(guidelines);
      var tasksSection = this.createTasksSection(tasks);
      var stopButton = createElement('div', 'stop_bn_or', stopWidgetStyle, 'Abort Session');
      var stopContainer = createElement('div', 'stop_ct_or', {
        fontSize: '13px!important'
      });
      stopContainer.style.fontSize = '13px';
      stopContainer.append(stopButton);
      this.container.append(titleSection, descriptionSection, tasksSection, stopContainer);
      this.taskSection = tasksSection;
      this.descriptionSection = descriptionSection;
      this.stopButton = stopButton;
      this.stopButtonContainer = stopContainer;

      stopButton.onclick = function () {
        var _this22$signalManager;

        _this22.userRecorder.discard();

        void ((_this22$signalManager = _this22.signalManager) === null || _this22$signalManager === void 0 ? void 0 : _this22$signalManager.signalTest('skipped'));
        document.body.removeChild(_this22.bg);
        window.close();
      };

      if (!inProgress) {
        this.hideTaskSection();
      } else {
        this.toggleDescriptionVisibility();
      }
    }
  }, {
    key: "createTitleSection",
    value: function createTitleSection() {
      var _this$test,
          _this23 = this;

      var title = createElement('div', 'title', titleWidgetStyle);
      var leftIcon = generateGrid();
      var titleText = createElement('div', 'title_text', {
        maxWidth: '19rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
        fontSize: 16,
        lineHeight: 'auto',
        cursor: 'pointer'
      }, (_this$test = this.test) === null || _this$test === void 0 ? void 0 : _this$test.title);
      var rightIcon = generateChevron();
      title.append(leftIcon, titleText, rightIcon);

      var toggleWidget = function toggleWidget(isVisible) {
        _this23.widgetVisible = isVisible;
        _this23.container.style.fontFamily = "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
        Object.assign(_this23.container.style, _this23.widgetVisible ? containerWidgetStyle : {
          border: 'none',
          background: 'none',
          padding: 0
        });

        if (_this23.taskSection) {
          Object.assign(_this23.taskSection.style, _this23.widgetVisible ? descriptionWidgetStyle : {
            display: 'none'
          });
        }

        if (_this23.descriptionSection) {
          Object.assign(_this23.descriptionSection.style, _this23.widgetVisible ? descriptionWidgetStyle : {
            display: 'none'
          });
        }

        if (_this23.endSection) {
          Object.assign(_this23.endSection.style, _this23.widgetVisible ? descriptionWidgetStyle : {
            display: 'none'
          });
        }

        if (_this23.stopButton) {
          Object.assign(_this23.stopButton.style, _this23.widgetVisible ? stopWidgetStyle : {
            display: 'none'
          });
        }

        return isVisible;
      };

      var collapseWidget = function collapseWidget() {
        Object.assign(rightIcon.style, {
          transform: _this23.widgetVisible ? 'rotate(0deg)' : 'rotate(180deg)'
        });
        toggleWidget(!_this23.widgetVisible);
      };

      titleText.onclick = collapseWidget;
      rightIcon.onclick = collapseWidget;
      attachDND(this.bg, leftIcon);

      this.collapseWidget = function () {
        return toggleWidget(false);
      };

      return title;
    }
  }, {
    key: "createDescriptionSection",
    value: function createDescriptionSection(guidelines) {
      var _this24 = this;

      var section = createElement('div', 'description_section_or', descriptionWidgetStyle);
      var titleContainer = createElement('div', 'description_s_title_or', sectionTitleStyle);
      var title = createElement('div', 'title', {
        fontSize: 13,
        fontWeight: 500,
        lineHeight: 'auto'
      }, 'Introduction & Guidelines');
      var icon = createElement('div', 'icon', symbolIcon, '-');
      var content = createElement('div', 'content', contentStyle);
      var descriptionC = createElement('div', 'text_description', {
        maxHeight: '250px',
        overflowY: 'auto',
        whiteSpace: 'pre-wrap',
        fontSize: 13,
        color: '#454545',
        lineHeight: 'auto'
      });
      descriptionC.innerHTML = guidelines;
      var button = createElement('div', 'button_begin_or', buttonWidgetStyle, 'Begin Test');
      titleContainer.append(title, icon);
      content.append(descriptionC, button);
      section.append(titleContainer, content);

      var toggleDescriptionVisibility = function toggleDescriptionVisibility() {
        _this24.widgetGuidelinesVisible = !_this24.widgetGuidelinesVisible;
        icon.textContent = _this24.widgetGuidelinesVisible ? '-' : '+';
        Object.assign(content.style, _this24.widgetGuidelinesVisible ? contentStyle : {
          display: 'none'
        });
      };

      titleContainer.onclick = toggleDescriptionVisibility;

      this.toggleDescriptionVisibility = function () {
        _this24.widgetGuidelinesVisible = false;
        icon.textContent = _this24.widgetGuidelinesVisible ? '-' : '+';
        Object.assign(content.style, _this24.widgetGuidelinesVisible ? contentStyle : {
          display: 'none'
        });
        content.removeChild(button);
      };

      button.onclick = function () {
        toggleDescriptionVisibility();

        if (_this24.test) {
          var _this24$signalManager, _this24$signalManager3;

          var durations = (_this24$signalManager = _this24.signalManager) === null || _this24$signalManager === void 0 ? void 0 : _this24$signalManager.getDurations();
          var taskDurationInd = durations ? durations.tasks.findIndex(function (t) {
            return _this24.test && t.taskId === _this24.test.tasks[0].task_id;
          }) : null;

          if (durations && taskDurationInd === -1) {
            var _this24$signalManager2;

            durations.tasks.push({
              taskId: _this24.test.tasks[0].task_id,
              started: _this24.app.timestamp()
            });
            (_this24$signalManager2 = _this24.signalManager) === null || _this24$signalManager2 === void 0 ? void 0 : _this24$signalManager2.setDurations(durations);
          }

          void ((_this24$signalManager3 = _this24.signalManager) === null || _this24$signalManager3 === void 0 ? void 0 : _this24$signalManager3.signalTask(_this24.test.tasks[0].task_id, 'begin'));
        }

        _this24.showTaskSection();

        content.removeChild(button);
      };

      return section;
    }
  }, {
    key: "createTasksSection",
    value: function createTasksSection(tasks) {
      var _this25 = this;

      this.container.style.fontFamily = "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
      Object.assign(this.container.style, containerWidgetStyle);
      var section = createElement('div', 'task_section_or', descriptionWidgetStyle);
      var titleContainer = createElement('div', 'description_t_title_or', sectionTitleStyle);
      var title = createElement('div', 'title', {
        fontSize: '13px',
        fontWeight: '500',
        lineHeight: 'auto'
      }, 'Tasks');
      var icon = createElement('div', 'icon', symbolIcon, '-');
      var content = createElement('div', 'content', contentStyle);
      var pagination = createElement('div', 'pagination', paginationStyle); // const leftArrow = createElement('span', 'leftArrow', {}, '<')
      // const rightArrow = createElement('span', 'rightArrow', {}, '>')

      var taskCard = createElement('div', 'taskCard', taskDescriptionCard);
      var taskText = createElement('div', 'taskText', taskTextStyle);
      var taskDescription = createElement('div', 'taskDescription', taskDescriptionStyle);
      var taskButtons = createElement('div', 'taskButtons', taskButtonsRow);
      var inputTitle = createElement('div', 'taskText', taskTextStyle);
      inputTitle.textContent = 'Your answer';
      var inputArea = createElement('textarea', 'taskDescription', {
        resize: 'vertical'
      });
      var inputContainer = createElement('div', 'inputArea', taskDescriptionCard);
      inputContainer.append(inputTitle, inputArea);
      var closePanelButton = createElement('div', 'closePanelButton', taskButtonStyle, 'Collapse Panel');
      var nextButton = createElement('div', 'nextButton', taskButtonBorderedStyle, 'Done, Next');
      titleContainer.append(title, icon);
      taskCard.append(taskText, taskDescription);
      taskButtons.append(closePanelButton, nextButton);
      content.append(pagination, taskCard, inputContainer, taskButtons);
      section.append(titleContainer, content);

      var updateTaskContent = function updateTaskContent() {
        var task = tasks[_this25.currentTaskIndex];
        taskText.textContent = task.title;
        taskDescription.textContent = task.description;

        if (task.allow_typing) {
          inputContainer.style.display = 'flex';
        } else {
          inputContainer.style.display = 'none';
        }
      }; // pagination.appendChild(leftArrow)


      tasks.forEach(function (_, index) {
        var pageNumber = createElement('span', "or_task_".concat(index), {
          outline: '1px solid #efefef',
          fontSize: '13px',
          height: '24px',
          width: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '6.25em'
        }, (index + 1).toString());
        pageNumber.id = "or_task_".concat(index);
        pagination.append(pageNumber);
      }); // pagination.appendChild(rightArrow)

      var toggleTasksVisibility = function toggleTasksVisibility() {
        _this25.widgetTasksVisible = !_this25.widgetTasksVisible;
        icon.textContent = _this25.widgetTasksVisible ? '-' : '+';
        Object.assign(content.style, _this25.widgetTasksVisible ? contentStyle : {
          display: 'none'
        });
      };

      this.hideTaskSection = function () {
        icon.textContent = '+';
        Object.assign(content.style, {
          display: 'none'
        });
        _this25.widgetTasksVisible = false;
        return false;
      };

      this.showTaskSection = function () {
        icon.textContent = '-';
        Object.assign(content.style, contentStyle);
        _this25.widgetTasksVisible = true;
        return true;
      };

      var highlightActive = function highlightActive() {
        var activeTaskEl = document.getElementById("or_task_".concat(_this25.currentTaskIndex));

        if (activeTaskEl) {
          Object.assign(activeTaskEl.style, taskNumberActive);
        }

        for (var _i4 = 0; _i4 < _this25.currentTaskIndex; _i4++) {
          var taskEl = document.getElementById("or_task_".concat(_i4));

          if (taskEl) {
            Object.assign(taskEl.style, taskNumberDone);
          }
        }
      };

      titleContainer.onclick = toggleTasksVisibility;
      closePanelButton.onclick = this.collapseWidget;

      nextButton.onclick = function () {
        var _this25$signalManager;

        var textAnswer = tasks[_this25.currentTaskIndex].allow_typing ? inputArea.value : undefined;
        inputArea.value = '';
        void ((_this25$signalManager = _this25.signalManager) === null || _this25$signalManager === void 0 ? void 0 : _this25$signalManager.signalTask(tasks[_this25.currentTaskIndex].task_id, 'done', textAnswer));

        if (_this25.currentTaskIndex < tasks.length - 1) {
          var _this25$signalManager2, _this25$signalManager4;

          _this25.currentTaskIndex++;
          updateTaskContent();
          var durations = (_this25$signalManager2 = _this25.signalManager) === null || _this25$signalManager2 === void 0 ? void 0 : _this25$signalManager2.getDurations();

          if (durations && durations.tasks.findIndex(function (t) {
            return t.taskId === tasks[_this25.currentTaskIndex].task_id;
          }) === -1) {
            var _this25$signalManager3;

            durations.tasks.push({
              taskId: tasks[_this25.currentTaskIndex].task_id,
              started: _this25.app.timestamp()
            });
            (_this25$signalManager3 = _this25.signalManager) === null || _this25$signalManager3 === void 0 ? void 0 : _this25$signalManager3.setDurations(durations);
          }

          void ((_this25$signalManager4 = _this25.signalManager) === null || _this25$signalManager4 === void 0 ? void 0 : _this25$signalManager4.signalTask(tasks[_this25.currentTaskIndex].task_id, 'begin'));
          highlightActive();
        } else {
          _this25.showEndSection();
        }

        _this25.app.localStorage.setItem('or_uxt_task_index', _this25.currentTaskIndex.toString());
      };

      setTimeout(function () {
        var firstTaskEl = document.getElementById('or_task_0');

        if (firstTaskEl) {
          Object.assign(firstTaskEl.style, taskNumberActive);
        }

        updateTaskContent();
        highlightActive();
      }, 1);
      return section;
    }
  }, {
    key: "showEndSection",
    value: function showEndSection() {
      var _this$signalManager,
          _this$test$conclusion,
          _this$test2,
          _this$test3,
          _this$test4,
          _this26 = this;

      var isLoading = true;
      void ((_this$signalManager = this.signalManager) === null || _this$signalManager === void 0 ? void 0 : _this$signalManager.signalTest('done'));
      var section = createElement('div', 'end_section_or', endSectionStyle);
      var title = createElement('div', 'end_title_or', {
        fontSize: '1.25rem',
        fontWeight: '500'
      }, 'Thank you! 👍');
      var description = createElement('div', 'end_description_or', {}, (_this$test$conclusion = (_this$test2 = this.test) === null || _this$test2 === void 0 ? void 0 : _this$test2.conclusion) !== null && _this$test$conclusion !== void 0 ? _this$test$conclusion : 'Thank you for participating in our usability test. Your feedback has been captured and will be used to enhance our website. \n' + '\n' + 'We appreciate your time and valuable input.');
      var button = createElement('div', 'end_button_or', buttonWidgetStyle, 'Submitting Feedback');
      var spinner = createSpinner();
      button.appendChild(spinner);

      if ((_this$test3 = this.test) !== null && _this$test3 !== void 0 && _this$test3.reqMic || (_this$test4 = this.test) !== null && _this$test4 !== void 0 && _this$test4.reqCamera) {
        void this.userRecorder.sendToAPI().then(function () {
          button.removeChild(spinner);
          button.textContent = 'End Session';
          isLoading = false;
        }).catch(function (err) {
          console.error(err);
          button.removeChild(spinner);
          button.textContent = 'End Session';
          isLoading = false;
        });
      } else {
        button.removeChild(spinner);
        button.textContent = 'End Session';
        isLoading = false;
      }

      if (this.taskSection) {
        this.container.removeChild(this.taskSection);
      }

      if (this.descriptionSection) {
        this.container.removeChild(this.descriptionSection);
      }

      if (this.stopButton && this.stopButtonContainer) {
        this.container.removeChild(this.stopButtonContainer);
      }

      button.onclick = function () {
        if (isLoading) return;
        window.close();
        document.body.removeChild(_this26.bg);
      };

      section.append(title, description, button);
      this.endSection = section;
      this.container.append(section);
    }
  }]);

  return UserTestManager;
}(); //@ts-ignore


function isNode(sth) {
  return !!sth && sth.nodeType != null;
}

function isSVGElement(node) {
  return node.namespaceURI === 'http://www.w3.org/2000/svg';
}

function isElementNode(node) {
  return node.nodeType === Node.ELEMENT_NODE;
}

function isCommentNode(node) {
  return node.nodeType === Node.COMMENT_NODE;
}

function isTextNode(node) {
  return node.nodeType === Node.TEXT_NODE;
}

function isDocument(node) {
  return node.nodeType === Node.DOCUMENT_NODE;
}

function isRootNode(node) {
  return node.nodeType === Node.DOCUMENT_NODE || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}

function hasTag(el, tagName) {
  // @ts-ignore
  return el.localName === tagName;
}

var CanvasRecorder = /*#__PURE__*/function () {
  function CanvasRecorder(app, options) {
    var _this27 = this,
        _options$fileExt;

    _classCallCheck(this, CanvasRecorder);

    this.app = app;
    this.options = options;
    this.snapshots = {};
    this.intervals = [];

    this.restartTracking = function () {
      _this27.clear();

      _this27.app.nodes.scanTree(_this27.captureCanvas);
    };

    this.captureCanvas = function (node) {
      var id = _this27.app.nodes.getID(node);

      if (!id || !hasTag(node, 'canvas')) {
        return;
      }

      var isIgnored = _this27.app.sanitizer.isObscured(id) || _this27.app.sanitizer.isHidden(id);

      if (isIgnored || !hasTag(node, 'canvas') || _this27.snapshots[id]) {
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (entry.target) {
              if (_this27.snapshots[id] && _this27.snapshots[id].createdAt) {
                _this27.snapshots[id].paused = false;
              } else {
                _this27.recordCanvas(entry.target, id);
              }
              /**
               * We can switch this to start observing when element is in the view
               * but otherwise right now we're just pausing when it's not
               * just to save some bandwidth and space on backend
               * */
              // observer.unobserve(entry.target)

            } else {
              if (_this27.snapshots[id]) {
                _this27.snapshots[id].paused = true;
              }
            }
          }
        });
      });
      observer.observe(node);
    };

    this.recordCanvas = function (node, id) {
      var ts = _this27.app.timestamp();

      _this27.snapshots[id] = {
        images: [],
        createdAt: ts,
        paused: false,
        dummy: document.createElement('canvas')
      };
      var canvasMsg = CanvasNode(id.toString(), ts);

      _this27.app.send(canvasMsg);

      var captureFn = function captureFn(canvas) {
        captureSnapshot(canvas, _this27.options.quality, _this27.snapshots[id].dummy, _this27.options.fixedScaling, _this27.fileExt, function (blob) {
          if (!blob) return;

          if (!_this27.snapshots[id]) {
            return _this27.app.debug.warn('Canvas not present in snapshots after capture:', _this27.snapshots, id);
          }

          _this27.snapshots[id].images.push({
            id: _this27.app.timestamp(),
            data: blob
          });

          if (_this27.snapshots[id].images.length > 9) {
            _this27.sendSnaps(_this27.snapshots[id].images, id, _this27.snapshots[id].createdAt);

            _this27.snapshots[id].images = [];
          }
        });
      };

      var int = setInterval(function () {
        var cid = _this27.app.nodes.getID(node);

        var canvas = cid ? _this27.app.nodes.getNode(cid) : undefined;

        if (!_this27.snapshots[id]) {
          _this27.app.debug.log('Canvas is not present in {snapshots}');

          clearInterval(int);
          return;
        }

        if (!canvas || !hasTag(canvas, 'canvas') || canvas !== node) {
          _this27.app.debug.log('Canvas element not in sync', canvas, node);

          clearInterval(int);
          return;
        } else {
          if (!_this27.snapshots[id].paused) {
            if (_this27.options.useAnimationFrame) {
              requestAnimationFrame(function () {
                captureFn(canvas);
              });
            } else {
              captureFn(canvas);
            }
          }
        }
      }, _this27.interval);

      _this27.intervals.push(int);
    };

    this.fileExt = (_options$fileExt = options.fileExt) !== null && _options$fileExt !== void 0 ? _options$fileExt : 'webp';
    this.interval = 1000 / options.fps;
  }

  _createClass(CanvasRecorder, [{
    key: "startTracking",
    value: function startTracking() {
      var _this28 = this;

      setTimeout(function () {
        _this28.app.nodes.scanTree(_this28.captureCanvas);

        _this28.app.nodes.attachNodeCallback(_this28.captureCanvas);
      }, 250);
    }
  }, {
    key: "sendSnaps",
    value: function sendSnaps(images, canvasId, createdAt) {
      var _this29 = this,
          _this$app$session$get;

      if (Object.keys(this.snapshots).length === 0) {
        return;
      }

      var formData = new FormData();
      images.forEach(function (snapshot) {
        var blob = snapshot.data;
        if (!blob) return;
        formData.append('snapshot', blob, "".concat(createdAt, "_").concat(canvasId, "_").concat(snapshot.id, ".").concat(_this29.fileExt));

        if (_this29.options.isDebug) {
          saveImageData(blob, "".concat(createdAt, "_").concat(canvasId, "_").concat(snapshot.id, ".").concat(_this29.fileExt));
        }
      });

      var initRestart = function initRestart() {
        _this29.app.debug.log('Restarting tracker; token expired');

        _this29.app.stop(false);

        setTimeout(function () {
          void _this29.app.start({}, true);
        }, 250);
      };

      fetch(this.app.options.ingestPoint + '/v1/web/images', {
        method: 'POST',
        headers: {
          Authorization: "Bearer ".concat((_this$app$session$get = this.app.session.getSessionToken()) !== null && _this$app$session$get !== void 0 ? _this$app$session$get : '')
        },
        body: formData
      }).then(function (r) {
        if (r.status === 401) {
          return initRestart();
        }

        return true;
      }).catch(function (e) {
        _this29.app.debug.error('error saving canvas', e);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.intervals.forEach(function (int) {
        return clearInterval(int);
      });
      this.snapshots = {};
    }
  }]);

  return CanvasRecorder;
}();

var qualityInt = {
  low: 0.35,
  medium: 0.55,
  high: 0.8
};

function captureSnapshot(canvas) {
  var quality = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'medium';
  var dummy = arguments.length > 2 ? arguments[2] : undefined;
  var fixedScaling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var fileExt = arguments.length > 4 ? arguments[4] : undefined;
  var onBlob = arguments.length > 5 ? arguments[5] : undefined;
  var imageFormat = "image/".concat(fileExt);

  if (fixedScaling) {
    var canvasScaleRatio = window.devicePixelRatio || 1;
    dummy.width = canvas.width / canvasScaleRatio;
    dummy.height = canvas.height / canvasScaleRatio;
    var ctx = dummy.getContext('2d');

    if (!ctx) {
      return '';
    }

    ctx.clearRect(0, 0, dummy.width, dummy.height);
    ctx.drawImage(canvas, 0, 0, dummy.width, dummy.height);
    dummy.toBlob(onBlob, imageFormat, qualityInt[quality]);
  } else {
    canvas.toBlob(onBlob, imageFormat, qualityInt[quality]);
  }
}

function saveImageData(imageDataBlob, name) {
  var imageDataUrl = URL.createObjectURL(imageDataBlob);
  var link = document.createElement('a');
  link.href = imageDataUrl;
  link.download = name;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

var LogLevel = {
  Verbose: 5,
  Log: 4,
  Warnings: 3,
  Errors: 2,
  Silent: 0
};

var Logger = /*#__PURE__*/_createClass(function Logger() {
  var _this30 = this;

  var debugLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LogLevel.Silent;

  _classCallCheck(this, Logger);

  this.shouldLog = function (level) {
    return _this30.level >= level;
  };

  this.info = function () {
    if (_this30.shouldLog(LogLevel.Verbose)) {
      var _console;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      (_console = console).info.apply(_console, arguments);
    }
  };

  this.log = function () {
    if (_this30.shouldLog(LogLevel.Log)) {
      var _console2;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      (_console2 = console).log.apply(_console2, arguments);
    }
  };

  this.warn = function () {
    if (_this30.shouldLog(LogLevel.Warnings)) {
      var _console3;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      (_console3 = console).warn.apply(_console3, arguments);
    }
  };

  this.error = function () {
    if (_this30.shouldLog(LogLevel.Errors)) {
      var _console4;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      (_console4 = console).error.apply(_console4, arguments);
    }
  };

  this.level = debugLevel;
});

var SECOND = 1000;

function processMapInBatches(map, batchSize, processBatchCallback) {
  var iterator = map.entries();

  function processNextBatch() {
    var batch = [];
    var result = iterator.next();

    while (!result.done && batch.length < batchSize) {
      batch.push(result.value);
      result = iterator.next();
    }

    if (batch.length > 0) {
      batch.forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            _ = _ref5[0],
            node = _ref5[1];

        if (node) {
          processBatchCallback(node);
        }
      });
      setTimeout(processNextBatch, 50);
    }
  }

  processNextBatch();
}

function isNodeStillActive(node) {
  try {
    var _node$ownerDocument;

    if (!node.isConnected) {
      return [false, 'not connected'];
    }

    var nodeIsDocument = node.nodeType === Node.DOCUMENT_NODE;
    var nodeWindow = nodeIsDocument ? node.defaultView : (_node$ownerDocument = node.ownerDocument) === null || _node$ownerDocument === void 0 ? void 0 : _node$ownerDocument.defaultView;
    var ownerDoc = nodeIsDocument ? node : node.ownerDocument;

    if (!nodeWindow) {
      return [false, 'no window'];
    }

    if (nodeWindow.closed) {
      return [false, 'window closed'];
    }

    if (!(ownerDoc !== null && ownerDoc !== void 0 && ownerDoc.documentElement.isConnected)) {
      return [false, 'documentElement not connected'];
    }

    return [true, 'ok'];
  } catch (e) {
    return [false, e];
  }
}

var defaults = {
  interval: SECOND * 30,
  batchSize: 2500,
  enabled: true
};

var Maintainer = /*#__PURE__*/_createClass(function Maintainer(nodes, unregisterNode, options) {
  var _this31 = this;

  _classCallCheck(this, Maintainer);

  this.nodes = nodes;
  this.unregisterNode = unregisterNode;

  this.start = function () {
    if (!_this31.options.enabled) {
      return;
    }

    _this31.stop();

    _this31.interval = setInterval(function () {
      processMapInBatches(_this31.nodes, _this31.options.batchSize, function (node) {
        var isActive = isNodeStillActive(node)[0];

        if (!isActive) {
          _this31.unregisterNode(node);
        }
      });
    }, _this31.options.interval);
  };

  this.stop = function () {
    if (_this31.interval) {
      clearInterval(_this31.interval);
    }
  };

  this.options = _objectSpread(_objectSpread({}, defaults), options);
});

var Nodes = /*#__PURE__*/function () {
  function Nodes(params) {
    var _this32 = this;

    _classCallCheck(this, Nodes);

    this.nodes = new Map();
    this.totalNodeAmount = 0;
    this.nodeCallbacks = [];
    this.elementListeners = new Map();
    this.nextNodeId = 0; // Attached once per Tracker instance

    this.attachNodeCallback = function (nodeCallback) {
      return _this32.nodeCallbacks.push(nodeCallback);
    };

    this.scanTree = function (cb) {
      _this32.nodes.forEach(function (node) {
        return node ? cb(node) : undefined;
      });
    };

    this.attachNodeListener = function (node, type, listener) {
      var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var id = _this32.getID(node);

      if (id === undefined) {
        return;
      }

      createEventListener(node, type, listener, useCapture, _this32.forceNgOff);

      var listeners = _this32.elementListeners.get(id);

      if (listeners === undefined) {
        listeners = [];

        _this32.elementListeners.set(id, listeners);
      }

      listeners.push([type, listener, useCapture]);
    };

    this.unregisterNode = function (node) {
      var id = node[_this32.node_id];

      if (id !== undefined) {
        node[_this32.node_id] = undefined;
        delete node[_this32.node_id];

        _this32.nodes.delete(id);

        var listeners = _this32.elementListeners.get(id);

        if (listeners !== undefined) {
          _this32.elementListeners.delete(id);

          listeners.forEach(function (listener) {
            return deleteEventListener(node, listener[0], listener[1], listener[2], _this32.forceNgOff);
          });
        }

        _this32.totalNodeAmount--;
      }

      return id;
    };

    this.node_id = params.node_id;
    this.forceNgOff = params.forceNgOff;
    this.maintainer = new Maintainer(this.nodes, this.unregisterNode, params.maintainer);
    this.maintainer.start();
  }

  _createClass(Nodes, [{
    key: "syntheticMode",
    value: function syntheticMode(frameOrder) {
      var maxSafeNumber = Number.MAX_SAFE_INTEGER;
      var placeholderSize = 99999999;
      var nextFrameId = placeholderSize * frameOrder; // I highly doubt that this will ever happen,
      // but it will be easier to debug if it does

      if (nextFrameId > maxSafeNumber) {
        throw new Error('Placeholder id overflow');
      }

      this.nextNodeId = nextFrameId;
    }
  }, {
    key: "registerNode",
    value: function registerNode(node) {
      var id = node[this.node_id];
      var isNew = id === undefined;

      if (isNew) {
        id = this.nextNodeId;
        this.totalNodeAmount++;
        this.nextNodeId++;
        this.nodes.set(id, node);
        node[this.node_id] = id;
      }

      return [id, isNew];
    }
  }, {
    key: "cleanTree",
    value: function cleanTree() {
      // sadly we keep empty items in array here resulting in some memory still being used
      // but its still better than keeping dead nodes or undef elements
      // plus we keep our index positions for new/alive nodes
      // performance test: 3ms for 30k nodes with 17k dead ones
      var _iterator = _createForOfIteratorHelper(this.nodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value2 = _slicedToArray(_step.value, 2),
              _2 = _step$value2[0],
              node = _step$value2[1];

          if (node && !document.contains(node)) {
            this.unregisterNode(node);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "callNodeCallbacks",
    value: function callNodeCallbacks(node, isStart) {
      this.nodeCallbacks.forEach(function (cb) {
        return cb(node, isStart);
      });
    }
  }, {
    key: "getID",
    value: function getID(node) {
      if (!node) return undefined;
      return node[this.node_id];
    }
  }, {
    key: "getNode",
    value: function getNode(id) {
      return this.nodes.get(id);
    }
  }, {
    key: "getNodeCount",
    value: function getNodeCount() {
      return this.totalNodeAmount;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _iterator2 = _createForOfIteratorHelper(this.nodes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value2 = _slicedToArray(_step2.value, 2),
              _3 = _step2$value2[0],
              node = _step2$value2[1];

          if (node) {
            this.unregisterNode(node);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.nextNodeId = 0;
      this.nodes.clear();
    }
  }]);

  return Nodes;
}();

function isIgnored(node) {
  if (isCommentNode(node)) {
    return true;
  }

  if (isTextNode(node)) {
    return false;
  }

  if (!isElementNode(node)) {
    return true;
  }

  var tag = node.tagName.toUpperCase();

  if (tag === 'LINK') {
    var rel = node.getAttribute('rel');
    var as = node.getAttribute('as');
    return !(rel !== null && rel !== void 0 && rel.includes('stylesheet') || as === 'style' || as === 'font');
  }

  return tag === 'SCRIPT' || tag === 'NOSCRIPT' || tag === 'META' || tag === 'TITLE' || tag === 'BASE';
}

function isObservable(node) {
  if (isRootNode(node)) {
    return true;
  }

  return !isIgnored(node);
}
/*
  TODO:
    - fix unbinding logic + send all removals first (ensure sequence is correct)
    - use document as a 0-node in the upper context (should be updated in player at first)
*/


var RecentsType;

(function (RecentsType) {
  RecentsType[RecentsType["New"] = 0] = "New";
  RecentsType[RecentsType["Removed"] = 1] = "Removed";
  RecentsType[RecentsType["Changed"] = 2] = "Changed";
})(RecentsType || (RecentsType = {}));

var Observer = /*#__PURE__*/function () {
  function Observer(app) {
    var _this33 = this;

    var isTopContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, Observer);

    this.app = app;
    this.isTopContext = isTopContext;
    this.commited = [];
    this.recents = new Map();
    this.indexes = [];
    this.attributesMap = new Map();
    this.textSet = new Set();
    this.observer = createMutationObserver(this.app.safe(function (mutations) {
      var _iterator3 = _createForOfIteratorHelper(mutations),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var mutation = _step3.value;
          // mutations order is sequential
          var target = mutation.target;
          var type = mutation.type;

          if (!isObservable(target)) {
            continue;
          }

          if (type === 'childList') {
            for (var _i6 = 0; _i6 < mutation.removedNodes.length; _i6++) {
              // Should be the same as bindTree(mutation.removedNodes[i]), but logic needs to be be untied
              if (isObservable(mutation.removedNodes[_i6])) {
                _this33.bindNode(mutation.removedNodes[_i6]);
              }
            }

            for (var _i8 = 0; _i8 < mutation.addedNodes.length; _i8++) {
              _this33.bindTree(mutation.addedNodes[_i8]);
            }

            continue;
          }

          var _id2 = _this33.app.nodes.getID(target);

          if (_id2 === undefined) {
            continue;
          }

          if (!_this33.recents.has(_id2)) {
            _this33.recents.set(_id2, RecentsType.Changed); // TODO only when altered

          }

          if (type === 'attributes') {
            var name = mutation.attributeName;

            if (name === null) {
              continue;
            }

            var _attr = _this33.attributesMap.get(_id2);

            if (_attr === undefined) {
              _this33.attributesMap.set(_id2, _attr = new Set());
            }

            _attr.add(name);

            continue;
          }

          if (type === 'characterData') {
            _this33.textSet.add(_id2);

            continue;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      _this33.commitNodes();
    }), this.app.options.forceNgOff);
  }

  _createClass(Observer, [{
    key: "clear",
    value: function clear() {
      this.commited.length = 0;
      this.recents.clear();
      this.indexes.length = 1;
      this.attributesMap.clear();
      this.textSet.clear();
    }
    /**
     * EXPERIMENTAL: Unbinds the removed nodes in case of iframe src change.
     *
     * right now, we're relying on nodes.maintainer
     */

  }, {
    key: "handleIframeSrcChange",
    value: function handleIframeSrcChange(iframe) {
      var _this34 = this;

      var oldContentDocument = iframe.contentDocument;

      if (oldContentDocument) {
        var _id3 = this.app.nodes.getID(oldContentDocument);

        if (_id3 !== undefined) {
          var walker = document.createTreeWalker(oldContentDocument, NodeFilter.SHOW_ELEMENT + NodeFilter.SHOW_TEXT, {
            acceptNode: function acceptNode(node) {
              return isIgnored(node) || _this34.app.nodes.getID(node) === undefined ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
            }
          }, // @ts-ignore
          false);
          var removed = 0;
          var totalBeforeRemove = this.app.nodes.getNodeCount();

          while (walker.nextNode()) {
            if (!iframe.contentDocument.contains(walker.currentNode)) {
              removed += 1;
              this.app.nodes.unregisterNode(walker.currentNode);
            }
          }

          var removedPercent = Math.floor(removed / totalBeforeRemove * 100);

          if (removedPercent > 30) {
            this.app.send(UnbindNodes(removedPercent));
          }
        }
      }
    }
  }, {
    key: "sendNodeAttribute",
    value: function sendNodeAttribute(id, node, name, value) {
      if (isSVGElement(node)) {
        if (name.substring(0, 6) === 'xlink:') {
          name = name.substring(6);
        }

        if (value === null) {
          this.app.send(RemoveNodeAttribute(id, name));
        } else if (name === 'href') {
          if (value.length > 1e5) {
            value = '';
          }

          this.app.send(SetNodeAttributeURLBased(id, name, value, this.app.getBaseHref()));
        } else {
          this.app.attributeSender.sendSetAttribute(id, name, value);
        }

        return;
      }

      if (name === 'src' || name === 'srcset' || name === 'integrity' || name === 'crossorigin' || name === 'autocomplete' || name.substring(0, 2) === 'on') {
        return;
      }

      if (name === 'value' && hasTag(node, 'input') && node.type !== 'button' && node.type !== 'reset' && node.type !== 'submit') {
        return;
      }

      if (value === null) {
        this.app.send(RemoveNodeAttribute(id, name));
        return;
      }

      if (name === 'style' || name === 'href' && hasTag(node, 'link')) {
        this.app.send(SetNodeAttributeURLBased(id, name, value, this.app.getBaseHref()));
        return;
      }

      if (name === 'href' || value.length > 1e5) {
        value = '';
      }

      this.app.attributeSender.sendSetAttribute(id, name, value);
    }
  }, {
    key: "sendNodeData",
    value: function sendNodeData(id, parentElement, data) {
      if (hasTag(parentElement, 'style')) {
        this.app.send(SetCSSDataURLBased(id, data, this.app.getBaseHref()));
        return;
      }

      data = this.app.sanitizer.sanitize(id, data);
      this.app.send(SetNodeData(id, data));
    }
  }, {
    key: "bindNode",
    value: function bindNode(node) {
      var _this$app$nodes$regis = this.app.nodes.registerNode(node),
          _this$app$nodes$regis2 = _slicedToArray(_this$app$nodes$regis, 2),
          id = _this$app$nodes$regis2[0],
          isNew = _this$app$nodes$regis2[1];

      if (isNew) {
        this.recents.set(id, RecentsType.New);
      } else if (this.recents.get(id) !== RecentsType.New) {
        this.recents.set(id, RecentsType.Removed);
      }
    }
  }, {
    key: "bindTree",
    value: function bindTree(node) {
      var _this35 = this;

      if (!isObservable(node)) {
        return;
      }

      this.bindNode(node);
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT + NodeFilter.SHOW_TEXT, {
        acceptNode: function acceptNode(node) {
          if (_this35.app.nodes.getID(node) !== undefined) {
            _this35.app.debug.error('! Node is already bound', node);
          }

          return isIgnored(node) || _this35.app.nodes.getID(node) !== undefined ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        }
      }, // @ts-ignore
      false);

      while (walker.nextNode()) {
        this.bindNode(walker.currentNode);
      }
    }
  }, {
    key: "unbindTree",
    value: function unbindTree(node) {
      var _this36 = this;

      var id = this.app.nodes.unregisterNode(node);

      if (id !== undefined && this.recents.get(id) === RecentsType.Removed) {
        // Sending RemoveNode only for parent to maintain
        this.app.send(RemoveNode(id)); // Unregistering all the children in order to clear the memory

        var walker = document.createTreeWalker(node, NodeFilter.SHOW_ELEMENT + NodeFilter.SHOW_TEXT, {
          acceptNode: function acceptNode(node) {
            return isIgnored(node) || _this36.app.nodes.getID(node) === undefined ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }
        }, // @ts-ignore
        false);
        var removed = 0;
        var totalBeforeRemove = this.app.nodes.getNodeCount();

        while (walker.nextNode()) {
          removed += 1;
          this.app.nodes.unregisterNode(walker.currentNode);
        }

        var removedPercent = Math.floor(removed / totalBeforeRemove * 100);

        if (removedPercent > 30) {
          this.app.send(UnbindNodes(removedPercent));
        }
      }
    } // A top-consumption function on the infinite lists test. (~1% of performance resources)

  }, {
    key: "_commitNode",
    value: function _commitNode(id, node) {
      if (isRootNode(node)) {
        return true;
      }

      var parent = node.parentNode;
      var parentID; // Disable parent check for the upper context HTMLHtmlElement, because it is root there... (before)
      // TODO: get rid of "special" cases (there is an issue with CreateDocument altered behaviour though)
      // TODO: Clean the logic (though now it workd fine)

      if (!hasTag(node, 'html') || !this.isTopContext) {
        if (parent === null) {
          // Sometimes one observation contains attribute mutations for the removimg node, which gets ignored here.
          // That shouldn't affect the visual rendering ( should it? maybe when transition applied? )
          this.unbindTree(node);
          return false;
        }

        parentID = this.app.nodes.getID(parent);

        if (parentID === undefined) {
          this.unbindTree(node);
          return false;
        }

        if (!this.commitNode(parentID)) {
          this.unbindTree(node);
          return false;
        }

        this.app.sanitizer.handleNode(id, parentID, node);

        if (this.app.sanitizer.isHidden(parentID)) {
          return false;
        }
      } // From here parentID === undefined if node is top context HTML node


      var sibling = node.previousSibling;

      while (sibling !== null) {
        var siblingID = this.app.nodes.getID(sibling);

        if (siblingID !== undefined) {
          this.commitNode(siblingID);
          this.indexes[id] = this.indexes[siblingID] + 1;
          break;
        }

        sibling = sibling.previousSibling;
      }

      if (sibling === null) {
        this.indexes[id] = 0;
      }

      var recentsType = this.recents.get(id);
      var isNew = recentsType === RecentsType.New;
      var index = this.indexes[id];

      if (index === undefined) {
        throw 'commitNode: missing node index';
      }

      if (isNew) {
        if (isElementNode(node)) {
          var el = node;

          if (parentID !== undefined) {
            if (this.app.sanitizer.isHidden(id)) {
              var width = el.clientWidth;
              var height = el.clientHeight;
              el = node.cloneNode();
              el.style.width = "".concat(width, "px");
              el.style.height = "".concat(height, "px");
            }

            this.app.send(CreateElementNode(id, parentID, index, el.tagName, isSVGElement(node)));
          }

          for (var _i10 = 0; _i10 < el.attributes.length; _i10++) {
            var _attr2 = el.attributes[_i10];
            this.sendNodeAttribute(id, el, _attr2.nodeName, _attr2.value);
          }
        } else if (isTextNode(node)) {
          // for text node id != 0, hence parentID !== undefined and parent is Element
          this.app.send(CreateTextNode(id, parentID, index));
          this.sendNodeData(id, parent, node.data);
        }

        return true;
      }

      if (recentsType === RecentsType.Removed && parentID !== undefined) {
        this.app.send(MoveNode(id, parentID, index));
      }

      var attr = this.attributesMap.get(id);

      if (attr !== undefined) {
        if (!isElementNode(node)) {
          throw 'commitNode: node is not an element';
        }

        var _iterator4 = _createForOfIteratorHelper(attr),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var name = _step4.value;
            this.sendNodeAttribute(id, node, name, node.getAttribute(name));
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      if (this.textSet.has(id)) {
        if (!isTextNode(node)) {
          throw 'commitNode: node is not a text';
        } // for text node id != 0, hence parent is Element


        this.sendNodeData(id, parent, node.data);
      }

      return true;
    }
  }, {
    key: "commitNode",
    value: function commitNode(id) {
      var node = this.app.nodes.getNode(id);

      if (!node) {
        return false;
      }

      var cmt = this.commited[id];

      if (cmt !== undefined) {
        return cmt;
      }

      return this.commited[id] = this._commitNode(id, node);
    }
  }, {
    key: "commitNodes",
    value: function commitNodes() {
      var _this37 = this;

      var isStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var node;
      this.recents.forEach(function (type, id) {
        _this37.commitNode(id);

        if (type === RecentsType.New && (node = _this37.app.nodes.getNode(id))) {
          _this37.app.nodes.callNodeCallbacks(node, isStart);
        }
      });
      this.clear();
    } // ISSSUE (nodeToBinde should be the same as node in all cases. Look at the comment about 0-node at the beginning of the file.)
    // TODO: use one observer instance for all iframes/shadowRoots (composition instiad of inheritance)

  }, {
    key: "observeRoot",
    value: function observeRoot(node, beforeCommit) {
      var nodeToBind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : node;
      this.observer.observe(node, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true,
        attributeOldValue: false,
        characterDataOldValue: false
      });
      this.bindTree(nodeToBind);
      beforeCommit(this.app.nodes.getID(node));
      this.commitNodes(true);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.observer.disconnect();
      this.clear();
    }
  }]);

  return Observer;
}();

var IFrameObserver = /*#__PURE__*/function (_Observer) {
  _inherits(IFrameObserver, _Observer);

  var _super = _createSuper(IFrameObserver);

  function IFrameObserver() {
    _classCallCheck(this, IFrameObserver);

    return _super.apply(this, arguments);
  }

  _createClass(IFrameObserver, [{
    key: "observe",
    value: function observe(iframe) {
      var _this38 = this;

      var doc = iframe.contentDocument;
      var hostID = this.app.nodes.getID(iframe);

      if (!doc || hostID === undefined) {
        return;
      } // Have to observe document, because the inner <html> might be changed


      this.observeRoot(doc, function (docID) {
        //MBTODO: do not send if empty (send on load? it might be in-place iframe, like our replayer, which does not get loaded)
        if (docID === undefined) {
          _this38.app.debug.log('OpenReplay: Iframe document not bound');

          return;
        }

        _this38.docId = docID;

        _this38.app.send(CreateIFrameDocument(hostID, docID));
      });
    }
  }, {
    key: "syntheticObserve",
    value: function syntheticObserve(rootNodeId, doc) {
      var _this39 = this;

      this.observeRoot(doc, function (docID) {
        if (docID === undefined) {
          _this39.app.debug.log('OpenReplay: Iframe document not bound');

          return;
        }

        _this39.app.send(CreateIFrameDocument(rootNodeId, docID));
      });
    }
  }]);

  return IFrameObserver;
}(Observer);

var ShadowRootObserver = /*#__PURE__*/function (_Observer2) {
  _inherits(ShadowRootObserver, _Observer2);

  var _super2 = _createSuper(ShadowRootObserver);

  function ShadowRootObserver() {
    _classCallCheck(this, ShadowRootObserver);

    return _super2.apply(this, arguments);
  }

  _createClass(ShadowRootObserver, [{
    key: "observe",
    value: function observe(el) {
      var _this40 = this;

      var shRoot = el.shadowRoot;
      var hostID = this.app.nodes.getID(el);

      if (!shRoot || hostID === undefined) {
        return;
      } // log


      this.observeRoot(shRoot, function (rootID) {
        if (rootID === undefined) {
          _this40.app.debug.error('OpenReplay: Shadow Root was not bound');

          return;
        }

        _this40.app.send(CreateIFrameDocument(hostID, rootID));
      });
    }
  }]);

  return ShadowRootObserver;
}(Observer);

var IFrameOffsets = /*#__PURE__*/function () {
  function IFrameOffsets() {
    _classCallCheck(this, IFrameOffsets);

    this.states = new WeakMap();
  }

  _createClass(IFrameOffsets, [{
    key: "calcOffset",
    value: function calcOffset(state) {
      var parLeft = 0,
          parTop = 0;

      if (state.parent) {
        var _this$calcOffset = this.calcOffset(state.parent);

        var _this$calcOffset2 = _slicedToArray(_this$calcOffset, 2);

        parLeft = _this$calcOffset2[0];
        parTop = _this$calcOffset2[1];
      }

      if (!state.offset) {
        var _state$iFrame$getBoun2 = state.iFrame.getBoundingClientRect(),
            _left = _state$iFrame$getBoun2.left,
            _top = _state$iFrame$getBoun2.top;

        state.offset = [_left, _top];
      }

      var _state$offset = _slicedToArray(state.offset, 2),
          left = _state$offset[0],
          top = _state$offset[1];

      return [parLeft + left, parTop + top]; // TODO: store absolute sum, invalidate whole subtree. Otherwise it is summated on each mousemove
    }
  }, {
    key: "getDocumentOffset",
    value: function getDocumentOffset(doc) {
      var state = this.states.get(doc);

      if (!state) {
        return [0, 0];
      } // topmost doc


      return this.calcOffset(state);
    }
  }, {
    key: "observe",
    value: function observe(iFrame) {
      var _parentDoc$defaultVie2;

      var doc = iFrame.contentDocument;

      if (!doc) {
        return;
      }

      var parentDoc = iFrame.ownerDocument;
      var parentState = this.states.get(parentDoc);
      var state = {
        offset: null,
        // lazy calc
        iFrame: iFrame,
        parent: parentState || null,
        // null when parentDoc is the topmost document
        clear: function clear() {
          var _parentDoc$defaultVie;

          parentDoc.removeEventListener('scroll', invalidateOffset);
          (_parentDoc$defaultVie = parentDoc.defaultView) === null || _parentDoc$defaultVie === void 0 ? void 0 : _parentDoc$defaultVie.removeEventListener('resize', invalidateOffset);
        }
      };

      var invalidateOffset = function invalidateOffset() {
        state.offset = null;
      }; // anything more reliable? This does not cover all cases (layout changes are ignored, for ex.)


      parentDoc.addEventListener('scroll', invalidateOffset);
      (_parentDoc$defaultVie2 = parentDoc.defaultView) === null || _parentDoc$defaultVie2 === void 0 ? void 0 : _parentDoc$defaultVie2.addEventListener('resize', invalidateOffset);
      this.states.set(doc, state);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.states = new WeakMap();
    }
  }]);

  return IFrameOffsets;
}();

var attachShadowNativeFn = IN_BROWSER ? Element.prototype.attachShadow : function () {
  return new ShadowRoot();
};

var TopObserver = /*#__PURE__*/function (_Observer3) {
  _inherits(TopObserver, _Observer3);

  var _super3 = _createSuper(TopObserver);

  function TopObserver(params) {
    var _this41;

    _classCallCheck(this, TopObserver);

    _this41 = _super3.call(this, params.app, true);
    _this41.iframeOffsets = new IFrameOffsets();
    _this41.contextCallbacks = []; // Attached once per Tracker instance

    _this41.contextsSet = new WeakSet();
    _this41.iframeObserversArr = [];
    _this41.iframeObservers = new WeakMap();
    _this41.docObservers = new WeakMap();
    _this41.shadowRootObservers = new WeakMap();
    _this41.app = params.app;
    _this41.options = Object.assign({
      captureIFrames: true
    }, params.options); // IFrames

    _this41.app.nodes.attachNodeCallback(function (node) {
      if (hasTag(node, 'iframe') && (_this41.options.captureIFrames && !hasOpenreplayAttribute(node, 'obscured') || hasOpenreplayAttribute(node, 'capture'))) {
        _this41.handleIframe(node);
      }
    }); // ShadowDOM


    _this41.app.nodes.attachNodeCallback(function (node) {
      if (isElementNode(node) && node.shadowRoot !== null) {
        _this41.handleShadowRoot(node.shadowRoot);
      }
    });

    return _this41;
  }

  _createClass(TopObserver, [{
    key: "attachContextCallback",
    value: function attachContextCallback(cb) {
      this.contextCallbacks.push(cb);
    }
  }, {
    key: "getDocumentOffset",
    value: function getDocumentOffset(doc) {
      return this.iframeOffsets.getDocumentOffset(doc);
    }
  }, {
    key: "handleIframe",
    value: function handleIframe(iframe) {
      var _this42 = this;

      // setTimeout is required. Otherwise some event listeners (scroll, mousemove) applied in modules
      // do not work on the iframe document when it 've been loaded dynamically ((why?))
      var handle = this.app.safe(function () {
        return setTimeout(function () {
          var id = _this42.app.nodes.getID(iframe);

          if (id === undefined || !canAccessIframe(iframe)) return;
          var currentWin = iframe.contentWindow;
          var currentDoc = iframe.contentDocument;

          if (!currentDoc) {
            _this42.app.debug.warn('no doc for iframe found', iframe);

            return;
          }

          if (currentDoc && _this42.docObservers.has(currentDoc)) {
            _this42.app.debug.info('doc already observed for', id);

            return;
          }

          var observer = new IFrameObserver(_this42.app);

          _this42.iframeObservers.set(iframe, observer);

          _this42.docObservers.set(currentDoc, observer);

          _this42.iframeObserversArr.push(observer);

          observer.observe(iframe);

          _this42.iframeOffsets.observe(iframe);

          if (currentWin && // Sometimes currentWin.window is null (not in specification). Such window object is not functional
          currentWin === currentWin.window && !_this42.contextsSet.has(currentWin) // for each context callbacks called once per Tracker (TopObserver) instance
          //TODO: more explicit logic
          ) {
              _this42.contextsSet.add(currentWin); // @ts-ignore https://github.com/microsoft/TypeScript/issues/41684


              _this42.contextCallbacks.forEach(function (cb) {
                return cb(currentWin);
              });
            } // we need this delay because few iframes stacked one in another with rapid updates will break the player (or browser engine rather?)

        }, 250);
      });
      iframe.addEventListener('load', handle);
      handle();
    }
  }, {
    key: "handleShadowRoot",
    value: function handleShadowRoot(shRoot) {
      var observer = new ShadowRootObserver(this.app);
      this.shadowRootObservers.set(shRoot, observer);
      observer.observe(shRoot.host);
    }
  }, {
    key: "observe",
    value: function observe() {
      var _this43 = this;

      // Protection from several subsequent calls?
      var observer = this;

      Element.prototype.attachShadow = function () {
        // eslint-disable-next-line
        var shadow = attachShadowNativeFn.apply(this, arguments);
        observer.handleShadowRoot(shadow);
        return shadow;
      };

      this.app.nodes.clear(); // Can observe documentElement (<html>) here, because it is not supposed to be changing.
      // However, it is possible in some exotic cases and may cause an ignorance of the newly created <html>
      // In this case context.document have to be observed, but this will cause
      // the change in the re-player behaviour caused by CreateDocument message:
      //   the 0-node ("fRoot") will become #document rather than documentElement as it is now.
      // Alternatively - observe(#document) then bindNode(documentElement)

      this.observeRoot(window.document, function () {
        _this43.app.send(CreateDocument()); // it has no node_id here


        _this43.app.nodes.callNodeCallbacks(document, true);
      }, window.document.documentElement);
    }
  }, {
    key: "crossdomainObserve",
    value: function crossdomainObserve(rootNodeId, frameOder) {
      var observer = this;

      Element.prototype.attachShadow = function () {
        // eslint-disable-next-line
        var shadow = attachShadowNativeFn.apply(this, arguments);
        observer.handleShadowRoot(shadow);
        return shadow;
      };

      this.app.nodes.clear();
      this.app.nodes.syntheticMode(frameOder);
      var iframeObserver = new IFrameObserver(this.app);
      this.iframeObservers.set(window.document, iframeObserver);
      iframeObserver.syntheticObserve(rootNodeId, window.document);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.iframeOffsets.clear();
      Element.prototype.attachShadow = attachShadowNativeFn;
      this.iframeObserversArr.forEach(function (observer) {
        return observer.disconnect();
      });
      this.iframeObserversArr = [];
      this.iframeObservers = new WeakMap();
      this.shadowRootObservers = new WeakMap();
      this.docObservers = new WeakMap();

      _get(_getPrototypeOf(TopObserver.prototype), "disconnect", this).call(this);
    }
  }]);

  return TopObserver;
}(Observer);

var SanitizeLevel;

(function (SanitizeLevel) {
  SanitizeLevel[SanitizeLevel["Plain"] = 0] = "Plain";
  SanitizeLevel[SanitizeLevel["Obscured"] = 1] = "Obscured";
  SanitizeLevel[SanitizeLevel["Hidden"] = 2] = "Hidden";
})(SanitizeLevel || (SanitizeLevel = {}));

var stringWiper = function stringWiper(input) {
  return input.trim().replace(/[^\f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]/g, '█');
};

var Sanitizer = /*#__PURE__*/function () {
  function Sanitizer(params) {
    _classCallCheck(this, Sanitizer);

    this.obscured = new Set();
    this.hidden = new Set();
    this.app = params.app;
    this.options = Object.assign({
      obscureTextEmails: true,
      obscureTextNumbers: false
    }, params.options);
  }

  _createClass(Sanitizer, [{
    key: "handleNode",
    value: function handleNode(id, parentID, node) {
      if (this.obscured.has(parentID) || isElementNode(node) && (hasOpenreplayAttribute(node, 'masked') || hasOpenreplayAttribute(node, 'obscured'))) {
        this.obscured.add(id);
      }

      if (this.hidden.has(parentID) || isElementNode(node) && (hasOpenreplayAttribute(node, 'htmlmasked') || hasOpenreplayAttribute(node, 'hidden'))) {
        this.hidden.add(id);
      }

      if (this.options.domSanitizer !== undefined && isElementNode(node)) {
        var sanitizeLevel = this.options.domSanitizer(node);

        if (sanitizeLevel === SanitizeLevel.Obscured) {
          this.obscured.add(id);
        }

        if (sanitizeLevel === SanitizeLevel.Hidden) {
          this.hidden.add(id);
        }
      }
    }
  }, {
    key: "sanitize",
    value: function sanitize(id, data) {
      if (this.obscured.has(id)) {
        // TODO: is it the best place to put trim() ? Might trimmed spaces be considered in layout in certain cases?
        return stringWiper(data);
      }

      if (this.options.obscureTextNumbers) {
        data = data.replace(/\d/g, '0');
      }

      if (this.options.obscureTextEmails) {
        data = data.replace(/^\w+([+.-]\w+)*@\w+([.-]\w+)*\.\w{2,3}$/g, function (email) {
          var _email$split = email.split('@'),
              _email$split2 = _slicedToArray(_email$split, 2),
              name = _email$split2[0],
              domain = _email$split2[1];

          var _domain$split = domain.split('.'),
              _domain$split2 = _slicedToArray(_domain$split, 2),
              domainName = _domain$split2[0],
              host = _domain$split2[1];

          return "".concat(stars(name), "@").concat(stars(domainName), ".").concat(stars(host));
        });
      }

      return data;
    }
  }, {
    key: "isObscured",
    value: function isObscured(id) {
      return this.obscured.has(id);
    }
  }, {
    key: "isHidden",
    value: function isHidden(id) {
      return this.hidden.has(id);
    }
  }, {
    key: "getInnerTextSecure",
    value: function getInnerTextSecure(el) {
      var id = this.app.nodes.getID(el);

      if (!id) {
        return '';
      }

      return this.sanitize(id, el.innerText);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.obscured.clear();
      this.hidden.clear();
    }
  }]);

  return Sanitizer;
}();

var Session = /*#__PURE__*/function () {
  function Session(params) {
    var _this44 = this;

    _classCallCheck(this, Session);

    this.metadata = {};
    this.userID = null;
    this.callbacks = [];
    this.timestamp = 0;

    this.getPageNumber = function () {
      var pageNoStr = _this44.app.sessionStorage.getItem(_this44.options.session_pageno_key);

      if (pageNoStr == null) {
        return undefined;
      }

      return parseInt(pageNoStr);
    };

    this.incPageNo = function () {
      var pageNo = _this44.getPageNumber();

      if (pageNo === undefined) {
        pageNo = 0;
      } else {
        pageNo++;
      }

      _this44.app.sessionStorage.setItem(_this44.options.session_pageno_key, pageNo.toString());

      return pageNo;
    };

    this.app = params.app;
    this.options = params.options;
    this.createTabId();
  }

  _createClass(Session, [{
    key: "attachUpdateCallback",
    value: function attachUpdateCallback(cb) {
      this.callbacks.push(cb);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(newInfo) {
      if (newInfo.userID == null) {
        delete newInfo.userID;
      }

      if (newInfo.sessionID == null) {
        delete newInfo.sessionID;
      }

      this.callbacks.forEach(function (cb) {
        return cb(newInfo);
      });
    }
  }, {
    key: "assign",
    value: function assign(newInfo) {
      var _this45 = this;

      if (newInfo.userID !== undefined) {
        // TODO clear nullable/undefinable types
        this.userID = newInfo.userID;
      }

      if (newInfo.metadata !== undefined) {
        Object.entries(newInfo.metadata).forEach(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
              k = _ref7[0],
              v = _ref7[1];

          return _this45.metadata[k] = v;
        });
      }

      if (newInfo.sessionID !== undefined) {
        this.sessionID = newInfo.sessionID;
      }

      if (newInfo.timestamp !== undefined) {
        this.timestamp = newInfo.timestamp;
      }

      if (newInfo.projectID !== undefined) {
        this.projectID = newInfo.projectID;
      }

      this.handleUpdate(newInfo);
    }
  }, {
    key: "setMetadata",
    value: function setMetadata(key, value) {
      this.metadata[key] = value;
      this.handleUpdate({
        metadata: _defineProperty({}, key, value)
      });
    }
  }, {
    key: "setUserID",
    value: function setUserID(userID) {
      this.userID = userID;
      this.handleUpdate({
        userID: userID
      });
    }
  }, {
    key: "setUserInfo",
    value: function setUserInfo(userInfo) {
      this.userInfo = userInfo;
    }
  }, {
    key: "getSessionToken",
    value: function getSessionToken() {
      var token = this.token || this.app.sessionStorage.getItem(this.options.session_token_key);
      return token || undefined;
    }
  }, {
    key: "setSessionToken",
    value: function setSessionToken(token) {
      this.token = token;
      this.app.sessionStorage.setItem(this.options.session_token_key, token);
    }
  }, {
    key: "applySessionHash",
    value: function applySessionHash(hash) {
      var hashParts = decodeURI(hash).split('&');
      var token = hash;
      var pageNoStr = '100500'; // back-compat for sessionToken

      if (hashParts.length == 2) {
        var _hashParts = _slicedToArray(hashParts, 2);

        pageNoStr = _hashParts[0];
        token = _hashParts[1];
      }

      if (!pageNoStr || !token) {
        return;
      }

      this.app.sessionStorage.setItem(this.options.session_token_key, token);
      this.app.sessionStorage.setItem(this.options.session_pageno_key, pageNoStr);
    }
  }, {
    key: "getSessionHash",
    value: function getSessionHash() {
      var pageNo = this.getPageNumber();
      var token = this.getSessionToken();

      if (pageNo === undefined || token === undefined) {
        return;
      }

      return encodeURI(String(pageNo) + '&' + token);
    }
  }, {
    key: "getTabId",
    value: function getTabId() {
      if (!this.tabId) this.createTabId();
      return this.tabId;
    }
  }, {
    key: "regenerateTabId",
    value: function regenerateTabId() {
      var randomId = generateRandomId(12);
      this.app.sessionStorage.setItem(this.options.session_tabid_key, randomId);
      this.tabId = randomId;
    }
  }, {
    key: "createTabId",
    value: function createTabId() {
      var localId = this.app.sessionStorage.getItem(this.options.session_tabid_key);

      if (localId) {
        this.tabId = localId;
      } else {
        this.regenerateTabId();
      }
    }
  }, {
    key: "getInfo",
    value: function getInfo() {
      return {
        sessionID: this.sessionID,
        metadata: this.metadata,
        userID: this.userID,
        timestamp: this.timestamp,
        projectID: this.projectID
      };
    }
  }, {
    key: "reset",
    value: function reset() {
      this.app.sessionStorage.removeItem(this.options.session_token_key);
      this.metadata = {};
      this.userID = null;
      this.sessionID = undefined;
      this.timestamp = 0;
    }
  }]);

  return Session;
}();

function wrap(callback, n) {
  var t = 0;
  return function () {
    if (t++ >= n) {
      t = 0;
      callback();
    }
  };
}

var Ticker = /*#__PURE__*/function () {
  function Ticker(app) {
    _classCallCheck(this, Ticker);

    this.app = app;
    this.timer = null;
    this.callbacks = [];
  }
  /**
   * @param {Callback} callback - repeated cb
   * @param {number} n - number of turn skips; ticker have a 30 ms cycle
   * @param {boolean} useSafe - using safe wrapper to check if app is active
   * @param {object} thisArg - link to <this>
   * */


  _createClass(Ticker, [{
    key: "attach",
    value: function attach(callback) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var useSafe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var thisArg = arguments.length > 3 ? arguments[3] : undefined;

      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      if (useSafe) {
        callback = this.app.safe(callback);
      }

      this.callbacks.unshift(n ? wrap(callback, n) : callback) - 1;
    }
  }, {
    key: "start",
    value: function start() {
      var _this46 = this;

      if (this.timer === null) {
        this.timer = setInterval(function () {
          return _this46.callbacks.forEach(function (cb) {
            if (cb) cb();
          });
        }, 30);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }]);

  return Ticker;
}();
/**
 * this value is injected during build time via rollup
 * */
// @ts-ignore


var workerBodyFn = "!function(){\"use strict\";class t{constructor(t,s,i,e=10,n=250,h,r){this.onUnauthorised=s,this.onFailure=i,this.MAX_ATTEMPTS_COUNT=e,this.ATTEMPT_TIMEOUT=n,this.onCompress=h,this.pageNo=r,this.attemptsCount=0,this.busy=!1,this.queue=[],this.token=null,this.lastBatchNum=0,this.ingestURL=t+\"/v1/web/i\",this.isCompressing=void 0!==h}getQueueStatus(){return 0===this.queue.length&&!this.busy}authorise(t){this.token=t,this.busy||this.sendNext()}push(t){if(this.busy||!this.token)this.queue.push(t);else if(this.busy=!0,this.isCompressing&&this.onCompress)this.onCompress(t);else{const s=++this.lastBatchNum;this.sendBatch(t,!1,s)}}sendNext(){const t=this.queue.shift();if(t)if(this.busy=!0,this.isCompressing&&this.onCompress)this.onCompress(t);else{const s=++this.lastBatchNum;this.sendBatch(t,!1,s)}else this.busy=!1}retry(t,s,i){this.attemptsCount>=this.MAX_ATTEMPTS_COUNT?this.onFailure(`Failed to send batch after ${this.attemptsCount} attempts.`):(this.attemptsCount++,setTimeout((()=>this.sendBatch(t,s,i)),this.ATTEMPT_TIMEOUT*this.attemptsCount))}sendBatch(t,s,i){var e;const n=null==i?void 0:i.toString().replace(/^([^_]+)_([^_]+).*/,\"$1_$2_$3\");this.busy=!0;const h={Authorization:`Bearer ${this.token}`};s&&(h[\"Content-Encoding\"]=\"gzip\"),null!==this.token?fetch(`${this.ingestURL}?batch=${null!==(e=this.pageNo)&&void 0!==e?e:\"noPageNum\"}_${null!=n?n:\"noBatchNum\"}`,{body:t,method:\"POST\",headers:h,keepalive:t.length<65536}).then((e=>{if(401===e.status)return this.busy=!1,void this.onUnauthorised();e.status>=400?this.retry(t,s,`${null!=i?i:\"noBatchNum\"}_network:${e.status}`):(this.attemptsCount=0,this.sendNext())})).catch((e=>{console.warn(\"OpenReplay:\",e),this.retry(t,s,`${null!=i?i:\"noBatchNum\"}_reject:${e.message}`)})):setTimeout((()=>{this.sendBatch(t,s,`${null!=i?i:\"noBatchNum\"}_newToken`)}),500)}sendCompressed(t){const s=++this.lastBatchNum;this.sendBatch(t,!0,s)}sendUncompressed(t){const s=++this.lastBatchNum;this.sendBatch(t,!1,s)}clean(){this.sendNext(),setTimeout((()=>{this.token=null,this.queue.length=0}),10)}}const s=\"function\"==typeof TextEncoder?new TextEncoder:{encode(t){const s=t.length,i=new Uint8Array(3*s);let e=-1;for(let n=0,h=0,r=0;r!==s;){if(n=t.charCodeAt(r),r+=1,n>=55296&&n<=56319){if(r===s){i[e+=1]=239,i[e+=1]=191,i[e+=1]=189;break}if(h=t.charCodeAt(r),!(h>=56320&&h<=57343)){i[e+=1]=239,i[e+=1]=191,i[e+=1]=189;continue}if(n=1024*(n-55296)+h-56320+65536,r+=1,n>65535){i[e+=1]=240|n>>>18,i[e+=1]=128|n>>>12&63,i[e+=1]=128|n>>>6&63,i[e+=1]=128|63&n;continue}}n<=127?i[e+=1]=0|n:n<=2047?(i[e+=1]=192|n>>>6,i[e+=1]=128|63&n):(i[e+=1]=224|n>>>12,i[e+=1]=128|n>>>6&63,i[e+=1]=128|63&n)}return i.subarray(0,e+1)}};class i{constructor(t){this.size=t,this.offset=0,this.checkpointOffset=0,this.data=new Uint8Array(t)}getCurrentOffset(){return this.offset}checkpoint(){this.checkpointOffset=this.offset}get isEmpty(){return 0===this.offset}skip(t){return this.offset+=t,this.offset<=this.size}set(t,s){this.data.set(t,s)}boolean(t){return this.data[this.offset++]=+t,this.offset<=this.size}uint(t){for((t<0||t>Number.MAX_SAFE_INTEGER)&&(t=0);t>=128;)this.data[this.offset++]=t%256|128,t=Math.floor(t/128);return this.data[this.offset++]=t,this.offset<=this.size}int(t){return t=Math.round(t),this.uint(t>=0?2*t:-2*t-1)}string(t){const i=s.encode(t),e=i.byteLength;return!(!this.uint(e)||this.offset+e>this.size)&&(this.data.set(i,this.offset),this.offset+=e,!0)}reset(){this.offset=0,this.checkpointOffset=0}flush(){const t=this.data.slice(0,this.checkpointOffset);return this.reset(),t}}class e extends i{encode(t){switch(t[0]){case 0:case 11:case 114:case 115:return this.uint(t[1]);case 4:case 44:case 47:return this.string(t[1])&&this.string(t[2])&&this.uint(t[3]);case 5:case 20:case 38:case 70:case 75:case 76:case 77:case 82:return this.uint(t[1])&&this.uint(t[2]);case 6:return this.int(t[1])&&this.int(t[2]);case 7:return!0;case 8:return this.uint(t[1])&&this.uint(t[2])&&this.uint(t[3])&&this.string(t[4])&&this.boolean(t[5]);case 9:case 10:case 24:case 51:return this.uint(t[1])&&this.uint(t[2])&&this.uint(t[3]);case 12:case 52:case 61:case 71:return this.uint(t[1])&&this.string(t[2])&&this.string(t[3]);case 13:case 14:case 17:case 50:case 54:return this.uint(t[1])&&this.string(t[2]);case 16:return this.uint(t[1])&&this.int(t[2])&&this.int(t[3]);case 18:return this.uint(t[1])&&this.string(t[2])&&this.int(t[3]);case 19:return this.uint(t[1])&&this.boolean(t[2]);case 21:return this.string(t[1])&&this.string(t[2])&&this.string(t[3])&&this.string(t[4])&&this.string(t[5])&&this.uint(t[6])&&this.uint(t[7])&&this.uint(t[8]);case 22:case 27:case 30:case 41:case 45:case 46:case 43:case 63:case 64:case 79:case 124:return this.string(t[1])&&this.string(t[2]);case 23:return this.uint(t[1])&&this.uint(t[2])&&this.uint(t[3])&&this.uint(t[4])&&this.uint(t[5])&&this.uint(t[6])&&this.uint(t[7])&&this.uint(t[8])&&this.uint(t[9]);case 28:case 29:case 42:case 117:case 118:return this.string(t[1]);case 37:return this.uint(t[1])&&this.string(t[2])&&this.uint(t[3]);case 39:return this.string(t[1])&&this.string(t[2])&&this.string(t[3])&&this.string(t[4])&&this.uint(t[5])&&this.uint(t[6])&&this.uint(t[7]);case 40:return this.string(t[1])&&this.uint(t[2])&&this.string(t[3])&&this.string(t[4]);case 48:return this.string(t[1])&&this.string(t[2])&&this.string(t[3])&&this.string(t[4])&&this.int(t[5]);case 49:return this.int(t[1])&&this.int(t[2])&&this.uint(t[3])&&this.uint(t[4]);case 53:return this.uint(t[1])&&this.uint(t[2])&&this.uint(t[3])&&this.uint(t[4])&&this.uint(t[5])&&this.uint(t[6])&&this.string(t[7])&&this.string(t[8]);case 55:return this.boolean(t[1]);case 57:case 60:return this.uint(t[1])&&this.string(t[2])&&this.string(t[3])&&this.string(t[4]);case 58:case 120:return this.int(t[1]);case 59:return this.uint(t[1])&&this.uint(t[2])&&this.uint(t[3])&&this.uint(t[4])&&this.string(t[5])&&this.string(t[6])&&this.string(t[7]);case 67:case 73:return this.uint(t[1])&&this.string(t[2])&&this.uint(t[3])&&this.string(t[4]);case 68:return this.uint(t[1])&&this.uint(t[2])&&this.string(t[3])&&this.string(t[4])&&this.uint(t[5])&&this.uint(t[6]);case 69:return this.uint(t[1])&&this.uint(t[2])&&this.string(t[3])&&this.string(t[4]);case 78:return this.string(t[1])&&this.string(t[2])&&this.string(t[3])&&this.string(t[4]);case 81:return this.uint(t[1])&&this.uint(t[2])&&this.uint(t[3])&&this.int(t[4])&&this.string(t[5]);case 83:return this.string(t[1])&&this.string(t[2])&&this.string(t[3])&&this.string(t[4])&&this.string(t[5])&&this.uint(t[6])&&this.uint(t[7])&&this.uint(t[8])&&this.uint(t[9]);case 84:return this.string(t[1])&&this.string(t[2])&&this.string(t[3])&&this.uint(t[4])&&this.string(t[5])&&this.string(t[6]);case 112:return this.uint(t[1])&&this.string(t[2])&&this.boolean(t[3])&&this.string(t[4])&&this.int(t[5])&&this.int(t[6]);case 113:return this.uint(t[1])&&this.uint(t[2])&&this.string(t[3]);case 116:return this.uint(t[1])&&this.uint(t[2])&&this.uint(t[3])&&this.uint(t[4])&&this.uint(t[5])&&this.uint(t[6])&&this.string(t[7])&&this.string(t[8])&&this.uint(t[9])&&this.boolean(t[10]);case 119:return this.string(t[1])&&this.uint(t[2]);case 121:return this.string(t[1])&&this.string(t[2])&&this.uint(t[3])&&this.uint(t[4]);case 122:return this.string(t[1])&&this.string(t[2])&&this.uint(t[3])&&this.string(t[4]);case 123:return this.string(t[1])&&this.string(t[2])&&this.string(t[3])&&this.string(t[4])&&this.uint(t[5])}}}class n{constructor(t,s,i,n,h,r){this.pageNo=t,this.timestamp=s,this.url=i,this.onBatch=n,this.tabId=h,this.onOfflineEnd=r,this.nextIndex=0,this.beaconSize=2e5,this.encoder=new e(this.beaconSize),this.sizeBuffer=new Uint8Array(3),this.isEmpty=!0,this.beaconSizeLimit=1e6,this.prepare()}writeType(t){return this.encoder.uint(t[0])}writeFields(t){return this.encoder.encode(t)}writeSizeAt(t,s){for(let s=0;s<3;s++)this.sizeBuffer[s]=t>>8*s;this.encoder.set(this.sizeBuffer,s)}prepare(){if(!this.encoder.isEmpty)return;const t=[81,1,this.pageNo,this.nextIndex,this.timestamp,this.url],s=[118,this.tabId];this.writeType(t),this.writeFields(t),this.writeWithSize(s),this.isEmpty=!0}writeWithSize(t){const s=this.encoder;if(!this.writeType(t)||!s.skip(3))return!1;const i=s.getCurrentOffset(),e=this.writeFields(t);if(e){const e=s.getCurrentOffset()-i;if(e>16777215)return console.warn(\"OpenReplay: max message size overflow.\"),!1;this.writeSizeAt(e,i-3),s.checkpoint(),this.isEmpty=this.isEmpty&&0===t[0],this.nextIndex++}return e}setBeaconSizeLimit(t){this.beaconSizeLimit=t}writeMessage(t){if(\"q_end\"===t[0])return this.finaliseBatch(),this.onOfflineEnd();0===t[0]&&(this.timestamp=t[1]),122===t[0]&&(this.url=t[1]),this.writeWithSize(t)||(this.finaliseBatch(),this.writeWithSize(t)||(this.encoder=new e(this.beaconSizeLimit),this.prepare(),this.writeWithSize(t)?this.finaliseBatch():console.warn(\"OpenReplay: beacon size overflow. Skipping large message.\",t,this),this.encoder=new e(this.beaconSize),this.prepare()))}finaliseBatch(){if(this.isEmpty)return;const t=this.encoder.flush();this.onBatch(t),this.prepare()}clean(){this.encoder.reset()}}var h;!function(t){t[t.NotActive=0]=\"NotActive\",t[t.Starting=1]=\"Starting\",t[t.Stopping=2]=\"Stopping\",t[t.Active=3]=\"Active\",t[t.Stopped=4]=\"Stopped\"}(h||(h={}));let r=null,u=null,a=h.NotActive;function o(){u&&u.finaliseBatch()}function c(){return new Promise((t=>{a=h.Stopping,null!==p&&(clearInterval(p),p=null),u&&(u.clean(),u=null),r&&(r.clean(),setTimeout((()=>{r=null}),20)),setTimeout((()=>{a=h.NotActive,t(null)}),100)}))}function g(){[h.Stopped,h.Stopping].includes(a)||(postMessage(\"a_stop\"),c().then((()=>{postMessage(\"a_start\")})))}let l,p=null;self.onmessage=({data:s})=>{if(null!=s){if(\"stop\"===s)return o(),void c().then((()=>{a=h.Stopped}));if(\"forceFlushBatch\"!==s){if(!Array.isArray(s)){if(\"compressed\"===s.type){if(!r)return console.debug(\"OR WebWorker: sender not initialised. Compressed batch.\"),void g();s.batch&&r.sendCompressed(s.batch)}if(\"uncompressed\"===s.type){if(!r)return console.debug(\"OR WebWorker: sender not initialised. Uncompressed batch.\"),void g();s.batch&&r.sendUncompressed(s.batch)}return\"start\"===s.type?(a=h.Starting,r=new t(s.ingestPoint,(()=>{g()}),(t=>{!function(t){postMessage({type:\"failure\",reason:t}),c()}(t)}),s.connAttemptCount,s.connAttemptGap,(t=>{postMessage({type:\"compress\",batch:t},[t.buffer])}),s.pageNo),u=new n(s.pageNo,s.timestamp,s.url,(t=>{r&&r.push(t)}),s.tabId,(()=>postMessage({type:\"queue_empty\"}))),null===p&&(p=setInterval(o,1e4)),a=h.Active):\"auth\"===s.type?r?u?(r.authorise(s.token),void(s.beaconSizeLimit&&u.setBeaconSizeLimit(s.beaconSizeLimit))):(console.debug(\"OR WebWorker: writer not initialised. Received auth.\"),void g()):(console.debug(\"OR WebWorker: sender not initialised. Received auth.\"),void g()):void 0}if(u){const t=u;s.forEach((s=>{55===s[0]&&(s[1]?l=setTimeout((()=>g()),18e5):clearTimeout(l)),t.writeMessage(s)}))}else postMessage(\"not_init\"),g()}else o()}else o()}}();\n";
var CANCELED = 'canceled';
var uxtStorageKey = 'or_uxt_active';
var bufferStorageKey = 'or_buffer_1';

var UnsuccessfulStart = function UnsuccessfulStart(reason) {
  return {
    reason: reason,
    success: false
  };
};

var SuccessfulStart = function SuccessfulStart(body) {
  return _objectSpread(_objectSpread({}, body), {}, {
    success: true
  });
};

var ActivityState;

(function (ActivityState) {
  ActivityState[ActivityState["NotActive"] = 0] = "NotActive";
  ActivityState[ActivityState["Starting"] = 1] = "Starting";
  ActivityState[ActivityState["Active"] = 2] = "Active";
  ActivityState[ActivityState["ColdStart"] = 3] = "ColdStart";
})(ActivityState || (ActivityState = {})); // TODO: use backendHost only


var DEFAULT_INGEST_POINT = 'https://api.openreplay.com/ingest';

function getTimezone() {
  var offset = new Date().getTimezoneOffset() * -1;
  var sign = offset >= 0 ? '+' : '-';
  var hours = Math.floor(Math.abs(offset) / 60);
  var minutes = Math.abs(offset) % 60;
  return "UTC".concat(sign).concat(String(hours).padStart(2, '0'), ":").concat(String(minutes).padStart(2, '0'));
}

var delay = function delay(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};

var proto = {
  // ask if there are any tabs alive
  ask: 'never-gonna-give-you-up',
  // response from another tab
  resp: 'never-gonna-let-you-down',
  // regenerating id (copied other tab)
  reg: 'never-gonna-run-around-and-desert-you',
  iframeSignal: 'tracker inside a child iframe',
  iframeId: 'getting node id for child iframe',
  iframeBatch: 'batch of messages from an iframe window',
  parentAlive: 'signal that parent is live',
  killIframe: 'stop tracker inside frame',
  startIframe: 'start tracker inside frame',
  // checking updates
  polling: 'hello-how-are-you-im-under-the-water-please-help-me'
};

var App = /*#__PURE__*/function () {
  function App(projectKey, sessionToken, options, signalError, insideIframe) {
    var _this47 = this,
        _this$options$localSt,
        _this$options$session,
        _this$options$nodes,
        _this$options$crossdo;

    _classCallCheck(this, App);

    this.signalError = signalError;
    this.insideIframe = insideIframe;
    this.messages = [];
    /**
     * we need 2 buffers, so we don't lose anything
     * @read coldStart implementation
     * */

    this.bufferedMessages1 = [];
    this.bufferedMessages2 = [];
    this.startCallbacks = [];
    this.stopCallbacks = [];
    this.commitCallbacks = [];
    this.activityState = ActivityState.NotActive;
    this.version = '15.0.1'; // TODO: version compatability check inside each plugin.

    this.socketMode = false;
    this.compressionThreshold = 24 * 1000;
    this.bc = null;
    this.canvasRecorder = null;
    this.conditionsManager = null;
    this.canStart = false;
    this.rootId = null;
    this.pageFrames = [];
    this.frameOderNumber = 0;
    this.features = {
      'feature-flags': true,
      'usability-test': true
    };
    /** used by child iframes for crossdomain only */

    this.parentActive = false;

    this.checkStatus = function () {
      return _this47.parentActive;
    };

    this.parentCrossDomainFrameListener = function (event) {
      var data = event.data;
      if (!data || event.source === window) return;

      if (data.line === proto.startIframe) {
        if (_this47.active()) return;

        try {
          _this47.allowAppStart();

          void _this47.start();
        } catch (e) {
          console.error('children frame restart failed:', e);
        }
      }

      if (data.line === proto.parentAlive) {
        _this47.parentActive = true;
      }

      if (data.line === proto.iframeId) {
        _this47.parentActive = true;
        _this47.rootId = data.id;

        _this47.session.setSessionToken(data.token);

        _this47.frameOderNumber = data.frameOrderNumber;

        _this47.debug.log('starting iframe tracking', data);

        _this47.allowAppStart();
      }

      if (data.line === proto.killIframe) {
        if (_this47.active()) {
          _this47.stop();
        }
      }
    };
    /**
     * context ids for iframes,
     * order is not so important as long as its consistent
     * */


    this.trackedFrames = [];

    this.crossDomainIframeListener = function (event) {
      if (!_this47.active() || event.source === window) return;
      var data = event.data;
      if (!data) return;

      if (data.line === proto.iframeSignal) {
        var _event$source;

        // @ts-ignore
        (_event$source = event.source) === null || _event$source === void 0 ? void 0 : _event$source.postMessage({
          ping: true,
          line: proto.parentAlive
        }, '*');

        var signalId = /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
            var id, _event$source2, token, order, iframeData;

            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  if (!(event.source === null)) {
                    _context8.next = 2;
                    break;
                  }

                  return _context8.abrupt("return", console.error('Couldnt connect to event.source for child iframe tracking'));

                case 2:
                  _context8.next = 4;
                  return _this47.checkNodeId(event.source);

                case 4:
                  id = _context8.sent;

                  if (id) {
                    _context8.next = 8;
                    break;
                  }

                  _this47.debug.log('Couldnt get node id for iframe', event.source);

                  return _context8.abrupt("return");

                case 8:
                  _context8.prev = 8;

                  if (_this47.trackedFrames.includes(data.context)) {
                    _this47.debug.log('Trying to observe already added iframe; ignore if its a restart');
                  } else {
                    _this47.trackedFrames.push(data.context);
                  }

                  _context8.next = 12;
                  return _this47.waitStarted();

                case 12:
                  token = _this47.session.getSessionToken();
                  order = _this47.trackedFrames.findIndex(function (f) {
                    return f === data.context;
                  }) + 1;

                  if (order === 0) {
                    _this47.debug.error('Couldnt get order number for iframe', data.context, _this47.trackedFrames);
                  }

                  iframeData = {
                    line: proto.iframeId,
                    id: id,
                    token: token,
                    // since indexes go from 0 we +1
                    frameOrderNumber: order
                  };

                  _this47.debug.log('Got child frame signal; nodeId', id, event.source, iframeData); // @ts-ignore


                  (_event$source2 = event.source) === null || _event$source2 === void 0 ? void 0 : _event$source2.postMessage(iframeData, '*');
                  _context8.next = 23;
                  break;

                case 20:
                  _context8.prev = 20;
                  _context8.t0 = _context8["catch"](8);
                  console.error(_context8.t0);

                case 23:
                case "end":
                  return _context8.stop();
              }
            }, _callee8, null, [[8, 20]]);
          }));

          return function signalId() {
            return _ref8.apply(this, arguments);
          };
        }();

        void signalId();
      }
      /**
       * proxying messages from iframe to main body, so they can be in one batch (same indexes, etc)
       * plus we rewrite some of the messages to be relative to the main context/window
       * */


      if (data.line === proto.iframeBatch) {
        var _this47$messages;

        var msgBatch = data.messages;
        var mappedMessages = msgBatch.map(function (msg) {
          if (msg[0] === 20
          /* MType.MouseMove */
          ) {
              var fixedMessage = msg;

              _this47.pageFrames.forEach(function (frame) {
                if (frame.contentWindow === event.source) {
                  var _msg2 = _slicedToArray(msg, 3),
                      type = _msg2[0],
                      _x10 = _msg2[1],
                      _y = _msg2[2];

                  var _frame$getBoundingCli2 = frame.getBoundingClientRect(),
                      left = _frame$getBoundingCli2.left,
                      top = _frame$getBoundingCli2.top;

                  fixedMessage = [type, _x10 + left, _y + top];
                }
              });

              return fixedMessage;
            }

          if (msg[0] === 68
          /* MType.MouseClick */
          ) {
              var _fixedMessage = msg;

              _this47.pageFrames.forEach(function (frame) {
                if (frame.contentWindow === event.source) {
                  var _msg4 = _slicedToArray(msg, 7),
                      type = _msg4[0],
                      _id4 = _msg4[1],
                      hesitationTime = _msg4[2],
                      label = _msg4[3],
                      _selector = _msg4[4],
                      normX = _msg4[5],
                      normY = _msg4[6];

                  var _frame$getBoundingCli4 = frame.getBoundingClientRect(),
                      left = _frame$getBoundingCli4.left,
                      top = _frame$getBoundingCli4.top,
                      width = _frame$getBoundingCli4.width,
                      height = _frame$getBoundingCli4.height;

                  var contentWidth = document.documentElement.scrollWidth;
                  var contentHeight = document.documentElement.scrollHeight; // (normalizedX * frameWidth + frameLeftOffset)/docSize

                  var fullX = normX / 100 * width + left;
                  var fullY = normY / 100 * height + top;
                  var fixedX = fullX / contentWidth;
                  var fixedY = fullY / contentHeight;
                  _fixedMessage = [type, _id4, hesitationTime, label, _selector, Math.round(fixedX * 1e3) / 1e1, Math.round(fixedY * 1e3) / 1e1];
                }
              });

              return _fixedMessage;
            }

          return msg;
        });

        (_this47$messages = _this47.messages).push.apply(_this47$messages, _toConsumableArray(mappedMessages));
      }

      if (data.line === proto.polling) {
        if (!_this47.pollingQueue.order.length) {
          return;
        }

        var nextCommand = _this47.pollingQueue.order[0];

        if (nextCommand && _this47.pollingQueue[nextCommand].length === 0) {
          _this47.pollingQueue.order = _this47.pollingQueue.order.filter(function (c) {
            return c !== nextCommand;
          });
          return;
        }

        if (_this47.pollingQueue[nextCommand].includes(data.context)) {
          var _event$source3;

          _this47.pollingQueue[nextCommand] = _this47.pollingQueue[nextCommand].filter(function (c) {
            return c !== data.context;
          }); // @ts-ignore

          (_event$source3 = event.source) === null || _event$source3 === void 0 ? void 0 : _event$source3.postMessage({
            line: nextCommand
          }, '*');

          if (_this47.pollingQueue[nextCommand].length === 0) {
            _this47.pollingQueue.order.shift();
          }
        }
      }
    };
    /**
     * { command : [remaining iframes] }
     * + order of commands
     **/


    this.pollingQueue = {
      order: []
    };

    this.addCommand = function (cmd) {
      _this47.pollingQueue.order.push(cmd);

      _this47.pollingQueue[cmd] = _toConsumableArray(_this47.trackedFrames);
    };

    this.bootChildrenFrames = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _this47.waitStarted();

          case 2:
            _this47.addCommand(proto.startIframe);

          case 3:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));

    this.killChildrenFrames = function () {
      _this47.addCommand(proto.killIframe);
    };

    this.signalIframeTracker = function () {
      var _this47$options$cross, _this47$options$cross2;

      var thisTab = _this47.session.getTabId();

      window.parent.postMessage({
        line: proto.iframeSignal,
        source: thisTab,
        context: _this47.contextId
      }, (_this47$options$cross = (_this47$options$cross2 = _this47.options.crossdomain) === null || _this47$options$cross2 === void 0 ? void 0 : _this47$options$cross2.parentDomain) !== null && _this47$options$cross !== void 0 ? _this47$options$cross : '*');
      /**
       * since we need to wait uncertain amount of time
       * and I don't want to have recursion going on,
       * we'll just use a timeout loop with backoff
       * */

      var maxRetries = 10;
      var retries = 0;
      var delay = 250;
      var cumulativeDelay = 0;
      var stopAttempts = false;

      var checkAndSendMessage = function checkAndSendMessage() {
        var _this47$options$cross3, _this47$options$cross4;

        if (stopAttempts || _this47.checkStatus()) {
          stopAttempts = true;
          return;
        }

        window.parent.postMessage({
          line: proto.iframeSignal,
          source: thisTab,
          context: _this47.contextId
        }, (_this47$options$cross3 = (_this47$options$cross4 = _this47.options.crossdomain) === null || _this47$options$cross4 === void 0 ? void 0 : _this47$options$cross4.parentDomain) !== null && _this47$options$cross3 !== void 0 ? _this47$options$cross3 : '*');

        _this47.debug.info('Trying to signal to parent, attempt:', retries + 1);

        retries++;
      };

      for (var _i12 = 0; _i12 < maxRetries; _i12++) {
        if (_this47.checkStatus()) {
          stopAttempts = true;
          break;
        }

        cumulativeDelay += delay;
        setTimeout(function () {
          checkAndSendMessage();
        }, cumulativeDelay);
        delay *= 1.5;
      }
    };

    this.startTimeout = null;
    this.coldStartCommitN = 0;
    this.delay = 0;

    this.attachStartCallback = function (cb) {
      var useSafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (useSafe) {
        cb = _this47.safe(cb);
      }

      _this47.startCallbacks.push(cb);
    };

    this.attachStopCallback = function (cb) {
      var useSafe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (useSafe) {
        cb = _this47.safe(cb);
      }

      _this47.stopCallbacks.push(cb);
    };

    this.attachEventListener = function (target, type, listener) {
      var useSafe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var useCapture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      if (useSafe) {
        listener = _this47.safe(listener);
      }

      var createListener = function createListener() {
        return target ? createEventListener(target, type, listener, useCapture, _this47.options.forceNgOff) : null;
      };

      var deleteListener = function deleteListener() {
        return target ? deleteEventListener(target, type, listener, useCapture, _this47.options.forceNgOff) : null;
      };

      _this47.attachStartCallback(createListener, useSafe);

      _this47.attachStopCallback(deleteListener, useSafe);
    };

    this.coldInterval = null;
    this.orderNumber = 0;
    this.coldStartTs = 0;
    this.singleBuffer = false;

    this.onSessionSent = function () {
      return;
    };

    this.prevOpts = {};

    this.restartCanvasTracking = function () {
      var _this47$canvasRecorde;

      (_this47$canvasRecorde = _this47.canvasRecorder) === null || _this47$canvasRecorde === void 0 ? void 0 : _this47$canvasRecorde.restartTracking();
    };

    this.flushBuffer = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(buffer) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", new Promise(function (res) {
                var ended = false;
                var messagesBatch = [buffer.shift()];

                while (!ended) {
                  var nextMsg = buffer[0];

                  if (!nextMsg || nextMsg[0] === 0
                  /* MType.Timestamp */
                  )
                    /* MType.Timestamp */
                    {
                      ended = true;
                    } else {
                    messagesBatch.push(buffer.shift());
                  }
                }

                _this47.postToWorker(messagesBatch);

                res(null);
              }));

            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));

      return function (_x11) {
        return _ref10.apply(this, arguments);
      };
    }();

    this.onUxtCb = [];
    this.contextId = Math.random().toString(36).slice(2);
    this.projectKey = projectKey;

    if (Object.keys(options).findIndex(function (k) {
      return ['fixedCanvasScaling', 'disableCanvas'].includes(k);
    }) !== -1) {
      console.warn('Openreplay: canvas options are moving to separate key "canvas" in next update. Please update your configuration.');
      options = _objectSpread(_objectSpread({}, options), {}, {
        canvas: {
          __save_canvas_locally: options.__save_canvas_locally,
          fixedCanvasScaling: options.fixedCanvasScaling,
          disableCanvas: options.disableCanvas
        }
      });
    }

    this.networkOptions = options.network;
    var defaultOptions = {
      revID: '',
      node_id: '__openreplay_id',
      session_token_key: '__openreplay_token',
      session_pageno_key: '__openreplay_pageno',
      session_reset_key: '__openreplay_reset',
      session_tabid_key: '__openreplay_tabid',
      local_uuid_key: '__openreplay_uuid',
      ingestPoint: DEFAULT_INGEST_POINT,
      resourceBaseHref: null,
      __is_snippet: false,
      __debug_report_edp: null,
      __debug__: LogLevel.Silent,
      __save_canvas_locally: false,
      localStorage: null,
      sessionStorage: null,
      disableStringDict: false,
      forceSingleTab: false,
      assistSocketHost: '',
      fixedCanvasScaling: false,
      disableCanvas: false,
      captureIFrames: true,
      obscureTextEmails: true,
      obscureTextNumbers: false,
      crossdomain: {
        parentDomain: '*'
      },
      canvas: {
        disableCanvas: false,
        fixedCanvasScaling: false,
        __save_canvas_locally: false,
        useAnimationFrame: false
      },
      forceNgOff: false
    };
    this.options = simpleMerge(defaultOptions, options);

    if (!this.insideIframe && !this.options.forceSingleTab && globalThis && 'BroadcastChannel' in globalThis) {
      var host = location.hostname.split('.').slice(-2).join('_');
      this.bc = new BroadcastChannel("rick_".concat(host));
    }

    this.revID = this.options.revID;
    this.localStorage = (_this$options$localSt = this.options.localStorage) !== null && _this$options$localSt !== void 0 ? _this$options$localSt : window.localStorage;
    this.sessionStorage = (_this$options$session = this.options.sessionStorage) !== null && _this$options$session !== void 0 ? _this$options$session : window.sessionStorage;
    this.sanitizer = new Sanitizer({
      app: this,
      options: options
    });
    this.nodes = new Nodes({
      node_id: this.options.node_id,
      forceNgOff: Boolean(options.forceNgOff),
      maintainer: (_this$options$nodes = this.options.nodes) === null || _this$options$nodes === void 0 ? void 0 : _this$options$nodes.maintainer
    });
    this.observer = new TopObserver({
      app: this,
      options: options
    });
    this.ticker = new Ticker(this);
    this.ticker.attach(function () {
      return _this47.commit();
    });
    this.debug = new Logger(this.options.__debug__);
    this.session = new Session({
      app: this,
      options: this.options
    });
    this.attributeSender = new AttributeSender({
      app: this,
      isDictDisabled: Boolean(this.options.disableStringDict || ((_this$options$crossdo = this.options.crossdomain) === null || _this$options$crossdo === void 0 ? void 0 : _this$options$crossdo.enabled))
    });
    this.featureFlags = new FeatureFlags(this);
    this.tagWatcher = new TagWatcher({
      sessionStorage: this.sessionStorage,
      errLog: this.debug.error,
      onTag: function onTag(tag) {
        return _this47.send(TagTrigger(tag));
      }
    });
    this.session.attachUpdateCallback(function (_ref11) {
      var userID = _ref11.userID,
          metadata = _ref11.metadata;

      if (userID != null) {
        // TODO: nullable userID
        _this47.send(UserID(userID));
      }

      if (metadata != null) {
        Object.entries(metadata).forEach(function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
              key = _ref13[0],
              value = _ref13[1];

          return _this47.send(Metadata(key, value));
        });
      }
    }); // @deprecated (use sessionHash on start instead)

    if (sessionToken != null) {
      this.session.applySessionHash(sessionToken);
    }

    var thisTab = this.session.getTabId();

    if (this.insideIframe) {
      /**
       * listen for messages from parent window, so we can signal that we're alive
       * */
      window.addEventListener('message', this.parentCrossDomainFrameListener);
      setInterval(function () {
        var _options$crossdomain$, _options$crossdomain;

        if (document.hidden) {
          return;
        }

        window.parent.postMessage({
          line: proto.polling,
          context: _this47.contextId
        }, (_options$crossdomain$ = (_options$crossdomain = options.crossdomain) === null || _options$crossdomain === void 0 ? void 0 : _options$crossdomain.parentDomain) !== null && _options$crossdomain$ !== void 0 ? _options$crossdomain$ : '*');
      }, 250);
    } else {
      this.initWorker();
      /**
       * if we get a signal from child iframes, we check for their node_id and send it back,
       * so they can act as if it was just a same-domain iframe
       * */

      window.addEventListener('message', this.crossDomainIframeListener);
    }

    if (this.bc !== null) {
      this.bc.postMessage({
        line: proto.ask,
        source: thisTab,
        context: this.contextId
      });
      this.startTimeout = setTimeout(function () {
        _this47.allowAppStart();
      }, 250);

      this.bc.onmessage = function (ev) {
        if (ev.data.context === _this47.contextId) {
          return;
        }

        if (ev.data.line === proto.resp) {
          var _sessionToken = ev.data.token;

          _this47.session.setSessionToken(_sessionToken);

          _this47.allowAppStart();
        }

        if (ev.data.line === proto.reg) {
          var _sessionToken2 = ev.data.token;

          _this47.session.regenerateTabId();

          _this47.session.setSessionToken(_sessionToken2);

          _this47.allowAppStart();
        }

        if (ev.data.line === proto.ask) {
          var token = _this47.session.getSessionToken();

          if (token && _this47.bc) {
            _this47.bc.postMessage({
              line: ev.data.source === thisTab ? proto.reg : proto.resp,
              token: token,
              source: thisTab,
              context: _this47.contextId
            });
          }
        }
      };
    }
  }

  _createClass(App, [{
    key: "allowAppStart",
    value: function allowAppStart() {
      this.canStart = true;

      if (this.startTimeout) {
        clearTimeout(this.startTimeout);
        this.startTimeout = null;
      }
    }
  }, {
    key: "checkNodeId",
    value: function () {
      var _checkNodeId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(source) {
        var targetFrame, pageIframes, tries, potentialId;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (this.pageFrames.length > 0) {
                targetFrame = this.pageFrames.find(function (frame) {
                  return frame.contentWindow === source;
                });
              }

              if (!targetFrame || !this.pageFrames.length) {
                pageIframes = Array.from(document.querySelectorAll('iframe'));
                this.pageFrames = pageIframes;
                targetFrame = pageIframes.find(function (frame) {
                  return frame.contentWindow === source;
                });
              }

              if (targetFrame) {
                _context11.next = 4;
                break;
              }

              return _context11.abrupt("return", null);

            case 4:
              /**
               * Here we're trying to get node id from the iframe (which is kept in observer)
               * because of async nature of dom initialization, we give 100 retries with 100ms delay each
               * which equals to 10 seconds. This way we have a period where we give app some time to load
               * and tracker some time to parse the initial DOM tree even on slower devices
               * */
              tries = 0;

            case 5:
              if (!(tries < 100)) {
                _context11.next = 17;
                break;
              }

              // @ts-ignore
              potentialId = targetFrame[this.options.node_id];

              if (!(potentialId !== undefined)) {
                _context11.next = 12;
                break;
              }

              tries = 100;
              return _context11.abrupt("return", potentialId);

            case 12:
              tries++;
              _context11.next = 15;
              return delay(100);

            case 15:
              _context11.next = 5;
              break;

            case 17:
              return _context11.abrupt("return", null);

            case 18:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));

      function checkNodeId(_x12) {
        return _checkNodeId.apply(this, arguments);
      }

      return checkNodeId;
    }()
  }, {
    key: "initWorker",
    value: function initWorker() {
      var _this48 = this;

      try {
        this.worker = new Worker(URL.createObjectURL(new Blob([workerBodyFn], {
          type: 'text/javascript'
        })));

        this.worker.onerror = function (e) {
          _this48._debug('webworker_error', e);
        };

        this.worker.onmessage = function (_ref14) {
          var data = _ref14.data;

          _this48.handleWorkerMsg(data);
        };

        var alertWorker = function alertWorker() {
          if (_this48.worker) {
            _this48.worker.postMessage(null);
          }
        }; // keep better tactics, discard others?


        this.attachEventListener(window, 'beforeunload', alertWorker, false);
        this.attachEventListener(document.body, 'mouseleave', alertWorker, false, false); // TODO: stop session after inactivity timeout (make configurable)

        this.attachEventListener(document, 'visibilitychange', alertWorker, false);
      } catch (e) {
        this._debug('worker_start', e);
      }
    }
  }, {
    key: "handleWorkerMsg",
    value: function handleWorkerMsg(data) {
      var _this49 = this;

      // handling 401 auth restart (new token assignment)
      if (data === 'a_stop') {
        this.stop(false);
      } else if (data === 'a_start') {
        this.waitStatus(ActivityState.NotActive).then(function () {
          _this49.allowAppStart();

          _this49.start(_this49.prevOpts, true).then(function (r) {
            _this49.debug.info('Worker restart, session too long', r);
          }).catch(function (e) {
            _this49.debug.error('Worker restart failed', e);
          });
        });
      } else if (data === 'not_init') {
        this.debug.warn('OR WebWorker: writer not initialised. Restarting tracker');
      } else if (data.type === 'failure') {
        this.stop(false);
        this.debug.error('worker_failed', data.reason);

        this._debug('worker_failed', data.reason);
      } else if (data.type === 'compress') {
        var batch = data.batch;
        var batchSize = batch.byteLength;

        if (batchSize > this.compressionThreshold) {
          gzip(data.batch, {
            mtime: 0
          }, function (err, result) {
            if (err) {
              var _this49$worker;

              _this49.debug.error('Openreplay compression error:', err);

              (_this49$worker = _this49.worker) === null || _this49$worker === void 0 ? void 0 : _this49$worker.postMessage({
                type: 'uncompressed',
                batch: batch
              });
            } else {
              var _this49$worker2;

              (_this49$worker2 = _this49.worker) === null || _this49$worker2 === void 0 ? void 0 : _this49$worker2.postMessage({
                type: 'compressed',
                batch: result
              });
            }
          });
        } else {
          var _this$worker;

          (_this$worker = this.worker) === null || _this$worker === void 0 ? void 0 : _this$worker.postMessage({
            type: 'uncompressed',
            batch: batch
          });
        }
      } else if (data.type === 'queue_empty') {
        this.onSessionSent();
      }
    }
  }, {
    key: "_debug",
    value: function _debug(context, e) {
      if (this.options.__debug_report_edp !== null) {
        void fetch(this.options.__debug_report_edp, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            context: context,
            // @ts-ignore
            error: "".concat(e)
          })
        });
      }

      this.debug.error('OpenReplay error: ', context, e);
    }
  }, {
    key: "send",
    value: function send(message) {
      var urgent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.activityState === ActivityState.NotActive) {
        return;
      } // ====================================================


      if (this.activityState === ActivityState.ColdStart) {
        var _this$conditionsManag;

        this.bufferedMessages1.push(message);

        if (!this.singleBuffer) {
          this.bufferedMessages2.push(message);
        }

        (_this$conditionsManag = this.conditionsManager) === null || _this$conditionsManag === void 0 ? void 0 : _this$conditionsManag.processMessage(message);
      } else {
        this.messages.push(message);
      } // TODO: commit on start if there were `urgent` sends;
      // Clarify where urgent can be used for;
      // Clarify workflow for each type of message in case it was sent before start
      //      (like Fetch before start; maybe add an option "preCapture: boolean" or sth alike)
      // Careful: `this.delay` is equal to zero before start so all Timestamp-s will have to be updated on start


      if (this.activityState === ActivityState.Active && urgent) {
        this.commit();
      }
    }
    /**
     * Normal workflow: add timestamp and tab data to batch, then commit it
     * every ~30ms
     * */

  }, {
    key: "_nCommit",
    value: function _nCommit() {
      var _this50 = this;

      if (this.socketMode) {
        this.messages.unshift(TabData(this.session.getTabId()));
        this.messages.unshift(Timestamp(this.timestamp()));
        this.commitCallbacks.forEach(function (cb) {
          return cb(_this50.messages);
        });
        this.messages.length = 0;
        return;
      }

      if (this.insideIframe) {
        var _this$options$crossdo2, _this$options$crossdo3;

        window.parent.postMessage({
          line: proto.iframeBatch,
          messages: this.messages
        }, (_this$options$crossdo2 = (_this$options$crossdo3 = this.options.crossdomain) === null || _this$options$crossdo3 === void 0 ? void 0 : _this$options$crossdo3.parentDomain) !== null && _this$options$crossdo2 !== void 0 ? _this$options$crossdo2 : '*');
        this.commitCallbacks.forEach(function (cb) {
          return cb(_this50.messages);
        });
        this.messages.length = 0;
        return;
      }

      if (this.worker === undefined || !this.messages.length) {
        return;
      }

      try {
        requestIdleCb(function () {
          var _this50$worker;

          _this50.messages.unshift(TabData(_this50.session.getTabId()));

          _this50.messages.unshift(Timestamp(_this50.timestamp()));

          (_this50$worker = _this50.worker) === null || _this50$worker === void 0 ? void 0 : _this50$worker.postMessage(_this50.messages);

          _this50.commitCallbacks.forEach(function (cb) {
            return cb(_this50.messages);
          });

          _this50.messages.length = 0;
        });
      } catch (e) {
        this._debug('worker_commit', e);

        this.stop(true);
        setTimeout(function () {
          void _this50.start();
        }, 500);
      }
    }
    /**
     * Cold start: add timestamp and tab data to both batches
     * every 2nd tick, ~60ms
     * this will make batches a bit larger and replay will work with bigger jumps every frame
     * but in turn we don't overload batch writer on session start with 1000 batches
     * */

  }, {
    key: "_cStartCommit",
    value: function _cStartCommit() {
      this.coldStartCommitN += 1;

      if (this.coldStartCommitN === 2) {
        this.bufferedMessages1.push(Timestamp(this.timestamp()));
        this.bufferedMessages1.push(TabData(this.session.getTabId()));
        this.bufferedMessages2.push(Timestamp(this.timestamp()));
        this.bufferedMessages2.push(TabData(this.session.getTabId()));
        this.coldStartCommitN = 0;
      }
    }
  }, {
    key: "commit",
    value: function commit() {
      if (this.activityState === ActivityState.ColdStart) {
        this._cStartCommit();
      } else {
        this._nCommit();
      }
    }
  }, {
    key: "postToWorker",
    value: function postToWorker(messages) {
      var _this$worker2;

      (_this$worker2 = this.worker) === null || _this$worker2 === void 0 ? void 0 : _this$worker2.postMessage(messages);
      this.commitCallbacks.forEach(function (cb) {
        return cb(messages);
      });
      messages.length = 0;
    }
  }, {
    key: "timestamp",
    value: function timestamp() {
      return now() + this.delay;
    }
  }, {
    key: "safe",
    value: function safe(fn) {
      var app = this;
      return function () {
        try {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          fn.apply(this, args);
        } catch (e) {
          app._debug('safe_fn_call', e); // time: this.timestamp(),
          // name: e.name,
          // message: e.message,
          // stack: e.stack

        }
      }; // TODO: correct typing
    }
  }, {
    key: "attachCommitCallback",
    value: function attachCommitCallback(cb) {
      this.commitCallbacks.push(cb);
    } // TODO: full correct semantic

  }, {
    key: "checkRequiredVersion",
    value: function checkRequiredVersion(version) {
      var reqVer = version.split(/[.-]/);
      var ver = this.version.split(/[.-]/);

      for (var _i14 = 0; _i14 < 3; _i14++) {
        if (isNaN(Number(ver[_i14])) || isNaN(Number(reqVer[_i14]))) {
          return false;
        }

        if (Number(ver[_i14]) > Number(reqVer[_i14])) {
          return true;
        }

        if (Number(ver[_i14]) < Number(reqVer[_i14])) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "getTrackerInfo",
    value: function getTrackerInfo() {
      return {
        userUUID: this.localStorage.getItem(this.options.local_uuid_key),
        projectKey: this.projectKey,
        revID: this.revID,
        trackerVersion: this.version,
        isSnippet: this.options.__is_snippet
      };
    }
  }, {
    key: "getSessionInfo",
    value: function getSessionInfo() {
      return _objectSpread(_objectSpread({}, this.session.getInfo()), this.getTrackerInfo());
    }
  }, {
    key: "getSessionToken",
    value: function getSessionToken() {
      return this.session.getSessionToken();
    }
  }, {
    key: "getSessionID",
    value: function getSessionID() {
      return this.session.getInfo().sessionID || undefined;
    }
  }, {
    key: "getSessionURL",
    value: function getSessionURL(options) {
      var _this$session$getInfo = this.session.getInfo(),
          projectID = _this$session$getInfo.projectID,
          sessionID = _this$session$getInfo.sessionID,
          timestamp = _this$session$getInfo.timestamp;

      if (!projectID || !sessionID) {
        this.debug.error('OpenReplay error: Unable to build session URL');
        return undefined;
      }

      var ingest = this.options.ingestPoint;
      var isSaas = /api\.openreplay\.com/.test(ingest);
      var projectPath = isSaas ? 'https://app.openreplay.com/ingest' : ingest;
      var url = projectPath.replace(/ingest$/, "".concat(projectID, "/session/").concat(sessionID));

      if (options !== null && options !== void 0 && options.withCurrentTime) {
        var jumpTo = now() - timestamp;
        return "".concat(url, "?jumpto=").concat(jumpTo);
      }

      return url;
    }
  }, {
    key: "getHost",
    value: function getHost() {
      return new URL(this.options.ingestPoint).host;
    }
  }, {
    key: "getProjectKey",
    value: function getProjectKey() {
      return this.projectKey;
    }
  }, {
    key: "getBaseHref",
    value: function getBaseHref() {
      var _document$head, _document$head$getEle;

      if (typeof this.options.resourceBaseHref === 'string') {
        return this.options.resourceBaseHref;
      } else if (typeof this.options.resourceBaseHref === 'object') ;

      if (document.baseURI) {
        return document.baseURI;
      } // IE only


      return ((_document$head = document.head) === null || _document$head === void 0 ? void 0 : (_document$head$getEle = _document$head.getElementsByTagName('base')[0]) === null || _document$head$getEle === void 0 ? void 0 : _document$head$getEle.getAttribute('href')) || location.origin + location.pathname;
    }
  }, {
    key: "resolveResourceURL",
    value: function resolveResourceURL(resourceURL) {
      var base = new URL(this.getBaseHref());
      base.pathname += '/' + new URL(resourceURL).pathname;
      base.pathname.replace(/\/+/g, '/');
      return base.toString();
    }
  }, {
    key: "isServiceURL",
    value: function isServiceURL(url) {
      return url.startsWith(this.options.ingestPoint);
    }
  }, {
    key: "active",
    value: function active() {
      return this.activityState === ActivityState.Active;
    }
  }, {
    key: "resetNextPageSession",
    value: function resetNextPageSession(flag) {
      if (flag) {
        this.sessionStorage.setItem(this.options.session_reset_key, 't');
      } else {
        this.sessionStorage.removeItem(this.options.session_reset_key);
      }
    }
  }, {
    key: "checkSessionToken",
    value: function checkSessionToken(forceNew) {
      var lsReset = this.sessionStorage.getItem(this.options.session_reset_key) !== null;
      var needNewSessionID = forceNew || lsReset;
      var sessionToken = this.session.getSessionToken();
      return needNewSessionID || !sessionToken;
    }
    /**
     * start buffering messages without starting the actual session, which gives
     * user 30 seconds to "activate" and record session by calling `start()` on conditional trigger,
     * and we will then send buffered batch, so it won't get lost
     * */

  }, {
    key: "coldStart",
    value: function () {
      var _coldStart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this51 = this;

        var startOpts,
            conditional,
            second,
            isNewSession,
            cycle,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              startOpts = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
              conditional = _args12.length > 1 ? _args12[1] : undefined;
              this.singleBuffer = false;
              second = 1000;
              isNewSession = this.checkSessionToken(startOpts.forceNew);

              if (!conditional) {
                _context12.next = 8;
                break;
              }

              _context12.next = 8;
              return this.setupConditionalStart(startOpts);

            case 8:
              cycle = function cycle() {
                _this51.orderNumber += 1;
                adjustTimeOrigin();
                _this51.coldStartTs = now();

                if (_this51.orderNumber % 2 === 0) {
                  _this51.bufferedMessages1.length = 0;

                  _this51.bufferedMessages1.push(Timestamp(_this51.timestamp()));

                  _this51.bufferedMessages1.push(TabData(_this51.session.getTabId()));
                } else {
                  _this51.bufferedMessages2.length = 0;

                  _this51.bufferedMessages2.push(Timestamp(_this51.timestamp()));

                  _this51.bufferedMessages2.push(TabData(_this51.session.getTabId()));
                }

                _this51.stop(false);

                _this51.activityState = ActivityState.ColdStart;

                if (startOpts.sessionHash) {
                  _this51.session.applySessionHash(startOpts.sessionHash);
                }

                if (startOpts.forceNew) {
                  _this51.session.reset();
                }

                _this51.session.assign({
                  userID: startOpts.userID,
                  metadata: startOpts.metadata
                });

                if (!isNewSession) {
                  _this51.debug.log('continuing session on new tab', _this51.session.getTabId()); // eslint-disable-next-line @typescript-eslint/no-unsafe-argument


                  _this51.send(TabChange(_this51.session.getTabId()));
                }

                _this51.observer.observe();

                _this51.ticker.start();
              };

              this.coldInterval = setInterval(function () {
                cycle();
              }, 30 * second);
              cycle();

            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));

      function coldStart() {
        return _coldStart.apply(this, arguments);
      }

      return coldStart;
    }()
  }, {
    key: "setupConditionalStart",
    value: function () {
      var _setupConditionalStart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(startOpts) {
        var _this$conditionsManag2;

        var r, _yield$r$json3, token, userBrowser, userCity, userCountry, userDevice, userOS, userState, projectID, features, onStartInfo, _this$conditionsManag3;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              this.conditionsManager = new ConditionsManager(this, startOpts);
              _context13.next = 3;
              return fetch(this.options.ingestPoint + '/v1/web/start', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_objectSpread(_objectSpread({}, this.getTrackerInfo()), {}, {
                  timestamp: now(),
                  doNotRecord: true,
                  bufferDiff: 0,
                  userID: this.session.getInfo().userID,
                  token: undefined,
                  deviceMemory: deviceMemory,
                  jsHeapSizeLimit: jsHeapSizeLimit,
                  timezone: getTimezone(),
                  width: window.screen.width,
                  height: window.screen.height
                }))
              });

            case 3:
              r = _context13.sent;
              _context13.next = 6;
              return r.json();

            case 6:
              _yield$r$json3 = _context13.sent;
              token = _yield$r$json3.token;
              userBrowser = _yield$r$json3.userBrowser;
              userCity = _yield$r$json3.userCity;
              userCountry = _yield$r$json3.userCountry;
              userDevice = _yield$r$json3.userDevice;
              userOS = _yield$r$json3.userOS;
              userState = _yield$r$json3.userState;
              projectID = _yield$r$json3.projectID;
              features = _yield$r$json3.features;
              this.features = features ? features : this.features;
              this.session.assign({
                projectID: projectID
              });
              this.session.setUserInfo({
                userBrowser: userBrowser,
                userCity: userCity,
                userCountry: userCountry,
                userDevice: userDevice,
                userOS: userOS,
                userState: userState
              });
              onStartInfo = {
                sessionToken: token,
                userUUID: '',
                sessionID: ''
              };
              this.startCallbacks.forEach(function (cb) {
                return cb(onStartInfo);
              });
              _context13.next = 23;
              return (_this$conditionsManag2 = this.conditionsManager) === null || _this$conditionsManag2 === void 0 ? void 0 : _this$conditionsManag2.fetchConditions(projectID, token);

            case 23:
              if (!this.features['feature-flags']) {
                _context13.next = 27;
                break;
              }

              _context13.next = 26;
              return this.featureFlags.reloadFlags(token);

            case 26:
              (_this$conditionsManag3 = this.conditionsManager) === null || _this$conditionsManag3 === void 0 ? void 0 : _this$conditionsManag3.processFlags(this.featureFlags.flags);

            case 27:
              _context13.next = 29;
              return this.tagWatcher.fetchTags(this.options.ingestPoint, token);

            case 29:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));

      function setupConditionalStart(_x13) {
        return _setupConditionalStart.apply(this, arguments);
      }

      return setupConditionalStart;
    }()
    /**
     * Starts offline session recording
     * @param {Object} startOpts - options for session start, same as .start()
     * @param {Function} onSessionSent - callback that will be called once session is fully sent
     * */

  }, {
    key: "offlineRecording",
    value: function offlineRecording() {
      var startOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onSessionSent = arguments.length > 1 ? arguments[1] : undefined;
      this.onSessionSent = onSessionSent;
      this.singleBuffer = true;
      var isNewSession = this.checkSessionToken(startOpts.forceNew);
      adjustTimeOrigin();
      this.coldStartTs = now();
      var saverBuffer = this.localStorage.getItem(bufferStorageKey);

      if (saverBuffer) {
        var data = JSON.parse(saverBuffer);
        this.bufferedMessages1 = Array.isArray(data) ? data : this.bufferedMessages1;
        this.localStorage.removeItem(bufferStorageKey);
      }

      this.bufferedMessages1.push(Timestamp(this.timestamp()));
      this.bufferedMessages1.push(TabData(this.session.getTabId()));
      this.activityState = ActivityState.ColdStart;

      if (startOpts.sessionHash) {
        this.session.applySessionHash(startOpts.sessionHash);
      }

      if (startOpts.forceNew) {
        this.session.reset();
      }

      this.session.assign({
        userID: startOpts.userID,
        metadata: startOpts.metadata
      });
      var onStartInfo = {
        sessionToken: '',
        userUUID: '',
        sessionID: ''
      };
      this.startCallbacks.forEach(function (cb) {
        return cb(onStartInfo);
      });

      if (!isNewSession) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        this.send(TabChange(this.session.getTabId()));
      }

      this.observer.observe();
      this.ticker.start();
      return {
        saveBuffer: this.saveBuffer,
        getBuffer: this.getBuffer,
        setBuffer: this.setBuffer
      };
    }
    /**
     * Saves the captured messages in localStorage (or whatever is used in its place)
     *
     * Then, when this.offlineRecording is called, it will preload this messages and clear the storage item
     *
     * Keeping the size of local storage reasonable is up to the end users of this library
     * */

  }, {
    key: "saveBuffer",
    value: function saveBuffer() {
      this.localStorage.setItem(bufferStorageKey, JSON.stringify(this.bufferedMessages1));
    }
    /**
     * @returns buffer with stored messages for offline recording
     * */

  }, {
    key: "getBuffer",
    value: function getBuffer() {
      return this.bufferedMessages1;
    }
    /**
     * Used to set a buffer with messages array
     * */

  }, {
    key: "setBuffer",
    value: function setBuffer(buffer) {
      this.bufferedMessages1 = buffer;
    }
    /**
     * Uploads the stored session buffer to backend
     * @returns promise that resolves once messages are loaded, it has to be awaited
     * so the session can be uploaded properly
     * @resolve - if messages were loaded in service worker successfully
     * @reject {string} - error message
     * */

  }, {
    key: "uploadOfflineRecording",
    value: function () {
      var _uploadOfflineRecording = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this$worker3, _this$worker4;

        var timestamp, r, _yield$r$json4, token, userBrowser, userCity, userCountry, userDevice, userOS, userState, beaconSizeLimit, projectID;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              this.stop(false);
              timestamp = now();
              (_this$worker3 = this.worker) === null || _this$worker3 === void 0 ? void 0 : _this$worker3.postMessage({
                type: 'start',
                pageNo: this.session.incPageNo(),
                ingestPoint: this.options.ingestPoint,
                timestamp: this.coldStartTs,
                url: document.URL,
                connAttemptCount: this.options.connAttemptCount,
                connAttemptGap: this.options.connAttemptGap,
                tabId: this.session.getTabId()
              });
              _context14.next = 5;
              return fetch(this.options.ingestPoint + '/v1/web/start', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_objectSpread(_objectSpread({}, this.getTrackerInfo()), {}, {
                  timestamp: timestamp,
                  doNotRecord: false,
                  bufferDiff: timestamp - this.coldStartTs,
                  userID: this.session.getInfo().userID,
                  token: undefined,
                  deviceMemory: deviceMemory,
                  jsHeapSizeLimit: jsHeapSizeLimit,
                  timezone: getTimezone()
                }))
              });

            case 5:
              r = _context14.sent;
              _context14.next = 8;
              return r.json();

            case 8:
              _yield$r$json4 = _context14.sent;
              token = _yield$r$json4.token;
              userBrowser = _yield$r$json4.userBrowser;
              userCity = _yield$r$json4.userCity;
              userCountry = _yield$r$json4.userCountry;
              userDevice = _yield$r$json4.userDevice;
              userOS = _yield$r$json4.userOS;
              userState = _yield$r$json4.userState;
              beaconSizeLimit = _yield$r$json4.beaconSizeLimit;
              projectID = _yield$r$json4.projectID;
              (_this$worker4 = this.worker) === null || _this$worker4 === void 0 ? void 0 : _this$worker4.postMessage({
                type: 'auth',
                token: token,
                beaconSizeLimit: beaconSizeLimit
              });
              this.session.assign({
                projectID: projectID
              });
              this.session.setUserInfo({
                userBrowser: userBrowser,
                userCity: userCity,
                userCountry: userCountry,
                userDevice: userDevice,
                userOS: userOS,
                userState: userState
              });

            case 21:
              if (!(this.bufferedMessages1.length > 0)) {
                _context14.next = 26;
                break;
              }

              _context14.next = 24;
              return this.flushBuffer(this.bufferedMessages1);

            case 24:
              _context14.next = 21;
              break;

            case 26:
              this.postToWorker([['q_end']]);
              this.clearBuffers();

            case 28:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));

      function uploadOfflineRecording() {
        return _uploadOfflineRecording.apply(this, arguments);
      }

      return uploadOfflineRecording;
    }()
  }, {
    key: "_start",
    value: function () {
      var _start2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$worker5,
            _this52 = this;

        var startOpts,
            resetByWorker,
            conditionName,
            isColdStart,
            reason,
            _reason,
            timestamp,
            sessionToken,
            isNewSession,
            _startOpts$assistOnly,
            _this$options$crossdo4,
            _this$canvasRecorder2,
            r,
            error,
            _reason2,
            _reason3,
            _yield$r$json6,
            token,
            userUUID,
            projectID,
            beaconSizeLimit,
            compressionThreshold,
            _delay,
            sessionID,
            startTimestamp,
            userBrowser,
            userCity,
            userCountry,
            userDevice,
            userOS,
            userState,
            canvasEnabled,
            canvasQuality,
            canvasFPS,
            socketOnly,
            features,
            _reason4,
            _this$worker6,
            _this$worker7,
            onStartInfo,
            _this$canvasRecorder,
            biggestBuffer,
            _location,
            uxtId,
            savedUxtTag,
            query,
            qId,
            errorMessage,
            _args15 = arguments;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              startOpts = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : {};
              resetByWorker = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : false;
              conditionName = _args15.length > 2 ? _args15[2] : undefined;

              if (Object.keys(startOpts).length !== 0) {
                this.prevOpts = startOpts;
              }

              isColdStart = this.activityState === ActivityState.ColdStart;

              if (isColdStart && this.coldInterval) {
                clearInterval(this.coldInterval);
              }

              if (!(!this.worker && !this.insideIframe)) {
                _context15.next = 10;
                break;
              }

              reason = 'No worker found: perhaps, CSP is not set.';
              this.signalError(reason, []);
              return _context15.abrupt("return", Promise.resolve(UnsuccessfulStart(reason)));

            case 10:
              if (!(this.activityState === ActivityState.Active || this.activityState === ActivityState.Starting)) {
                _context15.next = 13;
                break;
              }

              _reason = 'OpenReplay: trying to call `start()` on the instance that has been started already.';
              return _context15.abrupt("return", Promise.resolve(UnsuccessfulStart(_reason)));

            case 13:
              this.activityState = ActivityState.Starting;

              if (!isColdStart) {
                adjustTimeOrigin();
              }

              if (startOpts.sessionHash) {
                this.session.applySessionHash(startOpts.sessionHash);
              }

              if (startOpts.forceNew) {
                // Reset session metadata only if requested directly
                this.session.reset();
              }

              this.session.assign({
                // MBTODO: maybe it would make sense to `forceNew` if the `userID` was changed
                userID: startOpts.userID,
                metadata: startOpts.metadata
              });
              timestamp = now();
              (_this$worker5 = this.worker) === null || _this$worker5 === void 0 ? void 0 : _this$worker5.postMessage({
                type: 'start',
                pageNo: this.session.incPageNo(),
                ingestPoint: this.options.ingestPoint,
                timestamp: isColdStart ? this.coldStartTs : timestamp,
                url: document.URL,
                connAttemptCount: this.options.connAttemptCount,
                connAttemptGap: this.options.connAttemptGap,
                tabId: this.session.getTabId()
              });
              sessionToken = this.session.getSessionToken();
              isNewSession = this.checkSessionToken(startOpts.forceNew);
              this.sessionStorage.removeItem(this.options.session_reset_key);
              this.debug.log('OpenReplay: starting session; need new session id?', isNewSession, 'session token: ', sessionToken);
              _context15.prev = 24;
              _context15.next = 27;
              return window.fetch(this.options.ingestPoint + '/v1/web/start', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_objectSpread(_objectSpread({}, this.getTrackerInfo()), {}, {
                  timestamp: timestamp,
                  doNotRecord: false,
                  bufferDiff: timestamp - this.coldStartTs,
                  userID: this.session.getInfo().userID,
                  token: isNewSession ? undefined : sessionToken,
                  deviceMemory: deviceMemory,
                  jsHeapSizeLimit: jsHeapSizeLimit,
                  timezone: getTimezone(),
                  condition: conditionName,
                  assistOnly: (_startOpts$assistOnly = startOpts.assistOnly) !== null && _startOpts$assistOnly !== void 0 ? _startOpts$assistOnly : this.socketMode,
                  width: window.screen.width,
                  height: window.screen.height
                }))
              });

            case 27:
              r = _context15.sent;

              if (!(r.status !== 200)) {
                _context15.next = 34;
                break;
              }

              _context15.next = 31;
              return r.text();

            case 31:
              error = _context15.sent;
              _reason2 = error === CANCELED ? CANCELED : "Server error: ".concat(r.status, ". ").concat(error);
              return _context15.abrupt("return", UnsuccessfulStart(_reason2));

            case 34:
              if (!(!this.worker && !this.insideIframe)) {
                _context15.next = 38;
                break;
              }

              _reason3 = 'no worker found after start request (this should not happen in real world)';
              this.signalError(_reason3, []);
              return _context15.abrupt("return", UnsuccessfulStart(_reason3));

            case 38:
              _context15.next = 40;
              return r.json();

            case 40:
              _yield$r$json6 = _context15.sent;
              token = _yield$r$json6.token;
              userUUID = _yield$r$json6.userUUID;
              projectID = _yield$r$json6.projectID;
              beaconSizeLimit = _yield$r$json6.beaconSizeLimit;
              compressionThreshold = _yield$r$json6.compressionThreshold;
              _delay = _yield$r$json6.delay;
              sessionID = _yield$r$json6.sessionID;
              startTimestamp = _yield$r$json6.startTimestamp;
              userBrowser = _yield$r$json6.userBrowser;
              userCity = _yield$r$json6.userCity;
              userCountry = _yield$r$json6.userCountry;
              userDevice = _yield$r$json6.userDevice;
              userOS = _yield$r$json6.userOS;
              userState = _yield$r$json6.userState;
              canvasEnabled = _yield$r$json6.canvasEnabled;
              canvasQuality = _yield$r$json6.canvasQuality;
              canvasFPS = _yield$r$json6.canvasFPS;
              socketOnly = _yield$r$json6.assistOnly;
              features = _yield$r$json6.features;
              this.features = features ? features : this.features;

              if (!(typeof token !== 'string' || typeof userUUID !== 'string' || typeof startTimestamp !== 'number' && typeof startTimestamp !== 'undefined' || typeof sessionID !== 'string' || typeof _delay !== 'number' || typeof beaconSizeLimit !== 'number' && typeof beaconSizeLimit !== 'undefined')) {
                _context15.next = 65;
                break;
              }

              _reason4 = "Incorrect server response: ".concat(JSON.stringify(r));
              this.signalError(_reason4, []);
              return _context15.abrupt("return", UnsuccessfulStart(_reason4));

            case 65:
              this.delay = _delay;
              this.session.setSessionToken(token);
              this.session.setUserInfo({
                userBrowser: userBrowser,
                userCity: userCity,
                userCountry: userCountry,
                userDevice: userDevice,
                userOS: userOS,
                userState: userState
              });
              this.session.assign({
                sessionID: sessionID,
                timestamp: startTimestamp || timestamp,
                projectID: projectID
              });

              if (socketOnly) {
                this.socketMode = true;
                (_this$worker6 = this.worker) === null || _this$worker6 === void 0 ? void 0 : _this$worker6.postMessage('stop');
              } else {
                (_this$worker7 = this.worker) === null || _this$worker7 === void 0 ? void 0 : _this$worker7.postMessage({
                  type: 'auth',
                  token: token,
                  beaconSizeLimit: beaconSizeLimit
                });
              }

              if (!isNewSession && token === sessionToken) {
                this.debug.log('continuing session on new tab', this.session.getTabId()); // eslint-disable-next-line @typescript-eslint/no-unsafe-argument

                this.send(TabChange(this.session.getTabId()));
              } // (Re)send Metadata for the case of a new session


              Object.entries(this.session.getInfo().metadata).forEach(function (_ref15) {
                var _ref16 = _slicedToArray(_ref15, 2),
                    key = _ref16[0],
                    value = _ref16[1];

                return _this52.send(Metadata(key, value));
              });
              this.localStorage.setItem(this.options.local_uuid_key, userUUID);
              this.compressionThreshold = compressionThreshold;
              onStartInfo = {
                sessionToken: token,
                userUUID: userUUID,
                sessionID: sessionID
              }; // TODO: start as early as possible (before receiving the token)

              /** after start */

              this.startCallbacks.forEach(function (cb) {
                return cb(onStartInfo);
              }); // MBTODO: callbacks after DOM "mounted" (observed)

              if (startOpts.startCallback) {
                startOpts.startCallback(SuccessfulStart(onStartInfo));
              }

              if (this.features['feature-flags']) {
                void this.featureFlags.reloadFlags();
              }

              _context15.next = 80;
              return this.tagWatcher.fetchTags(this.options.ingestPoint, token);

            case 80:
              this.activityState = ActivityState.Active;

              if ((_this$options$crossdo4 = this.options.crossdomain) !== null && _this$options$crossdo4 !== void 0 && _this$options$crossdo4.enabled && !this.insideIframe) {
                void this.bootChildrenFrames();
              }

              if (canvasEnabled && !this.options.canvas.disableCanvas) {
                this.canvasRecorder = (_this$canvasRecorder = this.canvasRecorder) !== null && _this$canvasRecorder !== void 0 ? _this$canvasRecorder : new CanvasRecorder(this, {
                  fps: canvasFPS,
                  quality: canvasQuality,
                  isDebug: this.options.canvas.__save_canvas_locally,
                  fixedScaling: this.options.canvas.fixedCanvasScaling,
                  useAnimationFrame: this.options.canvas.useAnimationFrame
                });
              }
              /** --------------- COLD START BUFFER ------------------*/


              if (!isColdStart) {
                _context15.next = 94;
                break;
              }

              biggestBuffer = this.bufferedMessages1.length > this.bufferedMessages2.length ? this.bufferedMessages1 : this.bufferedMessages2;

            case 85:
              if (!(biggestBuffer.length > 0)) {
                _context15.next = 90;
                break;
              }

              _context15.next = 88;
              return this.flushBuffer(biggestBuffer);

            case 88:
              _context15.next = 85;
              break;

            case 90:
              this.clearBuffers();
              this.commit();
              /** --------------- COLD START BUFFER ------------------*/

              _context15.next = 96;
              break;

            case 94:
              if (this.insideIframe && this.rootId) {
                this.observer.crossdomainObserve(this.rootId, this.frameOderNumber);
              } else {
                this.observer.observe();
              }

              this.ticker.start();

            case 96:
              (_this$canvasRecorder2 = this.canvasRecorder) === null || _this$canvasRecorder2 === void 0 ? void 0 : _this$canvasRecorder2.startTracking();

              if (this.features['usability-test'] && !this.insideIframe) {
                this.uxtManager = this.uxtManager ? this.uxtManager : new UserTestManager(this, uxtStorageKey);
                savedUxtTag = this.localStorage.getItem(uxtStorageKey);

                if (savedUxtTag) {
                  uxtId = parseInt(savedUxtTag, 10);
                }

                if ((_location = location) !== null && _location !== void 0 && _location.search) {
                  query = new URLSearchParams(location.search);

                  if (query.has('oruxt')) {
                    qId = query.get('oruxt');
                    uxtId = qId ? parseInt(qId, 10) : undefined;
                  }
                }

                if (uxtId) {
                  if (!this.uxtManager.isActive) {
                    // eslint-disable-next-line
                    this.uxtManager.getTest(uxtId, token, Boolean(savedUxtTag)).then(function (id) {
                      if (id) {
                        _this52.onUxtCb.forEach(function (cb) {
                          return cb(id);
                        });
                      }
                    });
                  } else {
                    // @ts-ignore
                    this.onUxtCb.forEach(function (cb) {
                      return cb(uxtId);
                    });
                  }
                }
              }

              return _context15.abrupt("return", SuccessfulStart(onStartInfo));

            case 101:
              _context15.prev = 101;
              _context15.t0 = _context15["catch"](24);
              this.stop();
              this.session.reset();

              if (_context15.t0) {
                _context15.next = 109;
                break;
              }

              console.error('Unknown error during start');
              this.signalError('Unknown error', []);
              return _context15.abrupt("return", UnsuccessfulStart('Unknown error'));

            case 109:
              if (!(_context15.t0 === CANCELED)) {
                _context15.next = 112;
                break;
              }

              this.signalError(CANCELED, []);
              return _context15.abrupt("return", UnsuccessfulStart(CANCELED));

            case 112:
              this._debug('session_start', _context15.t0);

              errorMessage = _context15.t0 instanceof Error ? _context15.t0.message : _context15.t0.toString();
              this.signalError(errorMessage, []);
              return _context15.abrupt("return", UnsuccessfulStart(errorMessage));

            case 116:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[24, 101]]);
      }));

      function _start() {
        return _start2.apply(this, arguments);
      }

      return _start;
    }()
  }, {
    key: "addOnUxtCb",
    value: function addOnUxtCb(cb) {
      // @ts-ignore
      this.onUxtCb.push(cb);
    }
  }, {
    key: "getUxtId",
    value: function getUxtId() {
      var _this$uxtManager;

      return (_this$uxtManager = this.uxtManager) === null || _this$uxtManager === void 0 ? void 0 : _this$uxtManager.getTestId();
    }
  }, {
    key: "waitStart",
    value: function () {
      var _waitStart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _this53 = this;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", new Promise(function (resolve) {
                var int = setInterval(function () {
                  if (_this53.canStart) {
                    clearInterval(int);
                    resolve(true);
                  }
                }, 100);
              }));

            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));

      function waitStart() {
        return _waitStart.apply(this, arguments);
      }

      return waitStart;
    }()
  }, {
    key: "waitStarted",
    value: function () {
      var _waitStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", this.waitStatus(ActivityState.Active));

            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));

      function waitStarted() {
        return _waitStarted.apply(this, arguments);
      }

      return waitStarted;
    }()
  }, {
    key: "waitStatus",
    value: function () {
      var _waitStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(status) {
        var _this54 = this;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", new Promise(function (resolve) {
                var check = function check() {
                  if (_this54.activityState === status) {
                    resolve(true);
                  } else {
                    setTimeout(check, 25);
                  }
                };

                check();
              }));

            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));

      function waitStatus(_x14) {
        return _waitStatus.apply(this, arguments);
      }

      return waitStatus;
    }()
    /**
     * basically we ask other tabs during constructor
     * and here we just apply 10ms delay just in case
     * */

  }, {
    key: "start",
    value: function () {
      var _start3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _this55 = this;

        var _len2,
            args,
            _key2,
            reason,
            _args20 = arguments;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              for (_len2 = _args20.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = _args20[_key2];
              }

              if (!(this.activityState === ActivityState.Active || this.activityState === ActivityState.Starting)) {
                _context20.next = 4;
                break;
              }

              reason = 'OpenReplay: trying to call `start()` on the instance that has been started already.';
              return _context20.abrupt("return", Promise.resolve(UnsuccessfulStart(reason)));

            case 4:
              if (this.insideIframe) {
                this.signalIframeTracker();
              }

              if (document.hidden) {
                _context20.next = 11;
                break;
              }

              _context20.next = 8;
              return this.waitStart();

            case 8:
              return _context20.abrupt("return", this._start.apply(this, args));

            case 11:
              return _context20.abrupt("return", new Promise(function (resolve) {
                var onVisibilityChange = /*#__PURE__*/function () {
                  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                      while (1) switch (_context19.prev = _context19.next) {
                        case 0:
                          if (document.hidden) {
                            _context19.next = 5;
                            break;
                          }

                          _context19.next = 3;
                          return _this55.waitStart();

                        case 3:
                          // eslint-disable-next-line
                          document.removeEventListener('visibilitychange', onVisibilityChange);
                          resolve(_this55._start.apply(_this55, args));

                        case 5:
                        case "end":
                          return _context19.stop();
                      }
                    }, _callee19);
                  }));

                  return function onVisibilityChange() {
                    return _ref17.apply(this, arguments);
                  };
                }(); // eslint-disable-next-line


                // eslint-disable-next-line
                document.addEventListener('visibilitychange', onVisibilityChange);
              }));

            case 12:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));

      function start() {
        return _start3.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "forceFlushBatch",
    value: function forceFlushBatch() {
      var _this$worker8;

      (_this$worker8 = this.worker) === null || _this$worker8 === void 0 ? void 0 : _this$worker8.postMessage('forceFlushBatch');
    }
  }, {
    key: "getTabId",
    value: function getTabId() {
      return this.session.getTabId();
    }
  }, {
    key: "clearBuffers",
    value: function clearBuffers() {
      this.bufferedMessages1.length = 0;
      this.bufferedMessages2.length = 0;
    }
    /**
     * Creates a named hook that expects event name, data string and msg direction (up/down),
     * it will skip any message bigger than 5 mb or event name bigger than 255 symbols
     * @returns {(msgType: string, data: string, dir: "up" | "down") => void}
     * */

  }, {
    key: "trackWs",
    value: function trackWs(channelName) {
      var _this56 = this;

      var channel = channelName;
      return function (msgType, data) {
        var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'down';

        if (typeof msgType !== 'string' || typeof data !== 'string' || data.length > 5 * 1024 * 1024 || msgType.length > 255) {
          return;
        }

        _this56.send(WSChannel('websocket', channel, data, _this56.timestamp(), dir, msgType));
      };
    }
  }, {
    key: "stop",
    value: function stop() {
      var stopWorker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.activityState !== ActivityState.NotActive) {
        try {
          var _this$options$crossdo5, _this$canvasRecorder3;

          if (!this.insideIframe && (_this$options$crossdo5 = this.options.crossdomain) !== null && _this$options$crossdo5 !== void 0 && _this$options$crossdo5.enabled) {
            this.killChildrenFrames();
          }

          this.attributeSender.clear();
          this.sanitizer.clear();
          this.observer.disconnect();
          this.nodes.clear();
          this.ticker.stop();
          this.stopCallbacks.forEach(function (cb) {
            return cb();
          });
          this.tagWatcher.clear();

          if (this.worker && stopWorker) {
            this.worker.postMessage('stop');
          }

          (_this$canvasRecorder3 = this.canvasRecorder) === null || _this$canvasRecorder3 === void 0 ? void 0 : _this$canvasRecorder3.clear();
          this.messages.length = 0;
          this.parentActive = false;
        } finally {
          this.activityState = ActivityState.NotActive;
          this.debug.log('OpenReplay tracking stopped.');
        }
      }
    }
  }]);

  return App;
}();

function Connection(app) {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  if (connection === undefined) {
    return;
  }

  var sendConnectionInformation = function sendConnectionInformation() {
    return app.send(ConnectionInformation(Math.round(connection.downlink * 1000), connection.type || 'unknown'));
  };

  sendConnectionInformation();
  connection.addEventListener('change', sendConnectionInformation);
}

var printError = IN_BROWSER && 'InstallTrigger' in window // detect Firefox
? function (e) {
  return e.message + '\n' + e.stack;
} : function (e) {
  return e.stack || e.message;
};

function printString(arg) {
  if (arg === undefined) {
    return 'undefined';
  }

  if (arg === null) {
    return 'null';
  }

  if (arg instanceof Error) {
    return printError(arg);
  }

  if (Array.isArray(arg)) {
    return "Array(".concat(arg.length, ")");
  }

  return String(arg);
}

function printFloat(arg) {
  if (typeof arg !== 'number') return 'NaN';
  return arg.toString();
}

function printInt(arg) {
  if (typeof arg !== 'number') return 'NaN';
  return Math.floor(arg).toString();
}

function printObject(arg) {
  if (arg === undefined) {
    return 'undefined';
  }

  if (arg === null) {
    return 'null';
  }

  if (arg instanceof Error) {
    return printError(arg);
  }

  if (Array.isArray(arg)) {
    var length = arg.length;
    var values = arg.slice(0, 10).map(printString).join(', ');
    return "Array(".concat(length, ")[").concat(values, "]");
  }

  if (typeof arg === 'object') {
    var res = [];
    var _i15 = 0;

    for (var _k2 in arg) {
      if (++_i15 === 10) {
        break;
      }

      var _v = arg[_k2];
      res.push(_k2 + ': ' + printString(_v));
    }

    return '{' + res.join(', ') + '}';
  }

  return arg.toString();
}

function printf(args) {
  if (typeof args[0] === 'string') {
    args.unshift(args.shift().replace(/%(o|s|f|d|i)/g, function (s, t) {
      var arg = args.shift();
      if (arg === undefined) return s;

      switch (t) {
        case 'o':
          return printObject(arg);

        case 's':
          return printString(arg);

        case 'f':
          return printFloat(arg);

        case 'd':
        case 'i':
          return printInt(arg);

        default:
          return s;
      }
    }));
  }

  return args.map(printObject).join(' ');
}

var consoleMethods = ['log', 'info', 'warn', 'error', 'debug', 'assert'];

function Console(app, opts) {
  var options = Object.assign({
    consoleMethods: consoleMethods,
    consoleThrottling: 30
  }, opts);

  if (!Array.isArray(options.consoleMethods) || options.consoleMethods.length === 0) {
    return;
  }

  var sendConsoleLog = app.safe(function (level, args) {
    return app.send(ConsoleLog(level, printf(args)));
  });
  var n = 0;

  var reset = function reset() {
    n = 0;
  };

  app.attachStartCallback(reset);
  app.ticker.attach(reset, 33, false);

  var patchConsole = function patchConsole(console, ctx) {
    var handler = {
      apply: function apply(target, thisArg, argumentsList) {
        Reflect.apply(target, ctx, argumentsList);
        n = n + 1;

        if (n > options.consoleThrottling) {
          return;
        } else {
          sendConsoleLog(target.name, argumentsList);
        }
      }
    };
    options.consoleMethods.forEach(function (method) {
      if (consoleMethods.indexOf(method) === -1) {
        app.debug.error("OpenReplay: unsupported console method \"".concat(method, "\""));
        return;
      }

      var fn = ctx.console[method];
      console[method] = new Proxy(fn, handler);
    });
  };

  var patchContext = app.safe(function (context) {
    return patchConsole(context.console, context);
  });
  patchContext(window);
  app.observer.attachContextCallback(patchContext);
}

var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;

function parse$1(error, options) {
  if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return parseOpera(error);else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return parseV8OrIE(error);else if (error.stack) return parseFFOrSafari(error);else throw new Error("Cannot parse given Error object");
}

function extractLocation(urlLike) {
  if (!urlLike.includes(":")) return [urlLike, void 0, void 0];
  var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
  var parts = regExp.exec(urlLike.replace(/[()]/g, ""));
  return [parts[1], parts[2] || void 0, parts[3] || void 0];
}

function applySlice(lines, options) {
  return lines;
}

function parseV8OrIE(error, options) {
  return parseV8OrIeString(error.stack);
}

function parseV8OrIeString(stack, options) {
  var filtered = applySlice(stack.split("\n").filter(function (line) {
    return !!line.match(CHROME_IE_STACK_REGEXP);
  }));
  return filtered.map(function (line) {
    if (line.includes("(eval ")) {
      line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, "");
    }

    var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, "");
    var location = sanitizedLine.match(/ (\(.+\)$)/);
    sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
    var locationParts = extractLocation(location ? location[1] : sanitizedLine);
    var functionName = location && sanitizedLine || void 0;
    var fileName = ["eval", "<anonymous>"].includes(locationParts[0]) ? void 0 : locationParts[0];
    return {
      function: functionName,
      file: fileName,
      line: locationParts[1] ? +locationParts[1] : void 0,
      col: locationParts[2] ? +locationParts[2] : void 0,
      raw: line
    };
  });
}

function parseFFOrSafari(error, options) {
  return parseFFOrSafariString(error.stack);
}

function parseFFOrSafariString(stack, options) {
  var filtered = applySlice(stack.split("\n").filter(function (line) {
    return !line.match(SAFARI_NATIVE_CODE_REGEXP);
  }));
  return filtered.map(function (line) {
    if (line.includes(" > eval")) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1");

    if (!line.includes("@") && !line.includes(":")) {
      return {
        function: line
      };
    } else {
      var functionNameRegex = /(([^\n\r"\u2028\u2029]*".[^\n\r"\u2028\u2029]*"[^\n\r@\u2028\u2029]*(?:@[^\n\r"\u2028\u2029]*"[^\n\r@\u2028\u2029]*)*(?:[\n\r\u2028\u2029][^@]*)?)?[^@]*)@/;
      var matches = line.match(functionNameRegex);
      var functionName = matches && matches[1] ? matches[1] : void 0;
      var locationParts = extractLocation(line.replace(functionNameRegex, ""));
      return {
        function: functionName,
        file: locationParts[0],
        line: locationParts[1] ? +locationParts[1] : void 0,
        col: locationParts[2] ? +locationParts[2] : void 0,
        raw: line
      };
    }
  });
}

function parseOpera(e, options) {
  if (!e.stacktrace || e.message.includes("\n") && e.message.split("\n").length > e.stacktrace.split("\n").length) return parseOpera9(e);else if (!e.stack) return parseOpera10(e);else return parseOpera11(e);
}

function parseOpera9(e, options) {
  var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
  var lines = e.message.split("\n");
  var result = [];

  for (var _i17 = 2, len = lines.length; _i17 < len; _i17 += 2) {
    var match = lineRE.exec(lines[_i17]);

    if (match) {
      result.push({
        file: match[2],
        line: +match[1],
        raw: lines[_i17]
      });
    }
  }

  return applySlice(result);
}

function parseOpera10(e, options) {
  var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
  var lines = e.stacktrace.split("\n");
  var result = [];

  for (var _i19 = 0, len = lines.length; _i19 < len; _i19 += 2) {
    var match = lineRE.exec(lines[_i19]);

    if (match) {
      result.push({
        function: match[3] || void 0,
        file: match[2],
        line: match[1] ? +match[1] : void 0,
        raw: lines[_i19]
      });
    }
  }

  return applySlice(result);
}

function parseOpera11(error, options) {
  var filtered = applySlice( // @ts-expect-error missing stack property
  error.stack.split("\n").filter(function (line) {
    return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
  }));
  return filtered.map(function (line) {
    var tokens = line.split("@");
    var locationParts = extractLocation(tokens.pop());
    var functionCall = tokens.shift() || "";
    var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
    var argsRaw;
    if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, "$1");
    var args = argsRaw === void 0 || argsRaw === "[arguments not available]" ? void 0 : argsRaw.split(",");
    return {
      function: functionName,
      args: args,
      file: locationParts[0],
      line: locationParts[1] ? +locationParts[1] : void 0,
      col: locationParts[2] ? +locationParts[2] : void 0,
      raw: line
    };
  });
}

function stackframesLiteToStackframes(liteStackframes) {
  return liteStackframes.map(function (liteStackframe) {
    return {
      functionName: liteStackframe.function,
      args: liteStackframe.args,
      fileName: liteStackframe.file,
      lineNumber: liteStackframe.line,
      columnNumber: liteStackframe.col,
      source: liteStackframe.raw
    };
  });
}

function parse(error, options) {
  return stackframesLiteToStackframes(parse$1(error));
}

function getDefaultStack(e) {
  return [{
    columnNumber: e.colno,
    lineNumber: e.lineno,
    fileName: e.filename,
    functionName: '',
    source: ''
  }];
}

function getExceptionMessage(error, fallbackStack) {
  var metadata = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var stack = fallbackStack;

  try {
    stack = parse(error);
  } catch (e) {}

  return JSException(error.name, error.message, JSON.stringify(stack), JSON.stringify(metadata));
}

function getExceptionMessageFromEvent(e) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var metadata = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (e instanceof ErrorEvent) {
    if (e.error instanceof Error) {
      return getExceptionMessage(e.error, getDefaultStack(e), metadata);
    } else {
      var _e$message$split3 = e.message.split(':'),
          _e$message$split4 = _slicedToArray(_e$message$split3, 2),
          name = _e$message$split4[0],
          message = _e$message$split4[1];

      if (!message) {
        name = 'Error';
        message = e.message;
      }

      return JSException(name, message, JSON.stringify(getDefaultStack(e)), JSON.stringify(metadata));
    }
  } else if ('PromiseRejectionEvent' in context && e instanceof context.PromiseRejectionEvent) {
    if (e.reason instanceof Error) {
      return getExceptionMessage(e.reason, [], metadata);
    } else {
      var _message;

      try {
        _message = JSON.stringify(e.reason);
      } catch (_) {
        _message = String(e.reason);
      }

      return JSException('Unhandled Promise Rejection', _message, '[]', JSON.stringify(metadata));
    }
  }

  return null;
}

function Exception(app, opts) {
  var options = Object.assign({
    captureExceptions: true
  }, opts);

  function patchContext(context) {
    function handler(e) {
      var msg = getExceptionMessageFromEvent(e, context);

      if (msg != null) {
        app.send(msg);
      }
    }

    try {
      app.attachEventListener(context, 'unhandledrejection', handler);
      app.attachEventListener(context, 'error', handler);
    } catch (e) {
      console.error('Error while attaching to error proto contexts', e);
    }
  }

  if (options.captureExceptions) {
    app.observer.attachContextCallback(patchContext); // TODO: attach once-per-iframe (?)

    patchContext(window);
  }
}

function resolveURL(url) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.location;
  url = url.trim();

  if (url.startsWith('//') || url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') // any other possible value here? https://bugzilla.mozilla.org/show_bug.cgi?id=1758035
  ) {
      return url;
    } else if (url.startsWith('/')) {
    return location.origin + url;
  } else {
    return location.origin + location.pathname + url;
  }
} // https://bugzilla.mozilla.org/show_bug.cgi?id=1607081


function isSVGInFireFox(url) {
  return IS_FIREFOX && (url.startsWith('data:image/svg+xml') || url.match(/.svg$|/i));
}

var PLACEHOLDER_SRC = 'https://static.openreplay.com/tracker/placeholder.jpeg';

function Img(app) {
  function sendPlaceholder(id, node) {
    app.attributeSender.sendSetAttribute(id, 'src', PLACEHOLDER_SRC);

    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    if (!node.hasAttribute('width')) {
      app.attributeSender.sendSetAttribute(id, 'width', String(width));
    }

    if (!node.hasAttribute('height')) {
      app.attributeSender.sendSetAttribute(id, 'height', String(height));
    }
  }

  var sendSrcset = function sendSrcset(id, img) {
    var srcset = img.srcset;

    if (!srcset) {
      return;
    }

    var resolvedSrcset = srcset.split(srcset.match(/,\s+/) ? /,\s+/ : ',').map(function (str) {
      return resolveURL(str);
    }).join(', ');
    app.attributeSender.sendSetAttribute(id, 'srcset', resolvedSrcset);
  };

  var sendSrc = function sendSrc(id, img) {
    if (img.src.length > MAX_STR_LEN) {
      sendPlaceholder(id, img);
    }

    app.send(SetNodeAttributeURLBased(id, 'src', img.src, app.getBaseHref()));
  };

  var sendImgError = app.safe(function (img) {
    var resolvedSrc = resolveURL(img.src || ''); // Src type is null sometimes. - is it true?

    if (isURL(resolvedSrc)) {
      app.send(ResourceTiming(app.timestamp(), 0, 0, 0, 0, 0, resolvedSrc, 'img', 0, false));
    }
  });
  var sendImgAttrs = app.safe(function (img) {
    var id = app.nodes.getID(img);

    if (id === undefined) {
      return;
    }

    if (!img.complete) {
      return;
    }

    if (img.naturalHeight === 0 && img.naturalWidth === 0 && !isSVGInFireFox(img.src)) {
      sendImgError(img);
    } else if (app.sanitizer.isHidden(id) || app.sanitizer.isObscured(id)) {
      sendPlaceholder(id, img);
    } else {
      sendSrc(id, img);
      sendSrcset(id, img);
    }
  });
  var observer = createMutationObserver(app.safe(function (mutations) {
    var _iterator5 = _createForOfIteratorHelper(mutations),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var mutation = _step5.value;

        if (mutation.type === 'attributes') {
          var target = mutation.target;

          var _id5 = app.nodes.getID(target);

          if (_id5 === undefined) {
            return;
          }

          if (mutation.attributeName === 'src') {
            sendSrc(_id5, target);
          }

          if (mutation.attributeName === 'srcset') {
            sendSrcset(_id5, target);
          }
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }), app.options.forceNgOff);
  app.attachStopCallback(function () {
    observer.disconnect();
  });
  app.nodes.attachNodeCallback(function (node) {
    if (!hasTag(node, 'img')) {
      return;
    }

    app.nodes.attachNodeListener(node, 'error', function () {
      return sendImgError(node);
    });
    app.nodes.attachNodeListener(node, 'load', function () {
      return sendImgAttrs(node);
    });
    sendImgAttrs(node);
    observer.observe(node, {
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });
  });
}

var INPUT_TYPES = ['text', 'password', 'email', 'search', 'number', 'range', 'date', 'tel', 'time'];

function isTextFieldElement(node) {
  if (hasTag(node, 'textarea')) {
    return true;
  }

  if (!hasTag(node, 'input')) {
    return false;
  }

  return INPUT_TYPES.includes(node.type);
}

function isCheckbox(node) {
  if (!hasTag(node, 'input')) {
    return false;
  }

  var type = node.type;
  return type === 'checkbox' || type === 'radio';
}

var labelElementFor = IN_BROWSER && 'labels' in HTMLInputElement.prototype ? function (node) {
  var p = node;

  while ((p = p.parentNode) !== null) {
    if (hasTag(p, 'label')) {
      return p;
    }
  }

  var labels = node.labels;

  if (labels !== null && labels.length === 1) {
    return labels[0];
  }
} : function (node) {
  var p = node;

  while ((p = p.parentNode) !== null) {
    if (hasTag(p, 'label')) {
      return p;
    }
  }

  var id = node.id;

  if (id) {
    var labels = node.ownerDocument.querySelectorAll('label[for="' + id + '"]');

    if (labels !== null && labels.length === 1) {
      return labels[0];
    }
  }
};

function getInputLabel(node) {
  var label = getLabelAttribute(node);

  if (label === null) {
    var labelElement = labelElementFor(node);
    label = labelElement && labelElement.innerText || node.placeholder || node.name || node.id || node.className || node.type;
  }

  return normSpaces(label).slice(0, 100);
}

var InputMode = {
  Plain: 0,
  Obscured: 1,
  Hidden: 2
};

function Input(app, opts) {
  var options = Object.assign({
    obscureInputNumbers: true,
    obscureInputEmails: true,
    defaultInputMode: InputMode.Obscured,
    obscureInputDates: false
  }, opts);

  function getInputValue(id, node) {
    var value = node.value;
    var inputMode = options.defaultInputMode;

    if (node.type === 'password' || app.sanitizer.isHidden(id)) {
      inputMode = InputMode.Hidden;
    } else if (app.sanitizer.isObscured(id) || inputMode === InputMode.Plain && (options.obscureInputNumbers && node.type !== 'date' && /\d\d\d\d/.test(value) || options.obscureInputDates && node.type === 'date' || options.obscureInputEmails && (node.type === 'email' || !!~value.indexOf('@')))) {
      inputMode = InputMode.Obscured;
    }

    var mask = 0;

    switch (inputMode) {
      case InputMode.Hidden:
        mask = -1;
        value = '';
        break;

      case InputMode.Obscured:
        mask = value.length;
        value = '';
        break;
    }

    return {
      value: value,
      mask: mask
    };
  }

  function sendInputValue(id, node) {
    var _getInputValue = getInputValue(id, node),
        value = _getInputValue.value,
        mask = _getInputValue.mask;

    app.send(SetInputValue(id, value, mask));
  }

  var inputValues = new Map();
  var checkboxValues = new Map();
  app.attachStopCallback(function () {
    inputValues.clear();
    checkboxValues.clear();
  });

  function trackInputValue(id, node) {
    if (inputValues.get(id) === node.value) {
      return;
    }

    inputValues.set(id, node.value);
    sendInputValue(id, node);
  }

  function trackCheckboxValue(id, value) {
    if (checkboxValues.get(id) === value) {
      return;
    }

    checkboxValues.set(id, value);
    app.send(SetInputChecked(id, value));
  } // The only way (to our knowledge) to track all kinds of input changes, including those made by JS


  app.ticker.attach(function () {
    inputValues.forEach(function (value, id) {
      var node = app.nodes.getNode(id);
      if (!node) return inputValues.delete(id);
      trackInputValue(id, node);
    });
    checkboxValues.forEach(function (checked, id) {
      var node = app.nodes.getNode(id);
      if (!node) return checkboxValues.delete(id);
      trackCheckboxValue(id, node.checked);
    });
  }, 3);

  function sendInputChange(id, node, hesitationTime, inputTime) {
    var _getInputValue2 = getInputValue(id, node),
        value = _getInputValue2.value,
        mask = _getInputValue2.mask;

    var label = getInputLabel(node);
    app.send(InputChange(id, value, mask !== 0, label, hesitationTime, inputTime));
  }

  app.nodes.attachNodeCallback(app.safe(function (node) {
    var id = app.nodes.getID(node);

    if (id === undefined) {
      return;
    } // TODO: support multiple select (?): use selectedOptions;


    if (hasTag(node, 'select')) {
      sendInputValue(id, node);
      app.nodes.attachNodeListener(node, 'change', function () {
        return sendInputValue(id, node);
      });
    }

    if (isTextFieldElement(node)) {
      trackInputValue(id, node);
      var nodeFocusTime = 0;
      var nodeHesitationTime = 0;
      var inputTime = 0;

      var onFocus = function onFocus() {
        nodeFocusTime = now();
      };

      var onInput = function onInput() {
        if (nodeHesitationTime === 0 && nodeFocusTime !== 0) {
          nodeHesitationTime = now() - nodeFocusTime;
        }
      };

      var onChange = function onChange() {
        if (nodeFocusTime !== 0) {
          inputTime = now() - nodeFocusTime;
        }

        sendInputChange(id, node, nodeHesitationTime, inputTime);
        nodeHesitationTime = 0;
        inputTime = 0;
        nodeFocusTime = 0;
      };

      app.nodes.attachNodeListener(node, 'focus', onFocus);
      app.nodes.attachNodeListener(node, 'input', onInput);
      app.nodes.attachNodeListener(node, 'change', onChange);
      return;
    }

    if (isCheckbox(node)) {
      trackCheckboxValue(id, node.checked);
      app.nodes.attachNodeListener(node, 'change', function () {
        return trackCheckboxValue(id, node.checked);
      });
      return;
    }
  }));
} // License: MIT
// Author: Anton Medvedev <anton@medv.io>
// Source: https://github.com/antonmedv/finder


var config;
var rootDocument;
var start;

function finder(input, options) {
  start = new Date();

  if (input.nodeType !== Node.ELEMENT_NODE) {
    throw new Error("Can't generate CSS selector for non-element node type.");
  }

  if ('html' === input.tagName.toLowerCase()) {
    return 'html';
  }

  var defaults = {
    root: document.body,
    idName: function idName(name) {
      return true;
    },
    className: function className(name) {
      return true;
    },
    tagName: function tagName(name) {
      return true;
    },
    attr: function attr(name, value) {
      return false;
    },
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1000,
    maxNumberOfTries: 10000,
    timeoutMs: undefined
  };
  config = _objectSpread(_objectSpread({}, defaults), options);
  rootDocument = findRootDocument(config.root, defaults);
  var path = bottomUpSearch(input, 'all', function () {
    return bottomUpSearch(input, 'two', function () {
      return bottomUpSearch(input, 'one', function () {
        return bottomUpSearch(input, 'none');
      });
    });
  });

  if (path) {
    var optimized = sort(optimize(path, input));

    if (optimized.length > 0) {
      path = optimized[0];
    }

    return selector(path);
  } else {
    throw new Error("Selector was not found.");
  }
}

function findRootDocument(rootNode, defaults) {
  if (rootNode.nodeType === Node.DOCUMENT_NODE) {
    return rootNode;
  }

  if (rootNode === defaults.root) {
    return rootNode.ownerDocument;
  }

  return rootNode;
}

function bottomUpSearch(input, limit, fallback) {
  var path = null;
  var stack = [];
  var current = input;
  var i = 0;

  var _loop = function _loop() {
    var elapsedTime = new Date().getTime() - start.getTime();

    if (config.timeoutMs !== undefined && elapsedTime > config.timeoutMs) {
      throw new Error("Timeout: Can't find a unique selector after ".concat(elapsedTime, "ms"));
    }

    var level = maybe(id(current)) || maybe.apply(void 0, _toConsumableArray(attr(current))) || maybe.apply(void 0, _toConsumableArray(classNames(current))) || maybe(tagName(current)) || [any()];
    var nth = index(current);

    if (limit == 'all') {
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'two') {
      level = level.slice(0, 1);

      if (nth) {
        level = level.concat(level.filter(dispensableNth).map(function (node) {
          return nthChild(node, nth);
        }));
      }
    } else if (limit == 'one') {
      var _level3 = level = level.slice(0, 1),
          _level4 = _slicedToArray(_level3, 1),
          node = _level4[0];

      if (nth && dispensableNth(node)) {
        level = [nthChild(node, nth)];
      }
    } else if (limit == 'none') {
      level = [any()];

      if (nth) {
        level = [nthChild(level[0], nth)];
      }
    }

    var _iterator6 = _createForOfIteratorHelper(level),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _node = _step6.value;
        _node.level = i;
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    stack.push(level);

    if (stack.length >= config.seedMinLength) {
      path = findUniquePath(stack, fallback);

      if (path) {
        return "break";
      }
    }

    current = current.parentElement;
    i++;
  };

  while (current) {
    var _ret = _loop();

    if (_ret === "break") break;
  }

  if (!path) {
    path = findUniquePath(stack, fallback);
  }

  if (!path && fallback) {
    return fallback();
  }

  return path;
}

function findUniquePath(stack, fallback) {
  var paths = sort(combinations(stack));

  if (paths.length > config.threshold) {
    return fallback ? fallback() : null;
  }

  var _iterator7 = _createForOfIteratorHelper(paths),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var candidate = _step7.value;

      if (unique(candidate)) {
        return candidate;
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return null;
}

function selector(path) {
  var node = path[0];
  var query = node.name;

  for (var _i21 = 1; _i21 < path.length; _i21++) {
    var level = path[_i21].level || 0;

    if (node.level === level - 1) {
      query = "".concat(path[_i21].name, " > ").concat(query);
    } else {
      query = "".concat(path[_i21].name, " ").concat(query);
    }

    node = path[_i21];
  }

  return query;
}

function penalty(path) {
  return path.map(function (node) {
    return node.penalty;
  }).reduce(function (acc, i) {
    return acc + i;
  }, 0);
}

function unique(path) {
  var css = selector(path);

  switch (rootDocument.querySelectorAll(css).length) {
    case 0:
      throw new Error("Can't select any node with this selector: ".concat(css));

    case 1:
      return true;

    default:
      return false;
  }
}

function id(input) {
  var elementId = input.getAttribute('id');

  if (elementId && config.idName(elementId)) {
    return {
      name: '#' + CSS.escape(elementId),
      penalty: 0
    };
  }

  return null;
}

function attr(input) {
  var attrs = Array.from(input.attributes).filter(function (attr) {
    return config.attr(attr.name, attr.value);
  });
  return attrs.map(function (attr) {
    return {
      name: "[".concat(CSS.escape(attr.name), "=\"").concat(CSS.escape(attr.value), "\"]"),
      penalty: 0.5
    };
  });
}

function classNames(input) {
  var names = Array.from(input.classList).filter(config.className);
  return names.map(function (name) {
    return {
      name: '.' + CSS.escape(name),
      penalty: 1
    };
  });
}

function tagName(input) {
  var name = input.tagName.toLowerCase();

  if (config.tagName(name)) {
    return {
      name: name,
      penalty: 2
    };
  }

  return null;
}

function any() {
  return {
    name: '*',
    penalty: 3
  };
}

function index(input) {
  var parent = input.parentNode;

  if (!parent) {
    return null;
  }

  var child = parent.firstChild;

  if (!child) {
    return null;
  }

  var i = 0;

  while (child) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      i++;
    }

    if (child === input) {
      break;
    }

    child = child.nextSibling;
  }

  return i;
}

function nthChild(node, i) {
  return {
    name: node.name + ":nth-child(".concat(i, ")"),
    penalty: node.penalty + 1
  };
}

function dispensableNth(node) {
  return node.name !== 'html' && !node.name.startsWith('#');
}

function maybe() {
  for (var _len3 = arguments.length, level = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    level[_key3] = arguments[_key3];
  }

  var list = level.filter(notEmpty);

  if (list.length > 0) {
    return list;
  }

  return null;
}

function notEmpty(value) {
  return value !== null && value !== undefined;
}

function combinations(stack) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
    var _iterator8, _step8, node;

    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          if (!(stack.length > 0)) {
            _context21.next = 19;
            break;
          }

          _iterator8 = _createForOfIteratorHelper(stack[0]);
          _context21.prev = 2;

          _iterator8.s();

        case 4:
          if ((_step8 = _iterator8.n()).done) {
            _context21.next = 9;
            break;
          }

          node = _step8.value;
          return _context21.delegateYield(combinations(stack.slice(1, stack.length), path.concat(node)), "t0", 7);

        case 7:
          _context21.next = 4;
          break;

        case 9:
          _context21.next = 14;
          break;

        case 11:
          _context21.prev = 11;
          _context21.t1 = _context21["catch"](2);

          _iterator8.e(_context21.t1);

        case 14:
          _context21.prev = 14;

          _iterator8.f();

          return _context21.finish(14);

        case 17:
          _context21.next = 21;
          break;

        case 19:
          _context21.next = 21;
          return path;

        case 21:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[2, 11, 14, 17]]);
  })();
}

function sort(paths) {
  return _toConsumableArray(paths).sort(function (a, b) {
    return penalty(a) - penalty(b);
  });
}

function optimize(path, input) {
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    counter: 0,
    visited: new Map()
  };
  return /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
    var _i23, newPath, newPathKey;

    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          if (!(path.length > 2 && path.length > config.optimizedMinLength)) {
            _context22.next = 19;
            break;
          }

          _i23 = 1;

        case 2:
          if (!(_i23 < path.length - 1)) {
            _context22.next = 19;
            break;
          }

          if (!(scope.counter > config.maxNumberOfTries)) {
            _context22.next = 5;
            break;
          }

          return _context22.abrupt("return");

        case 5:
          scope.counter += 1;
          newPath = _toConsumableArray(path);
          newPath.splice(_i23, 1);
          newPathKey = selector(newPath);

          if (!scope.visited.has(newPathKey)) {
            _context22.next = 11;
            break;
          }

          return _context22.abrupt("return");

        case 11:
          if (!(unique(newPath) && same(newPath, input))) {
            _context22.next = 16;
            break;
          }

          _context22.next = 14;
          return newPath;

        case 14:
          scope.visited.set(newPathKey, true);
          return _context22.delegateYield(optimize(newPath, input, scope), "t0", 16);

        case 16:
          _i23++;
          _context22.next = 2;
          break;

        case 19:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  })();
}

function same(path, input) {
  return rootDocument.querySelector(selector(path)) === input;
}

function _getSelector(target, document, options) {
  var selector = finder(target, {
    root: document.body,
    seedMinLength: 3,
    optimizedMinLength: (options === null || options === void 0 ? void 0 : options.minSelectorDepth) || 2,
    threshold: (options === null || options === void 0 ? void 0 : options.nthThreshold) || 1000,
    maxNumberOfTries: (options === null || options === void 0 ? void 0 : options.maxOptimiseTries) || 10000
  });
  return selector;
}

function isClickable(element) {
  var tag = element.tagName.toUpperCase();
  return tag === 'BUTTON' || tag === 'A' || tag === 'LI' || tag === 'SELECT' || tag === 'TR' || tag === 'TH' || element.onclick != null || element.getAttribute('role') === 'button'; //|| element.className.includes("btn")
  // MBTODO: intercept addEventListener
} //TODO: fix (typescript is not sure about target variable after assignation of svg)


function getTarget(target, document) {
  if (target instanceof Element) {
    return _getTarget(target, document);
  }

  return null;
}

function _getTarget(target, document) {
  var element = target;

  while (element !== null && element !== document.documentElement) {
    if (hasOpenreplayAttribute(element, 'masked')) {
      return null;
    }

    element = element.parentElement;
  }

  if (isSVGElement(target)) {
    var owner = target.ownerSVGElement;

    while (owner !== null) {
      target = owner;
      owner = owner.ownerSVGElement;
    }
  }

  element = target;

  while (element !== null && element !== document.documentElement) {
    var tag = element.tagName.toUpperCase();

    if (tag === 'LABEL') {
      return null;
    }

    if (tag === 'INPUT') {
      return element;
    }

    if (isClickable(element) || getLabelAttribute(element) !== null) {
      return element;
    }

    element = element.parentElement;
  }

  return target === document.documentElement ? null : target;
}

function Mouse(app, options) {
  var _ref18 = options || {},
      _ref18$disableClickma = _ref18.disableClickmaps,
      disableClickmaps = _ref18$disableClickma === void 0 ? false : _ref18$disableClickma;

  function getTargetLabel(target) {
    var dl = getLabelAttribute(target);

    if (dl !== null) {
      return dl;
    }

    if (hasTag(target, 'input')) {
      return getInputLabel(target);
    }

    if (isClickable(target)) {
      var label = '';

      if (target instanceof HTMLElement) {
        label = app.sanitizer.getInnerTextSecure(target);
      }

      label = label || target.id || target.className;
      return normSpaces(label).slice(0, 100);
    }

    return '';
  }

  var mousePositionX = -1;
  var mousePositionY = -1;
  var mousePositionChanged = false;
  var mouseTarget = null;
  var mouseTargetTime = 0;
  var selectorMap = {};
  var velocity = 0;
  var direction = 0;
  var directionChangeCount = 0;
  var distance = 0;
  var checkIntervalId;
  var shakeThreshold = 0.008;
  var shakeCheckInterval = 225;

  function checkMouseShaking() {
    var nextVelocity = distance / shakeCheckInterval;

    if (!velocity) {
      velocity = nextVelocity;
      return;
    }

    var acceleration = (nextVelocity - velocity) / shakeCheckInterval;

    if (directionChangeCount > 4 && acceleration > shakeThreshold) {
      app.send(MouseThrashing(now()));
    }

    distance = 0;
    directionChangeCount = 0;
    velocity = nextVelocity;
  }

  app.attachStartCallback(function () {
    checkIntervalId = setInterval(function () {
      return checkMouseShaking();
    }, shakeCheckInterval);
  });
  app.attachStopCallback(function () {
    mousePositionX = -1;
    mousePositionY = -1;
    mousePositionChanged = false;
    mouseTarget = null;
    selectorMap = {};

    if (checkIntervalId) {
      clearInterval(checkIntervalId);
    }
  });

  var sendMouseMove = function sendMouseMove() {
    if (mousePositionChanged) {
      app.send(MouseMove(mousePositionX, mousePositionY));
      mousePositionChanged = false;
    }
  };

  var patchDocument = function patchDocument(document) {
    var topframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    function getSelector(id, target, options) {
      return selectorMap[id] = selectorMap[id] || _getSelector(target, document, options);
    }

    var attachListener = topframe ? app.attachEventListener.bind(app) // attached/removed on start/stop
    : app.nodes.attachNodeListener.bind(app.nodes); // attached/removed on node register/unregister

    attachListener(document.documentElement, 'mouseover', function (e) {
      var target = getTarget(e.target, document);

      if (target !== mouseTarget) {
        mouseTarget = target;
        mouseTargetTime = performance.now();
      }
    });
    attachListener(document, 'mousemove', function (e) {
      var _app$observer$getDocu = app.observer.getDocumentOffset(document),
          _app$observer$getDocu2 = _slicedToArray(_app$observer$getDocu, 2),
          left = _app$observer$getDocu2[0],
          top = _app$observer$getDocu2[1]; // MBTODO?: document-id related message


      mousePositionX = e.clientX + left;
      mousePositionY = e.clientY + top;
      mousePositionChanged = true;
      var nextDirection = Math.sign(e.movementX);
      distance += Math.abs(e.movementX) + Math.abs(e.movementY);

      if (nextDirection !== direction) {
        direction = nextDirection;
        directionChangeCount++;
      }
    }, false);
    attachListener(document, 'click', function (e) {
      var target = getTarget(e.target, document);

      if (!e.clientX && !e.clientY || target === null) {
        return;
      }

      var id = app.nodes.getID(target);

      if (id !== undefined) {
        var clickX = e.pageX;
        var clickY = e.pageY;
        var contentWidth = document.documentElement.scrollWidth;
        var contentHeight = document.documentElement.scrollHeight;
        var normalizedX = roundNumber(clickX / contentWidth);
        var normalizedY = roundNumber(clickY / contentHeight);
        sendMouseMove();
        app.send(MouseClick(id, mouseTarget === target ? Math.round(performance.now() - mouseTargetTime) : 0, getTargetLabel(target), isClickable(target) && !disableClickmaps ? getSelector(id, target, options) : '', normalizedX, normalizedY), true);
      }

      mouseTarget = null;
    });
  };

  app.nodes.attachNodeCallback(function (node) {
    if (isDocument(node)) {
      patchDocument(node);
    }
  });
  patchDocument(document, true);
  app.ticker.attach(sendMouseMove, (options === null || options === void 0 ? void 0 : options.trackingOffset) || 7);
}
/**
 * we get 0 to 1 decimal number, convert and round it, then turn to %
 * 0.39643 => 396.43 => 396 => 39.6%
 * */


function roundNumber(num) {
  return Math.round(num * 1e4);
}

var e,
    o = -1,
    a = function a(e) {
  addEventListener("pageshow", function (n) {
    n.persisted && (o = n.timeStamp, e(n));
  }, !0);
},
    c = function c() {
  var e = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  if (e && e.responseStart > 0 && e.responseStart < performance.now()) return e;
},
    u = function u() {
  var e = c();
  return e && e.activationStart || 0;
},
    f = function f(e, n) {
  var t = c(),
      r = "navigate";
  o >= 0 ? r = "back-forward-cache" : t && (document.prerendering || u() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-")));
  return {
    name: e,
    value: void 0 === n ? -1 : n,
    rating: "good",
    delta: 0,
    entries: [],
    id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
    navigationType: r
  };
},
    s = function s(e, n, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var r = new PerformanceObserver(function (e) {
        Promise.resolve().then(function () {
          n(e.getEntries());
        });
      });
      return r.observe(Object.assign({
        type: e,
        buffered: !0
      }, t || {})), r;
    }
  } catch (e) {}
},
    d = function d(e, n, t, r) {
  var i, o;
  return function (a) {
    n.value >= 0 && (a || r) && ((o = n.value - (i || 0)) || void 0 === i) && (i = n.value, n.delta = o, n.rating = function (e, n) {
      return e > n[1] ? "poor" : e > n[0] ? "needs-improvement" : "good";
    }(n.value, t), e(n));
  };
},
    l = function l(e) {
  requestAnimationFrame(function () {
    return requestAnimationFrame(function () {
      return e();
    });
  });
},
    p = function p(e) {
  document.addEventListener("visibilitychange", function () {
    "hidden" === document.visibilityState && e();
  });
},
    v = function v(e) {
  var n = !1;
  return function () {
    n || (e(), n = !0);
  };
},
    m = -1,
    h = function h() {
  return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
},
    g = function g(e) {
  "hidden" === document.visibilityState && m > -1 && (m = "visibilitychange" === e.type ? e.timeStamp : 0, T());
},
    y = function y() {
  addEventListener("visibilitychange", g, !0), addEventListener("prerenderingchange", g, !0);
},
    T = function T() {
  removeEventListener("visibilitychange", g, !0), removeEventListener("prerenderingchange", g, !0);
},
    E = function E() {
  return m < 0 && (m = h(), y(), a(function () {
    setTimeout(function () {
      m = h(), y();
    }, 0);
  })), {
    get firstHiddenTime() {
      return m;
    }

  };
},
    C = function C(e) {
  document.prerendering ? addEventListener("prerenderingchange", function () {
    return e();
  }, !0) : e();
},
    b = [1800, 3e3],
    S = function S(e, n) {
  n = n || {}, C(function () {
    var t,
        r = E(),
        i = f("FCP"),
        o = s("paint", function (e) {
      e.forEach(function (e) {
        "first-contentful-paint" === e.name && (o.disconnect(), e.startTime < r.firstHiddenTime && (i.value = Math.max(e.startTime - u(), 0), i.entries.push(e), t(!0)));
      });
    });
    o && (t = d(e, i, b, n.reportAllChanges), a(function (r) {
      i = f("FCP"), t = d(e, i, b, n.reportAllChanges), l(function () {
        i.value = performance.now() - r.timeStamp, t(!0);
      });
    }));
  });
},
    L = [.1, .25],
    w = function w(e, n) {
  n = n || {}, S(v(function () {
    var t,
        r = f("CLS", 0),
        i = 0,
        o = [],
        c = function c(e) {
      e.forEach(function (e) {
        if (!e.hadRecentInput) {
          var n = o[0],
              t = o[o.length - 1];
          i && e.startTime - t.startTime < 1e3 && e.startTime - n.startTime < 5e3 ? (i += e.value, o.push(e)) : (i = e.value, o = [e]);
        }
      }), i > r.value && (r.value = i, r.entries = o, t());
    },
        u = s("layout-shift", c);

    u && (t = d(e, r, L, n.reportAllChanges), p(function () {
      c(u.takeRecords()), t(!0);
    }), a(function () {
      i = 0, r = f("CLS", 0), t = d(e, r, L, n.reportAllChanges), l(function () {
        return t();
      });
    }), setTimeout(t, 0));
  }));
},
    A = 0,
    I = 1 / 0,
    P = 0,
    M = function M(e) {
  e.forEach(function (e) {
    e.interactionId && (I = Math.min(I, e.interactionId), P = Math.max(P, e.interactionId), A = P ? (P - I) / 7 + 1 : 0);
  });
},
    k = function k() {
  return e ? A : performance.interactionCount || 0;
},
    F = function F() {
  "interactionCount" in performance || e || (e = s("event", M, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
},
    D = [],
    x = new Map(),
    R = 0,
    B = function B() {
  var e = Math.min(D.length - 1, Math.floor((k() - R) / 50));
  return D[e];
},
    H = [],
    q = function q(e) {
  if (H.forEach(function (n) {
    return n(e);
  }), e.interactionId || "first-input" === e.entryType) {
    var n = D[D.length - 1],
        t = x.get(e.interactionId);

    if (t || D.length < 10 || e.duration > n.latency) {
      if (t) e.duration > t.latency ? (t.entries = [e], t.latency = e.duration) : e.duration === t.latency && e.startTime === t.entries[0].startTime && t.entries.push(e);else {
        var r = {
          id: e.interactionId,
          latency: e.duration,
          entries: [e]
        };
        x.set(r.id, r), D.push(r);
      }
      D.sort(function (e, n) {
        return n.latency - e.latency;
      }), D.length > 10 && D.splice(10).forEach(function (e) {
        return x.delete(e.id);
      });
    }
  }
},
    O = function O(e) {
  var n = self.requestIdleCallback || self.setTimeout,
      t = -1;
  return e = v(e), "hidden" === document.visibilityState ? e() : (t = n(e), p(e)), t;
},
    N = [200, 500],
    j = function j(e, n) {
  "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (n = n || {}, C(function () {
    var t;
    F();

    var r,
        i = f("INP"),
        o = function o(e) {
      O(function () {
        e.forEach(q);
        var n = B();
        n && n.latency !== i.value && (i.value = n.latency, i.entries = n.entries, r());
      });
    },
        c = s("event", o, {
      durationThreshold: null !== (t = n.durationThreshold) && void 0 !== t ? t : 40
    });

    r = d(e, i, N, n.reportAllChanges), c && (c.observe({
      type: "first-input",
      buffered: !0
    }), p(function () {
      o(c.takeRecords()), r(!0);
    }), a(function () {
      R = k(), D.length = 0, x.clear(), i = f("INP"), r = d(e, i, N, n.reportAllChanges);
    }));
  }));
},
    _ = [2500, 4e3],
    z = {},
    G = function G(e, n) {
  n = n || {}, C(function () {
    var t,
        r = E(),
        i = f("LCP"),
        o = function o(e) {
      n.reportAllChanges || (e = e.slice(-1)), e.forEach(function (e) {
        e.startTime < r.firstHiddenTime && (i.value = Math.max(e.startTime - u(), 0), i.entries = [e], t());
      });
    },
        c = s("largest-contentful-paint", o);

    if (c) {
      t = d(e, i, _, n.reportAllChanges);
      var m = v(function () {
        z[i.id] || (o(c.takeRecords()), c.disconnect(), z[i.id] = !0, t(!0));
      });
      ["keydown", "click"].forEach(function (e) {
        addEventListener(e, function () {
          return O(m);
        }, {
          once: !0,
          capture: !0
        });
      }), p(m), a(function (r) {
        i = f("LCP"), t = d(e, i, _, n.reportAllChanges), l(function () {
          i.value = performance.now() - r.timeStamp, z[i.id] = !0, t(!0);
        });
      });
    }
  });
},
    J = [800, 1800],
    K = function e(n) {
  document.prerendering ? C(function () {
    return e(n);
  }) : "complete" !== document.readyState ? addEventListener("load", function () {
    return e(n);
  }, !0) : setTimeout(n, 0);
},
    Q = function Q(e, n) {
  n = n || {};
  var t = f("TTFB"),
      r = d(e, t, J, n.reportAllChanges);
  K(function () {
    var i = c();
    i && (t.value = Math.max(i.responseStart - u(), 0), t.entries = [i], r(!0), a(function () {
      t = f("TTFB", 0), (r = d(e, t, J, n.reportAllChanges))(!0);
    }));
  });
};

function getPaintBlocks(resources) {
  var paintBlocks = [];
  var elements = document.getElementsByTagName('*');
  var styleURL = /url\(("[^"]*"|'[^']*'|[^)]*)\)/i;

  for (var _i25 = 0; _i25 < elements.length; _i25++) {
    var element = elements[_i25];
    var src = '';

    if (hasTag(element, 'img')) {
      src = element.currentSrc || element.src;
    }

    if (!src) {
      var backgroundImage = getComputedStyle(element).getPropertyValue('background-image');

      if (backgroundImage) {
        var matches = styleURL.exec(backgroundImage);

        if (matches !== null) {
          src = matches[1];

          if (src.startsWith('"') || src.startsWith("'")) {
            src = src.substr(1, src.length - 2);
          }
        }
      }
    }

    if (!src) continue;
    var time = src.substr(0, 10) === 'data:image' ? 0 : resources[src];
    if (time === undefined) continue;
    var rect = element.getBoundingClientRect();
    var top = Math.max(rect.top, 0);
    var left = Math.max(rect.left, 0);
    var bottom = Math.min(rect.bottom, window.innerHeight || document.documentElement && document.documentElement.clientHeight || 0);
    var right = Math.min(rect.right, window.innerWidth || document.documentElement && document.documentElement.clientWidth || 0);
    if (bottom <= top || right <= left) continue;
    var area = (bottom - top) * (right - left);
    paintBlocks.push({
      time: time,
      area: area
    });
  }

  return paintBlocks;
}

function calculateSpeedIndex(firstContentfulPaint, paintBlocks) {
  var a = Math.max(document.documentElement && document.documentElement.clientWidth || 0, window.innerWidth || 0) * Math.max(document.documentElement && document.documentElement.clientHeight || 0, window.innerHeight || 0) / 10;
  var s = a * firstContentfulPaint;

  for (var _i27 = 0; _i27 < paintBlocks.length; _i27++) {
    var _paintBlocks$_i2 = paintBlocks[_i27],
        time = _paintBlocks$_i2.time,
        area = _paintBlocks$_i2.area;
    a += area;
    s += area * (time > firstContentfulPaint ? time : firstContentfulPaint);
  }

  return a === 0 ? 0 : s / a;
}

function Timing(app, opts) {
  var options = Object.assign({
    captureResourceTimings: true,
    capturePageLoadTimings: true,
    capturePageRenderTimings: true,
    excludedResourceUrls: []
  }, opts);

  if (!('PerformanceObserver' in window)) {
    options.captureResourceTimings = false;
  }

  if (!options.captureResourceTimings) {
    return;
  } // Resources are necessary for all timings


  var resources = {};

  function resourceTiming(entry) {
    var _options$excludedReso;

    if (entry.duration < 0 || !isURL(entry.name) || app.isServiceURL(entry.name)) return;

    if (resources !== null) {
      resources[entry.name] = entry.startTime + entry.duration;
    }

    var shouldSkip = false;
    (_options$excludedReso = options.excludedResourceUrls) === null || _options$excludedReso === void 0 ? void 0 : _options$excludedReso.forEach(function (url) {
      if (entry.name.startsWith(url)) {
        shouldSkip = true;
        return;
      }
    });

    if (shouldSkip) {
      return;
    }

    app.send(ResourceTiming(entry.startTime + getTimeOrigin(), entry.duration, entry.responseStart && entry.startTime ? entry.responseStart - entry.startTime : 0, entry.transferSize > entry.encodedBodySize ? entry.transferSize - entry.encodedBodySize : 0, entry.encodedBodySize || 0, entry.decodedBodySize || 0, entry.name, entry.initiatorType, entry.transferSize, // @ts-ignore
    entry.responseStatus && entry.responseStatus === 304 || entry.transferSize === 0));
  }

  var observer = new PerformanceObserver(function (list) {
    return list.getEntries().forEach(resourceTiming);
  });

  function onVitalsSignal(msg) {
    if (app.active()) {
      return app.send(WebVitals(msg.name, String(msg.value)));
    }
  }

  var prevSessionID;
  app.attachStartCallback(function (_ref19) {
    var sessionID = _ref19.sessionID;

    if (sessionID !== prevSessionID) {
      // Send past page resources on a newly started session
      performance.getEntriesByType('resource').forEach(resourceTiming);
      prevSessionID = sessionID;
    }

    observer.observe({
      entryTypes: ['resource']
    }); // browser support:
    // onCLS(): Chromium
    // onFCP(): Chromium, Firefox, Safari
    // onFID(): Chromium, Firefox (Deprecated)
    // onINP(): Chromium
    // onLCP(): Chromium, Firefox
    // onTTFB(): Chromium, Firefox, Safari

    w(onVitalsSignal);
    j(onVitalsSignal);
    G(onVitalsSignal);
    Q(onVitalsSignal);
  });
  app.attachStopCallback(function () {
    observer.disconnect();
  });
  var firstPaint = 0,
      firstContentfulPaint = 0;

  if (options.capturePageLoadTimings) {
    var pageLoadTimingSent = false;
    app.ticker.attach(function () {
      if (pageLoadTimingSent) {
        return;
      }

      if (firstPaint === 0 || firstContentfulPaint === 0) {
        performance.getEntriesByType('paint').forEach(function (entry) {
          var name = entry.name,
              startTime = entry.startTime;

          switch (name) {
            case 'first-paint':
              firstPaint = startTime;
              break;

            case 'first-contentful-paint':
              firstContentfulPaint = startTime;
              break;
          }
        });
      }

      if (performance.timing.loadEventEnd || performance.now() > 30000) {
        pageLoadTimingSent = true;
        var _performance$timing2 = performance.timing,
            navigationStart = _performance$timing2.navigationStart,
            requestStart = _performance$timing2.requestStart,
            responseStart = _performance$timing2.responseStart,
            responseEnd = _performance$timing2.responseEnd,
            domContentLoadedEventStart = _performance$timing2.domContentLoadedEventStart,
            domContentLoadedEventEnd = _performance$timing2.domContentLoadedEventEnd,
            loadEventStart = _performance$timing2.loadEventStart,
            loadEventEnd = _performance$timing2.loadEventEnd;
        app.send(PageLoadTiming(requestStart - navigationStart || 0, responseStart - navigationStart || 0, responseEnd - navigationStart || 0, domContentLoadedEventStart - navigationStart || 0, domContentLoadedEventEnd - navigationStart || 0, loadEventStart - navigationStart || 0, loadEventEnd - navigationStart || 0, firstPaint, firstContentfulPaint));
      }
    }, 30);
  }

  if (options.capturePageRenderTimings) {
    var visuallyComplete = 0,
        interactiveWindowStartTime = 0,
        interactiveWindowTickTime = 0,
        paintBlocks = null;
    var pageRenderTimingSent = false;
    app.ticker.attach(function () {
      if (pageRenderTimingSent) {
        return;
      }

      var time = performance.now();

      if (resources !== null) {
        visuallyComplete = Math.max.apply(null, Object.keys(resources).map(function (k) {
          return resources[k];
        }));

        if (time - visuallyComplete > 1000) {
          paintBlocks = getPaintBlocks(resources);
          resources = null;
        }
      }

      if (interactiveWindowTickTime !== null) {
        if (time - interactiveWindowTickTime > 50) {
          interactiveWindowStartTime = time;
        }

        interactiveWindowTickTime = time - interactiveWindowStartTime > 5000 ? null : time;
      }

      if (paintBlocks !== null && interactiveWindowTickTime === null || time > 30000) {
        pageRenderTimingSent = true;
        resources = null;
        var speedIndex = paintBlocks === null ? 0 : calculateSpeedIndex(firstContentfulPaint || firstPaint, paintBlocks);
        var _performance$timing4 = performance.timing,
            domContentLoadedEventEnd = _performance$timing4.domContentLoadedEventEnd,
            navigationStart = _performance$timing4.navigationStart;
        var timeToInteractive = interactiveWindowTickTime === null ? Math.max(interactiveWindowStartTime, firstContentfulPaint, domContentLoadedEventEnd - navigationStart || 0) : 0;
        app.send(PageRenderTiming(speedIndex, firstContentfulPaint > visuallyComplete ? firstContentfulPaint : visuallyComplete, timeToInteractive));
      }
    });
  }
}

function getDocumentScroll(doc) {
  var win = doc.defaultView;
  return [win && win.scrollX || doc.documentElement && doc.documentElement.scrollLeft || doc.body && doc.body.scrollLeft || 0, win && win.scrollY || doc.documentElement && doc.documentElement.scrollTop || doc.body && doc.body.scrollTop || 0];
}

function Scroll(app, insideIframe) {
  var documentScroll = false;
  var nodeScroll = new Map();

  function setNodeScroll(target) {
    if (!isNode(target)) {
      return;
    }

    if (isElementNode(target)) {
      nodeScroll.set(target, [target.scrollLeft, target.scrollTop]);
    }

    if (isDocument(target)) {
      nodeScroll.set(target, getDocumentScroll(target));
    }
  }

  var sendSetViewportScroll = app.safe(function () {
    if (insideIframe) {
      return;
    }

    app.send(SetViewportScroll.apply(void 0, _toConsumableArray(getDocumentScroll(document))));
  });
  var sendSetNodeScroll = app.safe(function (s, node) {
    var id = app.nodes.getID(node);

    if (id !== undefined) {
      app.send(SetNodeScroll(id, s[0], s[1]));
    }
  });
  app.attachStartCallback(sendSetViewportScroll);
  app.attachStopCallback(function () {
    documentScroll = false;
    nodeScroll.clear();
  });
  app.nodes.attachNodeCallback(function (node, isStart) {
    // MBTODO: iterate over all the nodes on start instead of using isStart hack
    if (isStart) {
      if (isElementNode(node) && node.scrollLeft + node.scrollTop > 0) {
        nodeScroll.set(node, [node.scrollLeft, node.scrollTop]);
      } else if (isDocument(node)) {
        // DRY somehow?
        nodeScroll.set(node, getDocumentScroll(node));
      }
    }

    if (isRootNode(node)) {
      // scroll is not-composed event (https://javascript.info/shadow-dom-events)
      app.nodes.attachNodeListener(node, 'scroll', function (e) {
        setNodeScroll(e.target);
      });
    }
  });
  app.attachEventListener(document, 'scroll', function (e) {
    var target = e.target;

    if (target === document) {
      documentScroll = true;
      return;
    }

    setNodeScroll(target);
  });
  app.ticker.attach(function () {
    if (documentScroll) {
      sendSetViewportScroll();
      documentScroll = false;
    }

    nodeScroll.forEach(sendSetNodeScroll);
    nodeScroll.clear();
  }, 5, false);
}

function Viewport(app) {
  var url, width, height;
  var navigationStart;
  var referrer = document.referrer;
  var sendSetPageLocation = app.safe(function () {
    var _document = document,
        URL = _document.URL;

    if (URL !== url) {
      url = URL;
      app.send(SetPageLocation(url, referrer, navigationStart, document.title));
      navigationStart = 0;
      referrer = url;
    }
  });
  var sendSetViewportSize = app.safe(function () {
    var _window = window,
        innerWidth = _window.innerWidth,
        innerHeight = _window.innerHeight;

    if (innerWidth !== width || innerHeight !== height) {
      width = innerWidth;
      height = innerHeight;
      app.send(SetViewportSize(width, height));
    }
  });
  var sendSetPageVisibility = document.hidden === undefined ? Function.prototype : app.safe(function () {
    return app.send(SetPageVisibility(document.hidden));
  });
  app.attachStartCallback(function () {
    url = null;
    navigationStart = getTimeOrigin();
    width = height = -1;
    sendSetPageLocation();
    sendSetViewportSize();
    sendSetPageVisibility();
  });

  if (document.hidden !== undefined) {
    app.attachEventListener(document, 'visibilitychange', sendSetPageVisibility, false, false);
  }

  app.ticker.attach(sendSetPageLocation, 1, false);
  app.ticker.attach(sendSetViewportSize, 5, false);
}

function hasAdoptedSS(node) {
  return isRootNode(node) && // @ts-ignore
  !!node.adoptedStyleSheets;
} // TODO: encapsulate to be init-ed on-start and join with cssrules.ts under one folder


var _id = 0xf;

function nextID() {
  return _id++;
}

var styleSheetIDMap = new Map();

function ConstructedStyleSheets(app) {
  if (app === null) {
    return;
  }

  if (!hasAdoptedSS(document)) {
    return;
  }

  var styleSheetIDMap = new Map();
  var adoptedStyleSheetsOwnings = new Map();

  var sendAdoptedStyleSheetsUpdate = function sendAdoptedStyleSheetsUpdate(root) {
    return setTimeout(function () {
      var nodeID = app.nodes.getID(root);

      if (root === document) {
        nodeID = 0; // main document doesn't have nodeID. ID count starts from the documentElement
      }

      if (nodeID === undefined) {
        return;
      }

      var pastOwning = adoptedStyleSheetsOwnings.get(nodeID);

      if (!pastOwning) {
        pastOwning = [];
      }

      var nowOwning = [];
      var styleSheets = root.adoptedStyleSheets;

      if (styleSheets && Symbol.iterator in styleSheets) {
        var _iterator9 = _createForOfIteratorHelper(styleSheets),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _s = _step9.value;
            var sheetID = styleSheetIDMap.get(_s);
            var init = !sheetID;

            if (!sheetID) {
              sheetID = nextID();
              styleSheetIDMap.set(_s, sheetID);
            }

            if (!pastOwning.includes(sheetID)) {
              app.send(AdoptedSSAddOwner(sheetID, nodeID));
            }

            if (init) {
              var rules = _s.cssRules;

              for (var _i29 = 0; _i29 < rules.length; _i29++) {
                app.send(AdoptedSSInsertRuleURLBased(sheetID, rules[_i29].cssText, _i29, app.getBaseHref()));
              }
            }

            nowOwning.push(sheetID);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }
      }

      if (Symbol.iterator in pastOwning) {
        var _iterator10 = _createForOfIteratorHelper(pastOwning),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _sheetID = _step10.value;

            if (!nowOwning.includes(_sheetID)) {
              app.send(AdoptedSSRemoveOwner(_sheetID, nodeID));
            }
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }

      adoptedStyleSheetsOwnings.set(nodeID, nowOwning);
    }, 20);
  }; // Mysterious bug:

  /* On the page https://explore.fast.design/components/fast-accordion
    the only rule inside the only adoptedStyleSheet of the iframe-s document
    gets changed during first milliseconds after the load.
    However, none of the documented methods (replace, insertRule) is triggered.
    The rule is not substituted (remains the same object), however the text gets changed.
  */


  function patchAdoptedStyleSheets(prototype) {
    var nativeAdoptedStyleSheetsDescriptor = Object.getOwnPropertyDescriptor(prototype, 'adoptedStyleSheets');

    if (nativeAdoptedStyleSheetsDescriptor) {
      Object.defineProperty(prototype, 'adoptedStyleSheets', _objectSpread(_objectSpread({}, nativeAdoptedStyleSheetsDescriptor), {}, {
        set: function set(value) {
          // @ts-ignore
          var retVal = nativeAdoptedStyleSheetsDescriptor.set.call(this, value);
          sendAdoptedStyleSheetsUpdate(this);
          return retVal;
        }
      }));
    }
  }

  var patchContext = function patchContext(context) {
    // @ts-ignore
    if (context.__openreplay_adpss_patched__) {
      return;
    } else {
      // @ts-ignore
      context.__openreplay_adpss_patched__ = true;
    }

    patchAdoptedStyleSheets(context.Document.prototype);
    patchAdoptedStyleSheets(context.ShadowRoot.prototype); //@ts-ignore TODO: upgrade ts to 4.8+

    var _context$CSSStyleShee = context.CSSStyleSheet.prototype,
        replace = _context$CSSStyleShee.replace,
        replaceSync = _context$CSSStyleShee.replaceSync; //@ts-ignore

    context.CSSStyleSheet.prototype.replace = function (text) {
      var _this57 = this;

      return replace.call(this, text).then(function (sheet) {
        var sheetID = styleSheetIDMap.get(_this57);

        if (sheetID) {
          app.send(AdoptedSSReplaceURLBased(sheetID, text, app.getBaseHref()));
        }

        return sheet;
      });
    }; //@ts-ignore


    context.CSSStyleSheet.prototype.replaceSync = function (text) {
      var sheetID = styleSheetIDMap.get(this);

      if (sheetID) {
        app.send(AdoptedSSReplaceURLBased(sheetID, text, app.getBaseHref()));
      }

      return replaceSync.call(this, text);
    };
  };

  patchContext(window);
  app.observer.attachContextCallback(app.safe(patchContext));
  app.attachStopCallback(function () {
    styleSheetIDMap.clear();
    adoptedStyleSheetsOwnings.clear();
  }); // So far main Document is not triggered with nodeCallbacks

  app.attachStartCallback(function () {
    sendAdoptedStyleSheetsUpdate(document);
  });
  app.nodes.attachNodeCallback(function (node) {
    if (hasAdoptedSS(node)) {
      sendAdoptedStyleSheetsUpdate(node);
    }
  });
}

function CSSRules(app) {
  if (app === null) {
    return;
  }

  if (!window.CSSStyleSheet) {
    app.send(TechnicalInfo('no_stylesheet_prototype_in_window', ''));
    return;
  }

  var sendInsertDeleteRule = app.safe(function (sheet, index, rule) {
    var sheetID = styleSheetIDMap.get(sheet);

    if (!sheetID) {
      // OK-case. Sheet haven't been registered yet. Rules will be sent on registration.
      return;
    }

    if (typeof rule === 'string') {
      app.send(AdoptedSSInsertRuleURLBased(sheetID, rule, index, app.getBaseHref()));
    } else {
      app.send(AdoptedSSDeleteRule(sheetID, index));
    }
  }); // TODO: proper rule insertion/removal (how?)

  var sendReplaceGroupingRule = app.safe(function (rule) {
    var topmostRule = rule;

    while (topmostRule.parentRule) {
      topmostRule = topmostRule.parentRule;
    }

    var sheet = topmostRule.parentStyleSheet;

    if (!sheet) {
      app.debug.warn('No parent StyleSheet found for', topmostRule, rule);
      return;
    }

    var sheetID = styleSheetIDMap.get(sheet);

    if (!sheetID) {
      app.debug.warn('No sheedID found for', sheet, styleSheetIDMap);
      return;
    }

    var cssText = topmostRule.cssText;
    var ruleList = sheet.cssRules;
    var idx = Array.from(ruleList).indexOf(topmostRule);

    if (idx >= 0) {
      app.send(AdoptedSSInsertRuleURLBased(sheetID, cssText, idx, app.getBaseHref()));
      app.send(AdoptedSSDeleteRule(sheetID, idx + 1)); // Remove previous clone
    } else {
      app.debug.warn('Rule index not found in', sheet, topmostRule);
    }
  });
  var patchContext = app.safe(function (context) {
    var _context$CSSStyleShee2 = context.CSSStyleSheet.prototype,
        insertRule = _context$CSSStyleShee2.insertRule,
        deleteRule = _context$CSSStyleShee2.deleteRule;
    var _context$CSSGroupingR = context.CSSGroupingRule.prototype,
        groupInsertRule = _context$CSSGroupingR.insertRule,
        groupDeleteRule = _context$CSSGroupingR.deleteRule;

    context.CSSStyleSheet.prototype.insertRule = function (rule) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      sendInsertDeleteRule(this, index, rule);
      return insertRule.call(this, rule, index);
    };

    context.CSSStyleSheet.prototype.deleteRule = function (index) {
      sendInsertDeleteRule(this, index);
      return deleteRule.call(this, index);
    };

    context.CSSGroupingRule.prototype.insertRule = function (rule) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var result = groupInsertRule.call(this, rule, index);
      sendReplaceGroupingRule(this);
      return result;
    };

    context.CSSGroupingRule.prototype.deleteRule = function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var result = groupDeleteRule.call(this, index);
      sendReplaceGroupingRule(this);
      return result;
    };
  });
  patchContext(window);
  app.observer.attachContextCallback(patchContext);
  app.nodes.attachNodeCallback(function (node) {
    if (!hasTag(node, 'style') || !node.sheet) {
      return;
    }

    if (node.textContent !== null && node.textContent.trim().length > 0) {
      return; // Non-virtual styles captured by the observer as a text
    }

    var nodeID = app.nodes.getID(node);

    if (!nodeID) {
      return;
    }

    var sheet = node.sheet;
    var sheetID = nextID();
    styleSheetIDMap.set(sheet, sheetID);
    app.send(AdoptedSSAddOwner(sheetID, nodeID));
    var rules = sheet.cssRules;

    for (var _i31 = 0; _i31 < rules.length; _i31++) {
      sendInsertDeleteRule(sheet, _i31, rules[_i31].cssText);
    }
  });
}

function Focus(app) {
  function sendSetNodeFocus(n) {
    var id = app.nodes.getID(n);

    if (id !== undefined) {
      app.send(SetNodeFocus(id));
    }
  }

  var blurred = false;
  app.nodes.attachNodeCallback(function (node) {
    if (!hasTag(node, 'body')) {
      return;
    }

    app.nodes.attachNodeListener(node, 'focus', function (e) {
      if (!isNode(e.target)) {
        return;
      }

      sendSetNodeFocus(e.target);
      blurred = false;
    });
    app.nodes.attachNodeListener(node, 'blur', function (e) {
      if (e.relatedTarget === null) {
        blurred = true;
        setTimeout(function () {
          if (blurred) {
            app.send(SetNodeFocus(-1));
          }
        }, 0);
      }
    });
  });
  app.attachStartCallback(function () {
    var elem = document.activeElement;

    while (elem && hasTag(elem, 'iframe') && elem.contentDocument) {
      elem = elem.contentDocument.activeElement;
    }

    if (elem && elem !== elem.ownerDocument.body) {
      sendSetNodeFocus(elem);
    }
  }, true);
}

function Fonts(app) {
  if (!window.FontFace) {
    return;
  }

  var docFonts = new Map();

  var patchWindow = function patchWindow(wnd) {
    // @ts-ignore
    var FontFaceInterceptor = /*#__PURE__*/function (_wnd$FontFace) {
      _inherits(FontFaceInterceptor, _wnd$FontFace);

      var _super4 = _createSuper(FontFaceInterceptor);

      function FontFaceInterceptor() {
        var _this58;

        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        _classCallCheck(this, FontFaceInterceptor);

        //maybe do this on load(). In this case check if the document.fonts.load(...) function calls the font's load()
        if (typeof args[1] === 'string') {
          var desc = '';

          if (args[2]) {
            app.safe(function () {
              desc = JSON.stringify(args[2]);
            });
          }

          var ffData = [args[0], args[1], desc];
          var ffDataArr = docFonts.get(wnd.document) || [];
          ffDataArr.push(ffData);
          docFonts.set(wnd.document, ffDataArr);
          var parentID = wnd === window ? 0 : app.nodes.getID(wnd.document);

          if (parentID === undefined) {
            return _possibleConstructorReturn(_this58);
          }

          if (app.active()) {
            app.send(LoadFontFace.apply(void 0, [parentID].concat(ffData)));
          }
        }

        return _super4.call.apply(_super4, [this].concat(args));
      }

      return _createClass(FontFaceInterceptor);
    }(wnd.FontFace);

    wnd.FontFace = FontFaceInterceptor;
  };

  app.observer.attachContextCallback(patchWindow);
  patchWindow(window);
  app.nodes.attachNodeCallback(app.safe(function (node) {
    if (!isDocument(node)) {
      return;
    }

    var ffDataArr = docFonts.get(node);

    if (!ffDataArr) {
      return;
    }

    var parentID = node.defaultView === window ? 0 : app.nodes.getID(node);

    if (parentID === undefined) {
      return;
    }

    ffDataArr.forEach(function (ffData) {
      app.send(LoadFontFace.apply(void 0, [parentID].concat(_toConsumableArray(ffData))));
    });
  }));
}

function axiosSpy(app, instance, opts, sanitize, stringify) {
  app.debug.log('Openreplay: attaching axios spy to instance', instance);

  function captureResponseData(axiosResponseObj) {
    app.debug.log('Openreplay: capturing axios response data', axiosResponseObj);
    var _axiosResponseObj$con = axiosResponseObj.config,
        reqHs = _axiosResponseObj$con.headers,
        reqData = _axiosResponseObj$con.data,
        method = _axiosResponseObj$con.method,
        url = _axiosResponseObj$con.url,
        baseURL = _axiosResponseObj$con.baseURL;
    var rData = axiosResponseObj.data,
        rHs = axiosResponseObj.headers,
        globStatus = axiosResponseObj.status,
        response = axiosResponseObj.response;

    var _ref20 = response || {},
        resData = _ref20.data,
        resHs = _ref20.headers,
        resStatus = _ref20.status;

    var ihOpt = opts.ignoreHeaders;
    var isHIgnoring = Array.isArray(ihOpt) ? function (name) {
      return ihOpt.includes(name);
    } : function () {
      return ihOpt;
    };

    function writeHeader(hsObj, header) {
      if (!isHIgnoring(header[0])) {
        hsObj[header[0]] = header[1];
      }
    }

    var requestHs = {};
    var responseHs = {};

    if (reqHs.toJSON) {
      requestHs = reqHs.toJSON();
    } else if (reqHs instanceof Headers) {
      reqHs.forEach(function (v, n) {
        return writeHeader(requestHs, [n, v]);
      });
    } else if (Array.isArray(reqHs)) {
      reqHs.forEach(function (h) {
        return writeHeader(requestHs, h);
      });
    } else if (typeof reqHs === 'object') {
      Object.entries(reqHs).forEach(function (h) {
        return writeHeader(requestHs, h);
      });
    }

    var usedResHeader = resHs ? resHs : rHs;

    if (usedResHeader.toJSON) {
      responseHs = usedResHeader.toJSON();
    } else if (usedResHeader instanceof Headers) {
      usedResHeader.forEach(function (v, n) {
        return writeHeader(responseHs, [n, v]);
      });
    } else if (Array.isArray(usedResHeader)) {
      usedResHeader.forEach(function (h) {
        return writeHeader(responseHs, h);
      });
    } else if (typeof usedResHeader === 'object') {
      Object.entries(usedResHeader).forEach(function (_ref21) {
        var _ref22 = _slicedToArray(_ref21, 2),
            n = _ref22[0],
            v = _ref22[1];

        if (!isHIgnoring(n)) responseHs[n] = v;
      });
    }

    var reqResInfo = sanitize({
      url: url,
      method: method || '',
      status: globStatus || resStatus || 0,
      request: {
        headers: requestHs,
        body: reqData
      },
      response: {
        headers: responseHs,
        body: resData || rData
      }
    });

    if (!reqResInfo) {
      app.debug.log('Openreplay: empty request/response info, skipping');
      return;
    }

    var requestStart = axiosResponseObj.config.__openreplay_timing;
    var duration = performance.now() - requestStart;
    app.debug.log('Openreplay: final req object', reqResInfo);
    app.send(NetworkRequest('xhr', String(method), String(reqResInfo.url), stringify(reqResInfo.request), stringify(reqResInfo.response), reqResInfo.status, requestStart + getTimeOrigin(), duration, 0));
  }

  function getStartTime(config) {
    app.debug.log('Openreplay: capturing API request', config);
    config.__openreplay_timing = performance.now();

    if (opts.sessionTokenHeader) {
      var header = typeof opts.sessionTokenHeader === 'string' ? opts.sessionTokenHeader : 'X-OpenReplay-Session-Token';
      var headerValue = app.getSessionToken();

      if (headerValue) {
        config.headers.set(header, headerValue);
      }
    }

    return config;
  }

  function captureNetworkRequest(response) {
    if (opts.failuresOnly) return response;
    captureResponseData(response);
    return response;
  }

  function captureNetworkError(error) {
    app.debug.log('Openreplay: capturing API request error', error);

    if (isAxiosError(error) && Boolean(error.response)) {
      captureResponseData(error.response);
    } else if (error instanceof Error) {
      app.send(getExceptionMessage(error, []));
    }

    return Promise.reject(error);
  }

  function logRequestError(ev) {
    app.debug.log('Openreplay: failed API request, skipping', ev);
  }

  var reqInt = instance.interceptors.request.use(getStartTime, logRequestError, {
    synchronous: true
  });
  var resInt = instance.interceptors.response.use(captureNetworkRequest, captureNetworkError, {
    synchronous: true
  });
  app.attachStopCallback(function () {
    var _instance$interceptor, _instance$interceptor2, _instance$interceptor3, _instance$interceptor4;

    (_instance$interceptor = (_instance$interceptor2 = instance.interceptors.request).eject) === null || _instance$interceptor === void 0 ? void 0 : _instance$interceptor.call(_instance$interceptor2, reqInt);
    (_instance$interceptor3 = (_instance$interceptor4 = instance.interceptors.response).eject) === null || _instance$interceptor3 === void 0 ? void 0 : _instance$interceptor3.call(_instance$interceptor4, resInt);
  });
}

function isAxiosError(payload) {
  return isObject(payload) && payload.isAxiosError === true;
}

function isObject(thing) {
  return thing !== null && typeof thing === 'object';
}
/**
 * I know we're not using most of the information from this class
 * but it can be useful in the future if we will decide to display more stuff in our ui
 * */


var NetworkMessage = /*#__PURE__*/function () {
  function NetworkMessage() {
    var ignoredHeaders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var setSessionTokenHeader = arguments.length > 1 ? arguments[1] : undefined;
    var sanitize = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, NetworkMessage);

    this.ignoredHeaders = ignoredHeaders;
    this.setSessionTokenHeader = setSessionTokenHeader;
    this.sanitize = sanitize;
    this.id = '';
    this.name = '';
    this.method = '';
    this.url = '';
    this.status = 0;
    this.statusText = '';
    this.cancelState = 0;
    this.readyState = 0;
    this.header = {};
    this.responseType = '';
    this.requestType = 'xhr';
    this.requestHeader = {};
    this.responseSize = 0; // bytes

    this.responseSizeText = '';
    this.startTime = 0;
    this.endTime = 0;
    this.duration = 0;
    this.getData = {};
    this.requestData = null;
  }

  _createClass(NetworkMessage, [{
    key: "getMessage",
    value: function getMessage() {
      var _this$writeHeaders = this.writeHeaders(),
          reqHs = _this$writeHeaders.reqHs,
          resHs = _this$writeHeaders.resHs;

      var request = {
        headers: reqHs,
        body: this.method === 'GET' ? JSON.stringify(this.getData) : this.requestData
      };
      var response = {
        headers: resHs,
        body: this.response
      };
      var messageInfo = this.sanitize({
        url: this.url,
        method: this.method,
        status: this.status,
        request: request,
        response: response
      });
      if (!messageInfo) return null;
      var isGraphql = messageInfo.url.includes("/graphql");

      if (isGraphql && messageInfo.response.body && typeof messageInfo.response.body === 'string') {
        var isError = messageInfo.response.body.includes("errors");
        messageInfo.status = isError ? 400 : 200;
        this.requestType = 'graphql';
      }

      return {
        requestType: this.requestType,
        method: messageInfo.method,
        url: messageInfo.url,
        request: JSON.stringify(messageInfo.request),
        response: JSON.stringify(messageInfo.response),
        status: messageInfo.status,
        startTime: this.startTime,
        duration: this.duration,
        responseSize: this.responseSize
      };
    }
  }, {
    key: "writeHeaders",
    value: function writeHeaders() {
      var _this59 = this;

      var reqHs = {};
      Object.entries(this.requestHeader).forEach(function (_ref23) {
        var _ref24 = _slicedToArray(_ref23, 2),
            key = _ref24[0],
            value = _ref24[1];

        if (_this59.isHeaderIgnored(key)) return;
        reqHs[key] = value;
      });
      this.setSessionTokenHeader(function (name, value) {
        reqHs[name] = value;
      });
      var resHs = {};
      Object.entries(this.header).forEach(function (_ref25) {
        var _ref26 = _slicedToArray(_ref25, 2),
            key = _ref26[0],
            value = _ref26[1];

        if (_this59.isHeaderIgnored(key)) return;
        resHs[key] = value;
      });
      return {
        reqHs: reqHs,
        resHs: resHs
      };
    }
  }, {
    key: "isHeaderIgnored",
    value: function isHeaderIgnored(key) {
      if (Array.isArray(this.ignoredHeaders)) {
        return this.ignoredHeaders.map(function (k) {
          return k.toLowerCase();
        }).includes(key.toLowerCase());
      } else {
        return this.ignoredHeaders;
      }
    }
  }]);

  return NetworkMessage;
}();

var getStringResponseByType = function getStringResponseByType(responseType, response) {
  var result = '';

  switch (responseType) {
    case '':
    case 'text':
    case 'json':
      if (typeof response == 'string') {
        result = response;
      } else if (isPureObject(response) || Array.isArray(response)) {
        result = JSON.stringify(response);
      } else if (typeof response !== 'undefined') {
        result = Object.prototype.toString.call(response);
      }

      break;

    case 'blob':
    case 'document':
    case 'arraybuffer':
    default:
      if (typeof response !== 'undefined') {
        result = Object.prototype.toString.call(response);
      }

      break;
  }

  return result;
};

var genStringBody = function genStringBody(body) {
  if (!body) {
    return null;
  }

  var result;

  if (typeof body === 'string') {
    if (body[0] === '{' || body[0] === '[') {
      result = body;
    } // 'a=1&b=2' => try to parse as query


    var arr = body.split('&');

    if (arr.length === 1) {
      // not a query, parse as original string
      result = body;
    } else {
      // 'a=1&b=2&c' => parse as query
      result = arr.join(',');
    }
  } else if (isIterable(body)) {
    // FormData or URLSearchParams or Array
    var _arr = [];

    var _iterator11 = _createForOfIteratorHelper(body),
        _step11;

    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var _step11$value2 = _slicedToArray(_step11.value, 2),
            key = _step11$value2[0],
            value = _step11$value2[1];

        _arr.push("".concat(key, "=").concat(typeof value === 'string' ? value : '[object Object]'));
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }

    result = _arr.join(',');
  } else if (body instanceof Blob || body instanceof ReadableStream || body instanceof ArrayBuffer) {
    result = 'byte data';
  } else if (isPureObject(body)) {
    // overriding ArrayBufferView which is not convertable to string
    result = body;
  } else {
    result = "can't parse body ".concat(typeof body);
  }

  return result;
};

var genGetDataByUrl = function genGetDataByUrl(url) {
  var getData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!isPureObject(getData)) {
    getData = {};
  }

  var query = url ? url.split('?') : []; // a.php?b=c&d=?e => ['a.php', 'b=c&d=', 'e']

  query.shift(); // => ['b=c&d=', 'e']

  if (query.length > 0) {
    query = query.join('?').split('&'); // => 'b=c&d=?e' => ['b=c', 'd=?e']

    var _iterator12 = _createForOfIteratorHelper(query),
        _step12;

    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var _q = _step12.value;

        var kv = _q.split('=');

        try {
          getData[kv[0]] = decodeURIComponent(kv[1]);
        } catch (e) {
          // "URIError: URI malformed" will be thrown when `kv[1]` contains "%", so just use raw data
          // @issue #470
          // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Malformed_URI
          getData[kv[0]] = kv[1];
        }
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }

  return getData;
};

function isPureObject(input) {
  return null !== input && typeof input === 'object';
}

function isIterable(value) {
  if (value === null || value === undefined) {
    return false;
  }

  if (ArrayBuffer.isView(value)) {
    return false;
  }

  return typeof Symbol !== 'undefined' && typeof value[Symbol.iterator] === 'function';
}

function formatByteSize(bytes) {
  if (bytes <= 0) {
    // shouldn't happen?
    return '';
  }

  if (bytes >= 1000 * 1000) {
    return (bytes / 1000 / 1000).toFixed(1) + ' MB';
  }

  if (bytes >= 1000) {
    return (bytes / 1000).toFixed(1) + ' KB';
  }

  return "".concat(bytes, "B");
}

var getURL = function getURL(urlString) {
  if (urlString.startsWith('//')) {
    var baseUrl = new URL(window.location.href);
    urlString = "".concat(baseUrl.protocol).concat(urlString);
  }

  if (urlString.startsWith('http')) {
    return new URL(urlString);
  } else {
    return new URL(urlString, window.location.href);
  }
}; // https://fetch.spec.whatwg.org/#concept-bodyinit-extract


var getContentType = function getContentType(data) {
  if (data instanceof Blob) {
    return data.type;
  }

  if (data instanceof FormData) {
    return 'multipart/form-data';
  }

  if (data instanceof URLSearchParams) {
    return 'application/x-www-form-urlencoded;charset=UTF-8';
  }

  return 'text/plain;charset=UTF-8';
};

var BeaconProxyHandler = /*#__PURE__*/function () {
  function BeaconProxyHandler(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl) {
    _classCallCheck(this, BeaconProxyHandler);

    this.ignoredHeaders = ignoredHeaders;
    this.setSessionTokenHeader = setSessionTokenHeader;
    this.sanitize = sanitize;
    this.sendMessage = sendMessage;
    this.isServiceUrl = isServiceUrl;
  }

  _createClass(BeaconProxyHandler, [{
    key: "apply",
    value: function apply(target, thisArg, argsList) {
      var urlString = argsList[0];
      var data = argsList[1];
      var item = new NetworkMessage(this.ignoredHeaders, this.setSessionTokenHeader, this.sanitize);

      if (this.isServiceUrl(urlString)) {
        return target.apply(thisArg, argsList);
      }

      var url = getURL(urlString);
      item.method = 'POST';
      item.url = urlString;
      item.name = (url.pathname.split('/').pop() || '') + url.search;
      item.requestType = 'beacon';
      item.requestHeader = {
        'Content-Type': getContentType(data)
      };
      item.status = 0;
      item.statusText = 'Pending';

      if (url.search && url.searchParams) {
        item.getData = {};

        var _iterator13 = _createForOfIteratorHelper(url.searchParams),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _step13$value2 = _slicedToArray(_step13.value, 2),
                key = _step13$value2[0],
                value = _step13$value2[1];

            item.getData[key] = value;
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }

      item.requestData = genStringBody(data);

      if (!item.startTime) {
        item.startTime = performance.now();
      }

      var isSuccess = target.apply(thisArg, argsList);

      if (isSuccess) {
        item.endTime = performance.now();
        item.duration = item.endTime - (item.startTime || item.endTime);
        item.status = 0;
        item.statusText = 'Sent';
        item.readyState = 4;
      } else {
        item.status = 500;
        item.statusText = 'Unknown';
      }

      var msg = item.getMessage();

      if (msg) {
        this.sendMessage(msg);
      }

      return isSuccess;
    }
  }]);

  return BeaconProxyHandler;
}();

var BeaconProxy = /*#__PURE__*/function () {
  function BeaconProxy() {
    _classCallCheck(this, BeaconProxy);
  }

  _createClass(BeaconProxy, null, [{
    key: "create",
    value: function create(originalSendBeacon, ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl) {
      if (!originalSendBeacon) {
        return undefined;
      }

      return new Proxy(originalSendBeacon, new BeaconProxyHandler(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl));
    }
  }]);

  return BeaconProxy;
}();

var RequestState;

(function (RequestState) {
  RequestState[RequestState["UNSENT"] = 0] = "UNSENT";
  RequestState[RequestState["OPENED"] = 1] = "OPENED";
  RequestState[RequestState["HEADERS_RECEIVED"] = 2] = "HEADERS_RECEIVED";
  RequestState[RequestState["LOADING"] = 3] = "LOADING";
  RequestState[RequestState["DONE"] = 4] = "DONE";
})(RequestState || (RequestState = {}));
/**
 * I took inspiration in few stack exchange posts
 * and Tencent vConsole library (MIT)
 * by wrapping the XMLHttpRequest object in a Proxy
 * we can intercept the network requests
 * in not-so-hacky way
 * */


var ResponseProxyHandler = /*#__PURE__*/function () {
  function ResponseProxyHandler(resp, item) {
    _classCallCheck(this, ResponseProxyHandler);

    this.resp = resp;
    this.item = item;
    this.mockReader();
  }

  _createClass(ResponseProxyHandler, [{
    key: "set",
    value: function set(target, key, value) {
      return Reflect.set(target, key, value);
    }
  }, {
    key: "get",
    value: function get(target, key) {
      var _this60 = this;

      var value = Reflect.get(target, key);

      switch (key) {
        case 'arrayBuffer':
        case 'blob':
        case 'formData':
        case 'json':
        case 'text':
          return function () {
            _this60.item.responseType = key.toLowerCase(); // @ts-ignore

            return value.apply(target).then(function (resp) {
              _this60.item.response = getStringResponseByType(_this60.item.responseType, resp);
              return resp;
            });
          };
      }

      if (typeof value === 'function') {
        return value.bind(target);
      } else {
        return value;
      }
    }
  }, {
    key: "mockReader",
    value: function mockReader() {
      var _this61 = this;

      var readerReceivedValue;

      if (!this.resp.body) {
        // some browsers do not return `body` in some cases, like `OPTIONS` method
        return;
      }

      if (typeof this.resp.body.getReader !== 'function') {
        return;
      }

      var _getReader = this.resp.body.getReader; // @ts-ignore

      this.resp.body.getReader = function () {
        var reader = _getReader.apply(_this61.resp.body); // when readyState is already 4,
        // it's not a chunked stream, or it had already been read.
        // so should not update status.


        if (_this61.item.readyState === RequestState.DONE) {
          return reader;
        }

        var _read = reader.read;
        var _cancel = reader.cancel;
        _this61.item.responseType = 'arraybuffer'; // @ts-ignore

        reader.read = function () {
          return _read.apply(reader).then(function (result) {
            if (!readerReceivedValue) {
              // @ts-ignore
              readerReceivedValue = new Uint8Array(result.value);
            } else {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              var newValue = new Uint8Array(readerReceivedValue.length + result.value.length);
              newValue.set(readerReceivedValue); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

              newValue.set(result.value, readerReceivedValue.length);
              readerReceivedValue = newValue;
            }

            _this61.item.endTime = performance.now();
            _this61.item.duration = _this61.item.endTime - (_this61.item.startTime || _this61.item.endTime);
            _this61.item.readyState = result.done ? 4 : 3;
            _this61.item.statusText = result.done ? String(_this61.item.status) : 'Loading';
            _this61.item.responseSize = readerReceivedValue.length;
            _this61.item.responseSizeText = formatByteSize(_this61.item.responseSize);

            if (result.done) {
              _this61.item.response = getStringResponseByType(_this61.item.responseType, readerReceivedValue);
            }

            return result;
          });
        };

        reader.cancel = function () {
          _this61.item.cancelState = 2;
          _this61.item.statusText = 'Cancel';
          _this61.item.endTime = performance.now();
          _this61.item.duration = _this61.item.endTime - (_this61.item.startTime || _this61.item.endTime);
          _this61.item.response = getStringResponseByType(_this61.item.responseType, readerReceivedValue);

          for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            args[_key5] = arguments[_key5];
          }

          return _cancel.apply(reader, args);
        };

        return reader;
      };
    }
  }]);

  return ResponseProxyHandler;
}();

var FetchProxyHandler = /*#__PURE__*/function () {
  function FetchProxyHandler(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher) {
    _classCallCheck(this, FetchProxyHandler);

    this.ignoredHeaders = ignoredHeaders;
    this.setSessionTokenHeader = setSessionTokenHeader;
    this.sanitize = sanitize;
    this.sendMessage = sendMessage;
    this.isServiceUrl = isServiceUrl;
    this.tokenUrlMatcher = tokenUrlMatcher;
  }

  _createClass(FetchProxyHandler, [{
    key: "apply",
    value: function apply(target, _, argsList) {
      var _this62 = this;

      var input = argsList[0];
      var init = argsList[1];

      if (!input || // @ts-ignore
      typeof input !== 'string' && !(input === null || input === void 0 ? void 0 : input.url)) {
        return target.apply(window, argsList);
      }

      var isORUrl = input instanceof URL || typeof input === 'string' ? this.isServiceUrl(String(input)) : this.isServiceUrl(String(input.url));

      if (isORUrl) {
        return target.apply(window, argsList);
      }

      var item = new NetworkMessage(this.ignoredHeaders, this.setSessionTokenHeader, this.sanitize);
      this.beforeFetch(item, input, init);
      this.setSessionTokenHeader(function (name, value) {
        if (_this62.tokenUrlMatcher !== undefined) {
          if (!_this62.tokenUrlMatcher(item.url)) {
            return;
          }
        }

        if (argsList[1] === undefined && argsList[0] instanceof Request) {
          return argsList[0].headers.append(name, value);
        } else {
          if (!argsList[1]) argsList[1] = {};

          if (argsList[1].headers === undefined) {
            argsList[1] = Object.assign(Object.assign({}, argsList[1]), {
              headers: {}
            });
          }

          if (argsList[1].headers instanceof Headers) {
            argsList[1].headers.append(name, value);
          } else if (Array.isArray(argsList[1].headers)) {
            argsList[1].headers.push([name, value]);
          } else {
            // @ts-ignore
            argsList[1].headers[name] = value;
          }
        }
      });
      return target.apply(window, argsList).then(this.afterFetch(item)).catch(function (e) {
        // mock finally
        item.endTime = performance.now();
        item.duration = item.endTime - (item.startTime || item.endTime);
        throw e;
      });
    }
  }, {
    key: "beforeFetch",
    value: function beforeFetch(item, input, init) {
      var url,
          method = 'GET',
          requestHeader = {}; // handle `input` content

      if (typeof input === 'string') {
        // when `input` is a string
        method = (init === null || init === void 0 ? void 0 : init.method) || 'GET';
        url = getURL(input);
        requestHeader = (init === null || init === void 0 ? void 0 : init.headers) || {};
      } else {
        // when `input` is a `Request` object
        method = input.method || 'GET';
        url = getURL(input.url);
        requestHeader = input.headers;
      }

      item.method = method;
      item.requestType = 'fetch';
      item.requestHeader = requestHeader;
      item.url = url.toString();
      item.name = (url.pathname.split('/').pop() || '') + url.search;
      item.status = 0;
      item.statusText = 'Pending';
      item.readyState = 1;

      if (!item.startTime) {
        // UNSENT
        item.startTime = performance.now();
      }

      if (Object.prototype.toString.call(requestHeader) === '[object Headers]') {
        item.requestHeader = {};

        var _iterator14 = _createForOfIteratorHelper(requestHeader),
            _step14;

        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var _step14$value2 = _slicedToArray(_step14.value, 2),
                key = _step14$value2[0],
                value = _step14$value2[1];

            item.requestHeader[key] = value;
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
      } else {
        item.requestHeader = requestHeader;
      } // save GET data


      if (url.search && url.searchParams) {
        item.getData = {};

        var _iterator15 = _createForOfIteratorHelper(url.searchParams),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var _step15$value2 = _slicedToArray(_step15.value, 2),
                _key6 = _step15$value2[0],
                _value = _step15$value2[1];

            item.getData[_key6] = _value;
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }
      } // save POST data


      if (init === null || init === void 0 ? void 0 : init.body) {
        item.requestData = genStringBody(init.body);
      }
    }
  }, {
    key: "afterFetch",
    value: function afterFetch(item) {
      var _this63 = this;

      return function (resp) {
        item.endTime = performance.now();
        item.duration = item.endTime - (item.startTime || item.endTime);
        item.status = resp.status;
        item.statusText = String(resp.status);
        var isChunked = false;
        item.header = {};

        var _iterator16 = _createForOfIteratorHelper(resp.headers),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var _step16$value2 = _slicedToArray(_step16.value, 2),
                key = _step16$value2[0],
                value = _step16$value2[1];

            item.header[key] = value;
            isChunked = value.toLowerCase().indexOf('chunked') > -1 ? true : isChunked;
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }

        if (isChunked) {
          // when `transfer-encoding` is chunked, the response is a stream which is under loading,
          // so the `readyState` should be 3 (Loading),
          // and the response should NOT be `clone()` which will affect stream reading.
          item.readyState = 3;
        } else {
          // Otherwise, not chunked, the response is not a stream,
          // so it's completed and can be cloned for `text()` calling.
          item.readyState = 4;

          _this63.handleResponseBody(resp.clone(), item).then(function (responseValue) {
            item.responseSize = typeof responseValue === 'string' ? responseValue.length : responseValue.byteLength;
            item.responseSizeText = formatByteSize(item.responseSize);
            item.response = getStringResponseByType(item.responseType, responseValue);
            var msg = item.getMessage();

            if (msg) {
              _this63.sendMessage(msg);
            }
          }).catch(function (e) {
            if (e.name !== 'AbortError') {
              throw e;
            }
          });
        }

        return new Proxy(resp, new ResponseProxyHandler(resp, item));
      };
    }
  }, {
    key: "handleResponseBody",
    value: function handleResponseBody(resp, item) {
      // parse response body by Content-Type
      var contentType = resp.headers.get('content-type');

      if (contentType && contentType.includes('application/json')) {
        item.responseType = 'json';
        return resp.text();
      } else if (contentType && (contentType.includes('text/html') || contentType.includes('text/plain'))) {
        item.responseType = 'text';
        return resp.text();
      } else {
        item.responseType = 'arraybuffer';
        return resp.arrayBuffer();
      }
    }
  }]);

  return FetchProxyHandler;
}();

var FetchProxy = /*#__PURE__*/function () {
  function FetchProxy() {
    _classCallCheck(this, FetchProxy);
  }

  _createClass(FetchProxy, null, [{
    key: "create",
    value: function create(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher) {
      return new Proxy(fetch, new FetchProxyHandler(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher));
    }
  }]);

  return FetchProxy;
}();
/**
 * I took inspiration in few stack exchange posts
 * and Tencent vConsole library (MIT)
 * by wrapping the XMLHttpRequest object in a Proxy
 * we can intercept the network requests
 * in not-so-hacky way
 * */


var XHRProxyHandler = /*#__PURE__*/function () {
  function XHRProxyHandler(XMLReq, ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher) {
    var _this64 = this;

    _classCallCheck(this, XHRProxyHandler);

    this.ignoredHeaders = ignoredHeaders;
    this.setSessionTokenHeader = setSessionTokenHeader;
    this.sanitize = sanitize;
    this.sendMessage = sendMessage;
    this.isServiceUrl = isServiceUrl;
    this.tokenUrlMatcher = tokenUrlMatcher;
    this.XMLReq = XMLReq;

    this.XMLReq.onreadystatechange = function () {
      _this64.onReadyStateChange();
    };

    this.XMLReq.onabort = function () {
      _this64.onAbort();
    };

    this.XMLReq.ontimeout = function () {
      _this64.onTimeout();
    };

    this.item = new NetworkMessage(ignoredHeaders, setSessionTokenHeader, sanitize);
    this.item.requestType = 'xhr';
  }

  _createClass(XHRProxyHandler, [{
    key: "get",
    value: function get(target, key) {
      var _this65 = this;

      switch (key) {
        case 'open':
          return this.getOpen(target);

        case 'send':
          this.setSessionTokenHeader(function (name, value) {
            if (_this65.tokenUrlMatcher !== undefined) {
              if (!_this65.tokenUrlMatcher(_this65.item.url)) {
                return;
              }
            }

            target.setRequestHeader(name, value);
          });
          return this.getSend(target);

        case 'setRequestHeader':
          return this.getSetRequestHeader(target);

        default:
          // eslint-disable-next-line no-case-declarations
          var value = Reflect.get(target, key);

          if (typeof value === 'function') {
            return value.bind(target);
          } else {
            return value;
          }

      }
    }
  }, {
    key: "set",
    value: function set(target, key, value) {
      switch (key) {
        case 'onreadystatechange':
          return this.setOnReadyStateChange(target, key, value);

        case 'onabort':
          return this.setOnAbort(target, key, value);

        case 'ontimeout':
          return this.setOnTimeout(target, key, value);
        // not tracked methods
      }

      return Reflect.set(target, key, value);
    }
  }, {
    key: "onReadyStateChange",
    value: function onReadyStateChange() {
      var _this66 = this;

      if (this.item.url && this.isServiceUrl(this.item.url)) return;
      this.item.readyState = this.XMLReq.readyState;
      this.item.responseType = this.XMLReq.responseType;
      this.item.endTime = performance.now();
      this.item.duration = this.item.endTime - this.item.startTime;
      this.updateItemByReadyState();
      setTimeout(function () {
        _this66.item.response = getStringResponseByType(_this66.item.responseType, _this66.item.response);
      }, 0);

      if (this.XMLReq.readyState === RequestState.DONE) {
        var msg = this.item.getMessage();

        if (msg) {
          this.sendMessage(msg);
        }
      }
    }
  }, {
    key: "onAbort",
    value: function onAbort() {
      this.item.cancelState = 1;
      this.item.statusText = 'Abort';
      var msg = this.item.getMessage();

      if (msg) {
        this.sendMessage(msg);
      }
    }
  }, {
    key: "onTimeout",
    value: function onTimeout() {
      this.item.cancelState = 3;
      this.item.statusText = 'Timeout';
      var msg = this.item.getMessage();

      if (msg) {
        this.sendMessage(msg);
      }
    }
  }, {
    key: "getOpen",
    value: function getOpen(target) {
      var _this67 = this;

      var targetFunction = Reflect.get(target, 'open');
      return function () {
        var _a, _b, _c;

        for (var _len6 = arguments.length, args = new Array(_len6), _key7 = 0; _key7 < _len6; _key7++) {
          args[_key7] = arguments[_key7];
        }

        var method = args[0];
        var url = args[1];
        _this67.item.method = method ? method.toUpperCase() : 'GET';
        _this67.item.url = ((_a = url.toString) === null || _a === void 0 ? void 0 : _a.call(url)) || '';
        _this67.item.name = (_c = (_b = _this67.item.url) === null || _b === void 0 ? void 0 : _b.replace(new RegExp('/*$'), '').split('/').pop()) !== null && _c !== void 0 ? _c : '';
        _this67.item.getData = genGetDataByUrl(_this67.item.url, {});
        return targetFunction.apply(target, args);
      };
    }
  }, {
    key: "getSend",
    value: function getSend(target) {
      var _this68 = this;

      var targetFunction = Reflect.get(target, 'send');
      return function () {
        for (var _len7 = arguments.length, args = new Array(_len7), _key8 = 0; _key8 < _len7; _key8++) {
          args[_key8] = arguments[_key8];
        }

        var data = args[0];
        _this68.item.requestData = genStringBody(data);
        return targetFunction.apply(target, args);
      };
    }
  }, {
    key: "getSetRequestHeader",
    value: function getSetRequestHeader(target) {
      var _this69 = this;

      var targetFunction = Reflect.get(target, 'setRequestHeader');
      return function () {
        if (!_this69.item.requestHeader) {
          _this69.item.requestHeader = {};
        } // @ts-ignore


        for (var _len8 = arguments.length, args = new Array(_len8), _key9 = 0; _key9 < _len8; _key9++) {
          args[_key9] = arguments[_key9];
        }

        _this69.item.requestHeader[args[0]] = args[1];
        return targetFunction.apply(target, args);
      };
    }
  }, {
    key: "setOnReadyStateChange",
    value: function setOnReadyStateChange(target, key, orscFunction) {
      var _this70 = this;

      return Reflect.set(target, key, function () {
        _this70.onReadyStateChange();

        for (var _len9 = arguments.length, args = new Array(_len9), _key10 = 0; _key10 < _len9; _key10++) {
          args[_key10] = arguments[_key10];
        }

        orscFunction === null || orscFunction === void 0 ? void 0 : orscFunction.apply(target, args);
      });
    }
  }, {
    key: "setOnAbort",
    value: function setOnAbort(target, key, oaFunction) {
      var _this71 = this;

      return Reflect.set(target, key, function () {
        _this71.onAbort();

        for (var _len10 = arguments.length, args = new Array(_len10), _key11 = 0; _key11 < _len10; _key11++) {
          args[_key11] = arguments[_key11];
        }

        oaFunction.apply(target, args);
      });
    }
  }, {
    key: "setOnTimeout",
    value: function setOnTimeout(target, key, otFunction) {
      var _this72 = this;

      return Reflect.set(target, key, function () {
        _this72.onTimeout();

        for (var _len11 = arguments.length, args = new Array(_len11), _key12 = 0; _key12 < _len11; _key12++) {
          args[_key12] = arguments[_key12];
        }

        otFunction.apply(target, args);
      });
    }
    /**
     * Update item's properties according to readyState.
     */

  }, {
    key: "updateItemByReadyState",
    value: function updateItemByReadyState() {
      switch (this.XMLReq.readyState) {
        case RequestState.UNSENT:
        case RequestState.OPENED:
          this.item.status = RequestState.UNSENT;
          this.item.statusText = 'Pending';

          if (!this.item.startTime) {
            this.item.startTime = performance.now();
          }

          break;

        case RequestState.HEADERS_RECEIVED:
          this.item.status = this.XMLReq.status;
          this.item.statusText = 'Loading';
          this.item.header = {}; // eslint-disable-next-line no-case-declarations

          var header = this.XMLReq.getAllResponseHeaders() || '',
              headerArr = header.split('\n'); // extract plain text to key-value format

          for (var _i33 = 0; _i33 < headerArr.length; _i33++) {
            var line = headerArr[_i33];

            if (!line) {
              continue;
            }

            var arr = line.split(': ');
            var key = arr[0];
            this.item.header[key] = arr.slice(1).join(': ');
          }

          break;

        case RequestState.LOADING:
          this.item.status = this.XMLReq.status;
          this.item.statusText = 'Loading';

          if (!!this.XMLReq.response && this.XMLReq.response.length) {
            this.item.responseSize = this.XMLReq.response.length;
            this.item.responseSizeText = formatByteSize(this.item.responseSize);
          }

          break;

        case RequestState.DONE:
          // `XMLReq.abort()` will change `status` from 200 to 0, so use previous value in this case
          this.item.status = this.XMLReq.status || this.item.status || 0; // show status code when request completed

          this.item.statusText = String(this.item.status);
          this.item.endTime = performance.now();
          this.item.duration = this.item.endTime - (this.item.startTime || this.item.endTime);
          this.item.response = this.XMLReq.response;

          if (!!this.XMLReq.response && this.XMLReq.response.length) {
            this.item.responseSize = this.XMLReq.response.length;
            this.item.responseSizeText = formatByteSize(this.item.responseSize);
          }

          break;

        default:
          this.item.status = this.XMLReq.status;
          this.item.statusText = 'Unknown';
          break;
      }
    }
  }]);

  return XHRProxyHandler;
}();

var XHRProxy = /*#__PURE__*/function () {
  function XHRProxy() {
    _classCallCheck(this, XHRProxy);
  }

  _createClass(XHRProxy, null, [{
    key: "create",
    value: function create(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher) {
      return new Proxy(XMLHttpRequest, {
        construct: function construct(original) {
          var XMLReq = new original();
          return new Proxy(XMLReq, new XHRProxyHandler(XMLReq, ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher));
        }
      });
    }
  }]);

  return XHRProxy;
}();

var getWarning = function getWarning(api) {
  var str = "Openreplay: Can't find ".concat(api, " in global context.");
  console.warn(str);
};
/**
 * Creates network proxies for XMLHttpRequest, fetch, and sendBeacon to intercept and monitor network requests and
 * responses.
 *
 * @param {Window | typeof globalThis} context - The global context object (e.g., window or globalThis).
 * @param {boolean | string[]} ignoredHeaders - Headers to ignore from requests. If `true`, all headers are ignored; if
 *   an array of strings, those header names are ignored.
 * @param {(cb: (name: string, value: string) => void) => void} setSessionTokenHeader - Function to set a session token
 *   header; accepts a callback that sets the header name and value.
 * @param {(data: RequestResponseData) => RequestResponseData | null} sanitize - Function to sanitize request and
 *   response data; should return sanitized data or `null` to ignore the data.
 * @param {(message: INetworkMessage) => void} sendMessage - Function to send network messages for further processing
 *   or logging.
 * @param {(url: string) => boolean} isServiceUrl - Function to determine if a URL is a service URL that should be
 *   ignored by the proxy.
 * @param {Object} [modules] - Modules to apply the proxies to.
 * @param {boolean} [modules.xhr=true] - Whether to proxy XMLHttpRequest.
 * @param {boolean} [modules.fetch=true] - Whether to proxy the fetch API.
 * @param {boolean} [modules.beacon=true] - Whether to proxy navigator.sendBeacon.
 * @param {(url: string) => boolean} [tokenUrlMatcher] - Optional function; the session token header will only be
 *   applied to requests matching this function.
 *
 * @returns {void}
 */


function createNetworkProxy(context, ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl) {
  var modules = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {
    xhr: true,
    fetch: true,
    beacon: true
  };
  var tokenUrlMatcher = arguments.length > 7 ? arguments[7] : undefined;

  var _a;

  if (!context) return;

  if (modules.xhr) {
    if (context.XMLHttpRequest) {
      context.XMLHttpRequest = XHRProxy.create(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher);
    } else {
      getWarning("XMLHttpRequest");
    }
  }

  if (modules.fetch) {
    if (context.fetch) {
      context.fetch = FetchProxy.create(ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl, tokenUrlMatcher);
    } else {
      getWarning("fetch");
    }
  }

  if (modules.beacon) {
    if ((_a = context.navigator) === null || _a === void 0 ? void 0 : _a.sendBeacon) {
      var origBeacon = context.navigator.sendBeacon;
      context.navigator.sendBeacon = BeaconProxy.create(origBeacon, ignoredHeaders, setSessionTokenHeader, sanitize, sendMessage, isServiceUrl);
    }
  }
}

function getXHRRequestDataObject(xhr) {
  // @ts-ignore  this is 3x faster than using Map<XHR, XHRRequestData>
  if (!xhr.__or_req_data__) {
    // @ts-ignore
    xhr.__or_req_data__ = {
      body: undefined,
      headers: {}
    };
  } // @ts-ignore


  return xhr.__or_req_data__;
}

function strMethod(method) {
  return typeof method === 'string' ? method.toUpperCase() : 'GET';
}

function Network(app) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = Object.assign({
    failuresOnly: false,
    ignoreHeaders: ['cookie', 'set-cookie', 'authorization'],
    capturePayload: false,
    sessionTokenHeader: false,
    captureInIframes: true,
    axiosInstances: undefined,
    useProxy: true
  }, opts);

  if (options.useProxy === false) {
    app.debug.warn('Network module is migrating to proxy api, to gradually migrate and test it set useProxy to true');
  }

  var ignoreHeaders = options.ignoreHeaders;
  var isHIgnored = Array.isArray(ignoreHeaders) ? function (name) {
    return ignoreHeaders.includes(name);
  } : function () {
    return ignoreHeaders;
  };
  var stHeader = options.sessionTokenHeader === true ? 'X-OpenReplay-SessionToken' : options.sessionTokenHeader;

  function setSessionTokenHeader(setRequestHeader) {
    if (stHeader) {
      var sessionToken = app.getSessionToken();

      if (sessionToken) {
        app.safe(setRequestHeader)(stHeader, sessionToken);
      }
    }
  }

  function sanitize(reqResInfo) {
    if (!options.capturePayload) {
      // @ts-ignore
      delete reqResInfo.request.body;
      delete reqResInfo.response.body;
    }

    if (options.sanitizer) {
      var resBody = reqResInfo.response.body;

      if (typeof resBody === 'string') {
        // Parse response in order to have handy view in sanitization function
        try {
          reqResInfo.response.body = JSON.parse(resBody);
        } catch (_unused) {}
      }

      return options.sanitizer(reqResInfo);
    }

    return reqResInfo;
  }

  function stringify(r) {
    if (r && typeof r.body !== 'string') {
      try {
        r.body = JSON.stringify(r.body);
      } catch (_unused2) {
        r.body = '<unable to stringify>';
        app.notify.warn("Openreplay fetch couldn't stringify body:", r.body);
      }
    }

    return JSON.stringify(r);
  }

  var patchWindow = function patchWindow(context) {
    /* ====== modern way ====== */
    if (options.useProxy) {
      return createNetworkProxy(context, options.ignoreHeaders, setSessionTokenHeader, sanitize, function (message) {
        app.send(NetworkRequest(message.requestType, message.method, message.url, message.request, message.response, message.status, message.startTime + getTimeOrigin(), message.duration, message.responseSize));
      }, function (url) {
        return app.isServiceURL(url);
      }, {
        xhr: true,
        fetch: true,
        beacon: true
      }, options.tokenUrlMatcher);
    }
    /* ====== Fetch ====== */


    var origFetch = context.fetch.bind(context);

    var trackFetch = function trackFetch(input) {
      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!(typeof input === 'string' || input instanceof URL) || app.isServiceURL(String(input))) {
        return origFetch(input, init);
      }

      setSessionTokenHeader(function (name, value) {
        if (init.headers === undefined) {
          init.headers = {};
        }

        if (init.headers instanceof Headers) {
          init.headers.append(name, value);
        } else if (Array.isArray(init.headers)) {
          init.headers.push([name, value]);
        } else {
          init.headers[name] = value;
        }
      });
      var startTime = performance.now();
      return origFetch(input, init).then(function (response) {
        var duration = performance.now() - startTime;

        if (options.failuresOnly && response.status < 400) {
          return response;
        }

        var r = response.clone();
        r.text().then(function (text) {
          var reqHs = {};
          var resHs = {};

          if (ignoreHeaders !== true) {
            // request headers
            var writeReqHeader = function writeReqHeader(_ref27) {
              var _ref28 = _slicedToArray(_ref27, 2),
                  n = _ref28[0],
                  v = _ref28[1];

              if (!isHIgnored(n)) {
                reqHs[n] = v;
              }
            };

            if (init.headers instanceof Headers) {
              init.headers.forEach(function (v, n) {
                return writeReqHeader([n, v]);
              });
            } else if (Array.isArray(init.headers)) {
              init.headers.forEach(writeReqHeader);
            } else if (typeof init.headers === 'object') {
              Object.entries(init.headers).forEach(writeReqHeader);
            } // response headers


            r.headers.forEach(function (v, n) {
              if (!isHIgnored(n)) resHs[n] = v;
            });
          }

          var method = strMethod(init.method);
          var reqResInfo = sanitize({
            url: String(input),
            method: method,
            status: r.status,
            request: {
              headers: reqHs,
              // @ts-ignore
              body: init.body || null
            },
            response: {
              headers: resHs,
              body: text
            }
          });

          if (!reqResInfo) {
            return;
          }

          app.send(NetworkRequest('fetch', method, String(reqResInfo.url), stringify(reqResInfo.request), stringify(reqResInfo.response), r.status, startTime + getTimeOrigin(), duration, 0));
        }).catch(function (e) {
          return app.debug.error('Could not process Fetch response:', e);
        });
        return response;
      });
    }; // @ts-ignore


    context.fetch = trackFetch;
    /* ====== <> ====== */

    /* ====== XHR ====== */

    var nativeOpen = context.XMLHttpRequest.prototype.open;
    var nativeSetRequestHeader = context.XMLHttpRequest.prototype.setRequestHeader;
    var nativeSend = context.XMLHttpRequest.prototype.send;

    function trackXMLHttpReqOpen(initMethod, url) {
      var xhr = this;
      setSessionTokenHeader(function (name, value) {
        return xhr.setRequestHeader(name, value);
      });
      var startTime = 0;
      xhr.addEventListener('loadstart', function (e) {
        startTime = e.timeStamp;
      });
      xhr.addEventListener('load', app.safe(function (e) {
        var _getXHRRequestDataObj = getXHRRequestDataObject(xhr),
            reqHs = _getXHRRequestDataObj.headers,
            reqBody = _getXHRRequestDataObj.body;

        var duration = startTime > 0 ? e.timeStamp - startTime : 0;
        var hString = xhr.getAllResponseHeaders() || ''; // might be null (only if no response received though)

        var headersArr = hString.trim().split(/[\r\n]+/);
        var headerMap = {};
        headersArr.forEach(function (line) {
          var parts = line.split(': ');
          var header = parts.shift();

          if (!isHIgnored(header)) {
            headerMap[header] = parts.join(': ');
          }
        });
        var method = strMethod(initMethod);
        var reqResInfo = sanitize({
          url: String(url),
          method: method,
          status: xhr.status,
          request: {
            headers: reqHs,
            // @ts-ignore
            body: reqBody || null
          },
          response: {
            headers: headerMap,
            body: xhr.response
          }
        });

        if (!reqResInfo) {
          return;
        }

        app.send(NetworkRequest('xhr', method, String(reqResInfo.url), stringify(reqResInfo.request), stringify(reqResInfo.response), xhr.status, startTime + getTimeOrigin(), duration, 0));
      })); //TODO: handle error (though it has no Error API nor any useful information)
      //xhr.addEventListener('error', (e) => {})

      return nativeOpen.apply(this, arguments);
    }

    function trackXHRSend(body) {
      var rdo = getXHRRequestDataObject(this);
      rdo.body = body; // @ts-ignore ??? this -> XMLHttpRequest

      return nativeSend.apply(this, arguments);
    }

    function trackSetReqHeader(name, value) {
      if (!isHIgnored(name)) {
        var rdo = getXHRRequestDataObject(this);
        rdo.headers[name] = value;
      }

      return nativeSetRequestHeader.apply(this, arguments);
    }

    if (!options.axiosInstances) {
      context.XMLHttpRequest.prototype.open = trackXMLHttpReqOpen;
      context.XMLHttpRequest.prototype.send = trackXHRSend;
      context.XMLHttpRequest.prototype.setRequestHeader = trackSetReqHeader;
    }
    /* ====== <> ====== */

  };

  patchWindow(window);

  if (options.axiosInstances) {
    options.axiosInstances.forEach(function (axiosInstance) {
      axiosSpy(app, axiosInstance, options, sanitize, stringify);
    });
  }

  if (options.captureInIframes) {
    app.observer.attachContextCallback(app.safe(patchWindow));
  }
}

function selection(app) {
  app.attachEventListener(document, 'selectionchange', function () {
    var selection = document.getSelection();

    if (selection !== null && !selection.isCollapsed) {
      var selectionStart = app.nodes.getID(selection.anchorNode);
      var selectionEnd = app.nodes.getID(selection.focusNode);
      var selectedText = selection.toString().replace(/\s+/g, ' ');

      if (selectionStart && selectionEnd) {
        app.send(SelectionChange(selectionStart, selectionEnd, selectedText));
      }
    } else {
      app.send(SelectionChange(-1, -1, ''));
    }
  });
}
/** TODO: research how to get all in-between nodes inside selection range
 *        including nodes between anchor and focus nodes and their children
 *        without recursively searching the dom tree
 */
// if (selection.rangeCount) {
//   const nodes = [];
//   for (let i = 0; i < selection.rangeCount; i++) {
//     const range = selection.getRangeAt(i);
//     let node: Node | null = range.startContainer;
//     while (node) {
//       nodes.push(node);
//       if (node === range.endContainer) break;
//       node = node.nextSibling;
//     }
//   }
//   // send selected nodes
// }


function Tabs(app) {
  function changeTab() {
    if (!document.hidden) {
      app.debug.log('Openreplay: tab change to' + app.session.getTabId());
      app.send(TabChange(app.session.getTabId()));
    }
  }

  app.attachEventListener(window, 'focus', changeTab, false, false);
}

var Messages = _Messages;
var DOCS_SETUP = '/installation/javascript-sdk';

function processOptions(obj) {
  if (obj == null) {
    console.error("OpenReplay: invalid options argument type. Please, check documentation on ".concat(DOCS_HOST).concat(DOCS_SETUP));
    return false;
  }

  if (typeof obj.projectKey !== 'string') {
    if (typeof obj.projectKey !== 'number') {
      if (typeof obj.projectID !== 'number') {
        // Back compatability
        console.error("OpenReplay: projectKey is missing or wrong type (string is expected). Please, check ".concat(DOCS_HOST).concat(DOCS_SETUP, " for more information."));
        return false;
      } else {
        obj.projectKey = obj.projectID.toString();
        deprecationWarn('`projectID` option', '`projectKey` option', DOCS_SETUP);
      }
    } else {
      console.warn('OpenReplay: projectKey is expected to have a string type.');
      obj.projectKey = obj.projectKey.toString();
    }
  }

  if (obj.sessionToken != null) {
    deprecationWarn('`sessionToken` option', '`sessionHash` start() option', '/');
  }

  return true;
}

var canAccessTop = function canAccessTop() {
  try {
    return Boolean(window.top);
  } catch (_unused3) {
    return false;
  }
};

var API = /*#__PURE__*/function () {
  function API(options) {
    var _this73 = this,
        _options$crossdomain2,
        _window$top;

    _classCallCheck(this, API);

    this.options = options;
    this.app = null;
    this.crossdomainMode = false;

    this.checkDoNotTrack = function () {
      return _this73.options.respectDoNotTrack && (navigator.doNotTrack == '1' || // @ts-ignore
      window.doNotTrack == '1');
    };

    this.signalStartIssue = function (reason, missingApi) {
      var doNotTrack = _this73.checkDoNotTrack();

      var req = new XMLHttpRequest();
      var orig = _this73.options.ingestPoint || DEFAULT_INGEST_POINT;
      req.open('POST', orig + '/v1/web/not-started');
      req.send(JSON.stringify({
        trackerVersion: '15.0.1',
        projectKey: _this73.options.projectKey,
        doNotTrack: doNotTrack,
        reason: missingApi.length ? "missing api: ".concat(missingApi.join(',')) : reason
      }));
    };

    this.restartCanvasTracking = function () {
      if (_this73.app === null) {
        return;
      }

      _this73.app.restartCanvasTracking();
    };

    this.handleError = function (e) {
      var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (_this73.app === null) {
        return;
      }

      if (e instanceof Error) {
        var msg = getExceptionMessage(e, [], metadata);

        _this73.app.send(msg);
      } else if (e instanceof ErrorEvent || 'PromiseRejectionEvent' in window && e instanceof PromiseRejectionEvent) {
        var _msg5 = getExceptionMessageFromEvent(e, undefined, metadata);

        if (_msg5 != null) {
          _this73.app.send(_msg5);
        }
      }
    };

    this.crossdomainMode = Boolean(inIframe() && ((_options$crossdomain2 = options.crossdomain) === null || _options$crossdomain2 === void 0 ? void 0 : _options$crossdomain2.enabled));

    if (!IN_BROWSER || !processOptions(options)) {
      return;
    }

    if (window.__OPENREPLAY__ || !this.crossdomainMode && inIframe() && canAccessTop() && (_window$top = window.top) !== null && _window$top !== void 0 && _window$top.__OPENREPLAY__) {
      console.error('OpenReplay: one tracker instance has been initialised already');
      return;
    }

    if (!options.__DISABLE_SECURE_MODE && location.protocol !== 'https:') {
      console.error('OpenReplay: Your website must be publicly accessible and running on SSL in order for OpenReplay to properly capture and replay the user session. You can disable this check by setting `__DISABLE_SECURE_MODE` option to `true` if you are testing in localhost. Keep in mind, that asset files on a local machine are not available to the outside world. This might affect tracking if you use css files.');
      return;
    }

    var doNotTrack = this.checkDoNotTrack();
    var failReason = [];
    var conditions = ['Map', 'Set', 'MutationObserver', 'performance', 'timing', 'startsWith', 'Blob', 'Worker'];

    if (doNotTrack) {
      failReason.push('doNotTrack');
    } else {
      var _iterator17 = _createForOfIteratorHelper(conditions),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var condition = _step17.value;

          if (condition === 'timing') {
            if ('performance' in window && !(condition in performance)) {
              failReason.push(condition);
              break;
            }
          } else if (condition === 'startsWith') {
            if (!(condition in String.prototype)) {
              failReason.push(condition);
              break;
            }
          } else {
            if (!(condition in window)) {
              failReason.push(condition);
              break;
            }
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }

    if (failReason.length > 0) {
      var missingApi = failReason.join(',');
      console.error("OpenReplay: browser doesn't support API required for tracking or doNotTrack is set to 1. Reason: ".concat(missingApi));
      this.signalStartIssue('missing_api', failReason);
      return;
    }

    var app = new App(options.projectKey, options.sessionToken, options, this.signalStartIssue, this.crossdomainMode);
    this.app = app;

    if (!this.crossdomainMode) {
      // no need to send iframe viewport data since its a node for us
      Viewport(app); // calculated in main window

      Connection(app); // while we can calculate it here, trying to compute it for all parts is hard

      Performance(app, options); // no tabs in iframes yet

      Tabs(app);
    }

    Mouse(app, options.mouse); // inside iframe, we ignore viewport scroll

    Scroll(app, this.crossdomainMode);
    CSSRules(app);
    ConstructedStyleSheets(app);
    Console(app, options);
    Exception(app, options);
    Img(app);
    Input(app, options);
    Timing(app, options);
    Focus(app);
    Fonts(app);
    Network(app, options.network);
    selection(app);
    window.__OPENREPLAY__ = this;

    if (options.flags && options.flags.onFlagsLoad) {
      this.onFlagsLoad(options.flags.onFlagsLoad);
    }

    var wOpen = window.open;

    if (options.autoResetOnWindowOpen || options.resetTabOnWindowOpen) {
      app.attachStartCallback(function () {
        var _app$sessionStorage;

        var tabId = app.getTabId();
        var sessStorage = (_app$sessionStorage = app.sessionStorage) !== null && _app$sessionStorage !== void 0 ? _app$sessionStorage : window.sessionStorage;

        window.open = function () {
          if (options.autoResetOnWindowOpen) {
            app.resetNextPageSession(true);
          }

          if (options.resetTabOnWindowOpen) {
            sessStorage.removeItem(options.session_tabid_key || '__openreplay_tabid');
          }

          app.resetNextPageSession(false);
          sessStorage.setItem(options.session_tabid_key || '__openreplay_tabid', tabId);

          for (var _len12 = arguments.length, args = new Array(_len12), _key13 = 0; _key13 < _len12; _key13++) {
            args[_key13] = arguments[_key13];
          }

          return wOpen.call.apply(wOpen, [window].concat(args));
        };
      });
      app.attachStopCallback(function () {
        window.open = wOpen;
      });
    }
  }

  _createClass(API, [{
    key: "isFlagEnabled",
    value: function isFlagEnabled(flagName) {
      return this.featureFlags.isFlagEnabled(flagName);
    }
  }, {
    key: "onFlagsLoad",
    value: function onFlagsLoad(callback) {
      var _this$app;

      (_this$app = this.app) === null || _this$app === void 0 ? void 0 : _this$app.featureFlags.onFlagsLoad(callback);
    }
  }, {
    key: "clearPersistFlags",
    value: function clearPersistFlags() {
      var _this$app2;

      (_this$app2 = this.app) === null || _this$app2 === void 0 ? void 0 : _this$app2.featureFlags.clearPersistFlags();
    }
  }, {
    key: "reloadFlags",
    value: function reloadFlags() {
      var _this$app3;

      return (_this$app3 = this.app) === null || _this$app3 === void 0 ? void 0 : _this$app3.featureFlags.reloadFlags();
    }
  }, {
    key: "getFeatureFlag",
    value: function getFeatureFlag(flagName) {
      var _this$app4;

      return (_this$app4 = this.app) === null || _this$app4 === void 0 ? void 0 : _this$app4.featureFlags.getFeatureFlag(flagName);
    }
  }, {
    key: "getAllFeatureFlags",
    value: function getAllFeatureFlags() {
      var _this$app5;

      return (_this$app5 = this.app) === null || _this$app5 === void 0 ? void 0 : _this$app5.featureFlags.flags;
    }
  }, {
    key: "use",
    value: function use(fn) {
      return fn(this.app, this.options);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      if (this.app === null) {
        return false;
      }

      return this.app.active();
    }
    /**
     * Creates a named hook that expects event name, data string and msg direction (up/down),
     * it will skip any message bigger than 5 mb or event name bigger than 255 symbols
     * msg direction is "down" (incoming) by default
     *
     * @returns {(msgType: string, data: string, dir: 'up' | 'down') => void}
     * */

  }, {
    key: "trackWs",
    value: function trackWs(channelName) {
      if (this.app === null) {
        return;
      }

      return this.app.trackWs(channelName);
    }
  }, {
    key: "start",
    value: function start(startOpts) {
      if (this.browserEnvCheck()) {
        if (this.app === null) {
          return Promise.reject("Browser doesn't support required api, or doNotTrack is active.");
        }

        return this.app.start(startOpts);
      } else {
        return Promise.reject('Trying to start not in browser.');
      }
    }
  }, {
    key: "browserEnvCheck",
    value: function browserEnvCheck() {
      if (!IN_BROWSER) {
        console.error("OpenReplay: you are trying to start Tracker on a node.js environment. If you want to use OpenReplay with SSR, please, use componentDidMount or useEffect API for placing the `tracker.start()` line. Check documentation on ".concat(DOCS_HOST).concat(DOCS_SETUP));
        return false;
      }

      return true;
    }
    /**
     * start buffering messages without starting the actual session, which gives user 30 seconds to "activate" and record
     * session by calling start() on conditional trigger and we will then send buffered batch, so it won't get lost
     * */

  }, {
    key: "coldStart",
    value: function coldStart(startOpts, conditional) {
      if (this.browserEnvCheck()) {
        if (this.app === null) {
          return Promise.reject('Tracker not initialized');
        }

        void this.app.coldStart(startOpts, conditional);
      } else {
        return Promise.reject('Trying to start not in browser.');
      }
    }
    /**
     * Starts offline session recording. Keep in mind that only user device time will be used for timestamps.
     * (no backend delay sync)
     *
     * @param {Object} startOpts - options for session start, same as .start()
     * @param {Function} onSessionSent - callback that will be called once session is fully sent
     * @returns methods to manipulate buffer:
     *
     * saveBuffer - to save it in localStorage
     *
     * getBuffer - returns current buffer
     *
     * setBuffer - replaces current buffer with given
     * */

  }, {
    key: "startOfflineRecording",
    value: function startOfflineRecording(startOpts, onSessionSent) {
      if (this.browserEnvCheck()) {
        if (this.app === null) {
          return Promise.reject('Tracker not initialized');
        }

        return this.app.offlineRecording(startOpts, onSessionSent);
      } else {
        return Promise.reject('Trying to start not in browser.');
      }
    }
    /**
     * Uploads the stored session buffer to backend
     * @returns promise that resolves once messages are loaded, it has to be awaited
     * so the session can be uploaded properly
     * @resolve - if messages were loaded into service worker successfully
     * @reject {string} - error message
     * */

  }, {
    key: "uploadOfflineRecording",
    value: function uploadOfflineRecording() {
      if (this.app === null) {
        return;
      }

      return this.app.uploadOfflineRecording();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.app === null) {
        return;
      }

      this.app.stop();
      return this.app.session.getSessionHash();
    }
  }, {
    key: "forceFlushBatch",
    value: function forceFlushBatch() {
      if (this.app === null) {
        return;
      }

      this.app.forceFlushBatch();
    }
  }, {
    key: "getSessionToken",
    value: function getSessionToken() {
      if (this.app === null) {
        return null;
      }

      return this.app.getSessionToken();
    }
  }, {
    key: "getSessionInfo",
    value: function getSessionInfo() {
      if (this.app === null) {
        return null;
      }

      return this.app.session.getInfo();
    }
  }, {
    key: "getSessionID",
    value: function getSessionID() {
      if (this.app === null) {
        return null;
      }

      return this.app.getSessionID();
    }
  }, {
    key: "getTabId",
    value: function getTabId() {
      if (this.app === null) {
        return null;
      }

      return this.app.getTabId();
    }
  }, {
    key: "getUxId",
    value: function getUxId() {
      if (this.app === null) {
        return null;
      }

      return this.app.getUxtId();
    }
  }, {
    key: "sessionID",
    value: function sessionID() {
      deprecationWarn("'sessionID' method", "'getSessionID' method", '/');
      return this.getSessionID();
    }
  }, {
    key: "getSessionURL",
    value: function getSessionURL(options) {
      if (this.app === null) {
        return undefined;
      }

      return this.app.getSessionURL(options);
    }
  }, {
    key: "setUserID",
    value: function setUserID(id) {
      if (typeof id === 'string' && this.app !== null) {
        this.app.session.setUserID(id);
      }
    }
  }, {
    key: "userID",
    value: function userID(id) {
      deprecationWarn("'userID' method", "'setUserID' method", '/');
      this.setUserID(id);
    }
  }, {
    key: "setUserAnonymousID",
    value: function setUserAnonymousID(id) {
      if (typeof id === 'string' && this.app !== null) {
        this.app.send(UserAnonymousID(id));
      }
    }
  }, {
    key: "userAnonymousID",
    value: function userAnonymousID(id) {
      deprecationWarn("'userAnonymousID' method", "'setUserAnonymousID' method", '/');
      this.setUserAnonymousID(id);
    }
  }, {
    key: "setMetadata",
    value: function setMetadata(key, value) {
      if (typeof key === 'string' && typeof value === 'string' && this.app !== null) {
        this.app.session.setMetadata(key, value);
      }
    }
  }, {
    key: "metadata",
    value: function metadata(key, value) {
      deprecationWarn("'metadata' method", "'setMetadata' method", '/');
      this.setMetadata(key, value);
    }
  }, {
    key: "event",
    value: function event(key) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var issue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof key === 'string' && this.app !== null) {
        if (issue) {
          return this.issue(key, payload);
        } else {
          try {
            payload = JSON.stringify(payload);
          } catch (e) {
            return;
          }

          this.app.send(CustomEvent(key, payload));
        }
      }
    }
  }, {
    key: "issue",
    value: function issue(key) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof key === 'string' && this.app !== null) {
        try {
          payload = JSON.stringify(payload);
        } catch (e) {
          return;
        }

        this.app.send(CustomIssue(key, payload));
      }
    }
  }]);

  return API;
}();

export { App, Messages, SanitizeLevel, API as default };